function Zt(e) {
  const {
    name: t,
    type: a,
    props: o = [],
    children: n = !1,
    forwardRef: s = !0,
    composedFrom: r = [],
    description: i = `${t} component`
  } = e, c = o.map((h) => {
    const f = h.required ? "" : "?";
    return `${h.description ? `  /** ${h.description} */
` : ""}  ${h.name}${f}: ${h.type};`;
  }).join(`
`), p = o.filter((h) => h.default).map((h) => `  ${h.name} = ${h.default},`).join(`
`), u = a === "atom" ? "../atoms" : a === "molecule" ? "../molecules" : "../organisms", l = r.length ? `import { ${r.join(", ")} } from '${u}';
` : "";
  return `"use client";

import React${s ? ", { forwardRef }" : ""} from 'react';
${l}import { cn } from '../../utils';

export interface ${t}Props {
${c}
${n ? `  children?: React.ReactNode;
` : ""}  className?: string;
}

/**
 * ${i}
 *
 * @example
 * \`\`\`tsx
 * <${t} />
 * \`\`\`
 */
export const ${t} = ${s ? `forwardRef<HTMLDivElement, ${t}Props>` : ""}(({
${p}
  className,
  ${n ? "children," : ""}
  ...props
}${s ? ", ref" : ""}) => {
  return (
    <div
      ${s ? "ref={ref}" : ""}
      className={cn(
        // Base styles
        '',
        className
      )}
      {...props}
    >
      ${n ? "{children}" : ""}
    </div>
  );
});

${t}.displayName = '${t}';
`;
}
function Xt(e) {
  const { name: t, fields: a } = e, o = a.map((r) => {
    var p;
    let i = "";
    const c = r.description ? `  // ${r.description}
` : "";
    switch (r.type) {
      case "string":
        i = "z.string()", r.min && (i += `.min(${r.min})`), r.max && (i += `.max(${r.max})`), r.pattern && (i += `.regex(/${r.pattern}/)`);
        break;
      case "email":
        i = "z.string().email()";
        break;
      case "url":
        i = "z.string().url()";
        break;
      case "uuid":
        i = "z.string().uuid()";
        break;
      case "number":
        i = "z.number()", r.min !== void 0 && (i += `.min(${r.min})`), r.max !== void 0 && (i += `.max(${r.max})`);
        break;
      case "boolean":
        i = "z.boolean()";
        break;
      case "date":
        i = "z.date()";
        break;
      case "enum":
        i = `z.enum([${((p = r.enumValues) == null ? void 0 : p.map((l) => `'${l}'`).join(", ")) || ""}])`;
        break;
      case "array":
        i = "z.array(z.unknown())";
        break;
      case "object":
        i = "z.object({})";
        break;
      default:
        i = "z.unknown()";
    }
    return r.required || (i += ".optional()"), `${c}  ${r.name}: ${i},`;
  }).join(`
`), n = t.replace("Schema", "");
  return `import { z } from 'zod';

export const ${t} = z.object({
${o}
});

export type ${n} = z.infer<typeof ${t}>;
`;
}
function ea(e) {
  const {
    componentName: t,
    componentPath: a,
    category: o,
    variants: n = [{ name: "Default" }],
    defaultArgs: s = {}
  } = e, r = n.map((c) => {
    const p = c.args ? `
  args: ${JSON.stringify(c.args, null, 4).replace(/\n/g, `
  `)},` : "", u = c.description ? `
  parameters: {
    docs: {
      description: {
        story: '${c.description}',
      },
    },
  },` : "";
    return `
export const ${c.name}: Story = {${p}${u}
};`;
  }).join(`
`);
  return `import type { Meta, StoryObj } from '@storybook/react';
import { ${t} } from '${a}';

const meta: Meta<typeof ${t}> = {
  title: '${o}/${t}',
  component: ${t},
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    // Add argTypes here
  },
  args: ${JSON.stringify(s, null, 4).replace(/\n/g, `
  `)},
};

export default meta;
type Story = StoryObj<typeof ${t}>;
${r}
`;
}
function ta(e) {
  const {
    name: t,
    pageType: a,
    entity: o = "Item",
    features: n = [],
    dataSource: s = "react-query"
  } = e, r = o.toLowerCase(), i = `${r}s`, c = ["Stack"];
  a === "list" ? (c.push("PageHeader", "Card", "DataTable", "Button"), n.includes("search") && c.push("Input"), n.includes("pagination") && c.push("Pagination"), n.includes("bulk-actions") && c.push("BulkActionBar")) : a === "detail" ? c.push("PageHeader", "Card", "Button", "Badge", "Tabs") : a === "form" ? c.push("Card", "Button", "TextField", "SelectField") : a === "dashboard" ? c.push("PageHeader", "Card", "Grid", "KpiCard") : a === "settings" ? c.push("PageHeader", "Card", "Tabs", "SettingsSection") : a === "error" && c.push("ErrorState"), c.push("LoadingState", "ErrorState", "EmptyState");
  const p = a === "list" || a === "detail";
  let u = `"use client";

import {
  ${[...new Set(c)].sort().join(`,
  `)},
} from '@org/design-system';
`, l = "", m = "";
  p && (s === "react-query" ? (u += `import { useQuery } from '@tanstack/react-query';
`, m = `
// TODO: Import or implement fetch${o}s function from your API layer
// import { fetch${o}s } from '@/features/${r}/api';
`, l = `
  const { data: ${i}, isLoading, error, refetch } = useQuery({
    queryKey: ['${i}'],
    queryFn: () => fetch${o}s(),
  });
`) : s === "swr" && (u += `import useSWR from 'swr';
`, m = `
// TODO: Implement fetcher function for your API
// const fetcher = (url: string) => fetch(url).then(r => r.json());
`, l = `
  const { data: ${i}, error, isLoading, mutate } = useSWR('/${i}', fetcher);
`));
  let g = "";
  switch (a) {
    case "list":
      g = `
      <Stack gap={6}>
        <PageHeader
          title="${o}s"
          description="Manage your ${i}"
          actions={[
            ${n.includes("create-button") ? `{ label: 'Create ${o}', onClick: () => {}, variant: 'primary' },` : ""}
          ]}
        />

        ${n.includes("search") ? `<Input placeholder="Search ${i}..." className="max-w-sm" />` : ""}

        <Card padding="none">
          <DataTable
            columns={[
              { key: 'name', header: 'Name', render: (item) => item.name },
              { key: 'status', header: 'Status', render: (item) => item.status },
              { key: 'createdAt', header: 'Created', render: (item) => item.createdAt },
            ]}
            data={${i} || []}
            keyExtractor={(item) => item.id}
          />
        </Card>

        ${n.includes("pagination") ? "<Pagination totalPages={10} currentPage={1} onPageChange={() => {}} />" : ""}
      </Stack>`;
      break;
    case "detail":
      g = `
      <Stack gap={6}>
        <PageHeader
          title="${o} Details"
          actions={[
            { label: 'Edit', onClick: () => {}, variant: 'secondary' },
            { label: 'Delete', onClick: () => {}, variant: 'danger' },
          ]}
        />

        <Tabs
          items={[
            { id: 'overview', label: 'Overview' },
            { id: 'activity', label: 'Activity' },
            { id: 'settings', label: 'Settings' },
          ]}
          defaultValue="overview"
        />

        <Card padding="lg">
          <p className="text-muted-foreground">${o} details content will be displayed here.</p>
        </Card>
      </Stack>`;
      break;
    case "form":
      g = `
      <Stack gap={6} className="max-w-2xl mx-auto">
        <PageHeader title="Create ${o}" />

        <Card padding="lg">
          <form onSubmit={handleSubmit} className="space-y-4">
            <TextField
              name="name"
              label="Name"
              placeholder="Enter ${r} name"
              required
            />

            <SelectField
              name="status"
              label="Status"
              options={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
              ]}
            />

            <Stack direction="horizontal" gap={2} justify="end">
              <Button type="button" variant="secondary">Cancel</Button>
              <Button type="submit" variant="primary">Save</Button>
            </Stack>
          </form>
        </Card>
      </Stack>`;
      break;
    case "dashboard":
      g = `
      <Stack gap={6}>
        <PageHeader
          title="Dashboard"
          description="Overview of your ${i}"
        />

        <Grid columns={4} gap={4}>
          <KpiCard
            title="Total ${o}s"
            metric="1,234"
            subtext="+12% from last month"
            trend="up"
          />
          <KpiCard
            title="Active"
            metric="987"
            subtext="+5% from last month"
            trend="up"
          />
          <KpiCard
            title="Pending"
            metric="156"
            subtext="No change"
            trend="neutral"
          />
          <KpiCard
            title="Completed"
            metric="91"
            subtext="-3% from last month"
            trend="down"
          />
        </Grid>

        <Card padding="lg">
          <p className="text-muted-foreground">Dashboard charts and additional content can be added here.</p>
        </Card>
      </Stack>`;
      break;
    case "settings":
      g = `
      <Stack gap={6}>
        <PageHeader title="Settings" />

        <Tabs
          items={[
            { id: 'general', label: 'General' },
            { id: 'notifications', label: 'Notifications' },
            { id: 'security', label: 'Security' },
          ]}
          defaultValue="general"
        />

        <SettingsSection
          title="General Settings"
          description="Manage your account settings"
        >
          <TextField name="name" label="Display Name" />
          <TextField name="email" label="Email" type="email" />
        </SettingsSection>
      </Stack>`;
      break;
    case "error":
      g = `
      <ErrorState
        title="Something went wrong"
        description="We encountered an error while loading this page."
        onRetry={() => window.location.reload()}
      />`;
      break;
    default:
      g = `
      <Stack gap={6}>
        <PageHeader title="${t}" />
        <Card padding="lg">
          <p className="text-muted-foreground">Page content will be displayed here.</p>
        </Card>
      </Stack>`;
  }
  let h = "";
  return p && (h = `
  if (isLoading) {
    return <LoadingState text="Loading ${i}..." />;
  }

  if (error) {
    return <ErrorState title="Failed to load" onRetry={refetch} />;
  }

  ${a === "list" ? `if (!${i}?.length) {
    return (
      <EmptyState
        title="No ${i} yet"
        description="Get started by creating your first ${r}."
        action={<Button>Create ${o}</Button>}
      />
    );
  }` : ""}`), `${u}${m}
export default function ${t}() {
${l}${h}

  return (
    <>
${g}
    </>
  );
}
`;
}
function be(e) {
  return e.split("-").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join("");
}
function Te(e) {
  const t = be(e);
  return t.charAt(0).toLowerCase() + t.slice(1);
}
function aa(e) {
  const {
    app: t,
    name: a,
    template: o = "blank",
    withRoute: n = !0,
    entity: s
  } = e, r = be(a), i = Te(a), c = s || r, p = c.toLowerCase(), u = `apps/${t}/src/features/${a}`, l = [];
  return l.push({
    path: `${u}/types/index.ts`,
    content: `/**
 * ${r} Feature Types
 */

export interface ${c} {
  id: string;
  name: string;
  status: '${p}_active' | '${p}_inactive';
  createdAt: string;
  updatedAt: string;
}

export interface ${c}ListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: ${c}['status'];
}

export interface ${c}CreateInput {
  name: string;
}

export interface ${c}UpdateInput {
  name?: string;
  status?: ${c}['status'];
}
`
  }), l.push({
    path: `${u}/api/index.ts`,
    content: `/**
 * ${r} Feature API
 */

import type { ${c}, ${c}ListParams, ${c}CreateInput, ${c}UpdateInput } from '../types';

const API_BASE = process.env.NEXT_PUBLIC_API_URL || '';

export async function get${c}s(params?: ${c}ListParams): Promise<${c}[]> {
  const searchParams = new URLSearchParams();
  if (params?.page) searchParams.set('page', String(params.page));
  if (params?.limit) searchParams.set('limit', String(params.limit));
  if (params?.search) searchParams.set('search', params.search);
  if (params?.status) searchParams.set('status', params.status);

  const response = await fetch(\`\${API_BASE}/${p}s?\${searchParams}\`);
  if (!response.ok) throw new Error('Failed to fetch ${p}s');
  return response.json();
}

export async function get${c}(id: string): Promise<${c}> {
  const response = await fetch(\`\${API_BASE}/${p}s/\${id}\`);
  if (!response.ok) throw new Error('Failed to fetch ${p}');
  return response.json();
}

export async function create${c}(input: ${c}CreateInput): Promise<${c}> {
  const response = await fetch(\`\${API_BASE}/${p}s\`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('Failed to create ${p}');
  return response.json();
}

export async function update${c}(id: string, input: ${c}UpdateInput): Promise<${c}> {
  const response = await fetch(\`\${API_BASE}/${p}s/\${id}\`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('Failed to update ${p}');
  return response.json();
}

export async function delete${c}(id: string): Promise<void> {
  const response = await fetch(\`\${API_BASE}/${p}s/\${id}\`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete ${p}');
}
`
  }), l.push({
    path: `${u}/hooks/index.ts`,
    content: `/**
 * ${r} Feature Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  get${c}s,
  get${c},
  create${c},
  update${c},
  delete${c},
} from '../api';
import type { ${c}ListParams, ${c}CreateInput, ${c}UpdateInput } from '../types';

export const ${i}Keys = {
  all: ['${p}s'] as const,
  lists: () => [...${i}Keys.all, 'list'] as const,
  list: (params?: ${c}ListParams) => [...${i}Keys.lists(), params] as const,
  details: () => [...${i}Keys.all, 'detail'] as const,
  detail: (id: string) => [...${i}Keys.details(), id] as const,
};

export function use${c}s(params?: ${c}ListParams) {
  return useQuery({
    queryKey: ${i}Keys.list(params),
    queryFn: () => get${c}s(params),
  });
}

export function use${c}(id: string) {
  return useQuery({
    queryKey: ${i}Keys.detail(id),
    queryFn: () => get${c}(id),
    enabled: !!id,
  });
}

export function useCreate${c}() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ${c}CreateInput) => create${c}(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ${i}Keys.lists() });
    },
  });
}

export function useUpdate${c}() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: ${c}UpdateInput }) =>
      update${c}(id, input),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ${i}Keys.detail(id) });
      queryClient.invalidateQueries({ queryKey: ${i}Keys.lists() });
    },
  });
}

export function useDelete${c}() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete${c}(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ${i}Keys.lists() });
    },
  });
}
`
  }), l.push({
    path: `${u}/components/index.ts`,
    content: `export * from './${r}List';
export * from './${r}Detail';
export * from './${r}Form';
`
  }), l.push({
    path: `${u}/components/${r}List.tsx`,
    content: `'use client';

import {
  Card,
  DataTable,
  PageHeader,
  Stack,
  Button,
  LoadingState,
  ErrorState,
  EmptyState,
} from '@org/design-system';
import { use${c}s } from '../hooks';

export function ${r}List() {
  const { data: ${p}s, isLoading, error, refetch } = use${c}s();

  if (isLoading) {
    return <LoadingState text="Loading ${p}s..." />;
  }

  if (error) {
    return <ErrorState title="Failed to load ${p}s" onRetry={refetch} />;
  }

  if (!${p}s?.length) {
    return (
      <EmptyState
        title="No ${p}s yet"
        description="Get started by creating your first ${p}."
        action={<Button>Create ${c}</Button>}
      />
    );
  }

  return (
    <Stack gap={6}>
      <PageHeader
        title="${c}s"
        actions={[{ label: 'Create ${c}', variant: 'primary', onClick: () => {} }]}
      />

      <Card padding="none">
        <DataTable
          columns={[
            { key: 'name', header: 'Name', render: (item) => item.name },
            { key: 'status', header: 'Status', render: (item) => item.status },
            { key: 'createdAt', header: 'Created', render: (item) => item.createdAt },
          ]}
          data={${p}s}
          keyExtractor={(item) => item.id}
        />
      </Card>
    </Stack>
  );
}
`
  }), l.push({
    path: `${u}/components/${r}Detail.tsx`,
    content: `'use client';

import {
  Card,
  PageHeader,
  Stack,
  Button,
  Badge,
  LoadingState,
  ErrorState,
} from '@org/design-system';
import { use${c} } from '../hooks';

interface ${r}DetailProps {
  id: string;
}

export function ${r}Detail({ id }: ${r}DetailProps) {
  const { data: ${p}, isLoading, error, refetch } = use${c}(id);

  if (isLoading) {
    return <LoadingState text="Loading ${p}..." />;
  }

  if (error) {
    return <ErrorState title="Failed to load ${p}" onRetry={refetch} />;
  }

  if (!${p}) {
    return <ErrorState title="${c} not found" />;
  }

  return (
    <Stack gap={6}>
      <PageHeader
        title={${p}.name}
        actions={[
          { label: 'Edit', variant: 'secondary', onClick: () => {} },
          { label: 'Delete', variant: 'danger', onClick: () => {} },
        ]}
      />

      <Card padding="lg">
        <Stack gap={4}>
          <div>
            <span className="text-muted-foreground text-sm">Status</span>
            <Badge variant={${p}.status === '${p}_active' ? 'green' : 'gray'}>
              {${p}.status}
            </Badge>
          </div>
          <div>
            <span className="text-muted-foreground text-sm">Created</span>
            <p>{new Date(${p}.createdAt).toLocaleDateString()}</p>
          </div>
        </Stack>
      </Card>
    </Stack>
  );
}
`
  }), l.push({
    path: `${u}/components/${r}Form.tsx`,
    content: `'use client';

import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  Card,
  PageHeader,
  Stack,
  Button,
  TextField,
} from '@org/design-system';
import { useCreate${c} } from '../hooks';

const ${p}Schema = z.object({
  name: z.string().min(1, 'Name is required'),
});

type ${c}FormValues = z.infer<typeof ${p}Schema>;

interface ${r}FormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function ${r}Form({ onSuccess, onCancel }: ${r}FormProps) {
  const create${c} = useCreate${c}();

  const form = useForm<${c}FormValues>({
    resolver: zodResolver(${p}Schema),
    defaultValues: {
      name: '',
    },
  });

  const onSubmit = async (values: ${c}FormValues) => {
    await create${c}.mutateAsync(values);
    onSuccess?.();
  };

  return (
    <Stack gap={6} className="max-w-2xl mx-auto">
      <PageHeader title="Create ${c}" />

      <Card padding="lg">
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Stack gap={4}>
            <TextField
              label="Name"
              placeholder="Enter ${p} name"
              error={form.formState.errors.name?.message}
              {...form.register('name')}
            />

            <Stack direction="horizontal" gap={2} justify="end">
              <Button type="button" variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                isLoading={create${c}.isPending}
              >
                Create ${c}
              </Button>
            </Stack>
          </Stack>
        </form>
      </Card>
    </Stack>
  );
}
`
  }), n && l.push({
    path: `${u}/routes/index.tsx`,
    content: `'use client';

export { ${r}List } from '../components/${r}List';
export { ${r}Detail } from '../components/${r}Detail';
export { ${r}Form } from '../components/${r}Form';
`
  }), {
    featureName: a,
    app: t,
    template: o,
    files: l,
    instructions: [
      `1. Create directories: mkdir -p ${u}/{types,api,hooks,components${n ? ",routes" : ""}}`,
      '2. Write each file from the "files" array to its corresponding path',
      "3. Add the feature export to your app's features/index.ts",
      "4. Add route handlers in your app router if using Next.js App Router",
      "5. Update your API client to include the new endpoints"
    ]
  };
}
function ra(e) {
  const {
    appName: t,
    appTitle: a,
    appDescription: o = `${a} - Built with @org/design-system`,
    presetId: n = "saas-executive-premium",
    defaultTheme: s = "light",
    features: r = [],
    fonts: i = { sans: "Inter" },
    apiUrl: c
  } = e, p = r.includes("auth"), u = r.includes("react-query"), l = `@import "tailwindcss";

/* Import pre-bundled design system CSS (includes Tailwind utilities + theme) */
@import "@org/design-system/bundle-all-themes.css";

/* Additional base styles */
@layer base {
  * {
    border-color: hsl(var(--ds-border));
  }

  body {
    background-color: hsl(var(--ds-background));
    color: hsl(var(--ds-foreground));
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px hsl(var(--ds-ring)), 0 0 0 4px hsl(var(--ds-background));
}
`, m = [
    "/* eslint-disable no-restricted-imports -- design-system subpaths are approved */",
    "'use client';",
    "",
    u ? "import { QueryClient, QueryClientProvider } from '@tanstack/react-query';" : null,
    "import { PresetProvider, ThemeProvider } from '@org/design-system/theme';",
    "import { Toaster } from '@org/design-system';",
    u ? "import { useState, type ReactNode } from 'react';" : "import type { ReactNode } from 'react';",
    p ? "import { AuthProvider } from '@/lib/auth-context';" : null
  ].filter(Boolean).join(`
`), g = u ? `export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme={{ mode: '${s}' }}>
        <PresetProvider presetId="${n}">
${p ? "          <AuthProvider>" : ""}
            {children}
            <Toaster />
${p ? "          </AuthProvider>" : ""}
        </PresetProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}` : `export function Providers({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider defaultTheme={{ mode: '${s}' }}>
      <PresetProvider presetId="${n}">
${p ? "        <AuthProvider>" : ""}
          {children}
          <Toaster />
${p ? "        </AuthProvider>" : ""}
      </PresetProvider>
    </ThemeProvider>
  );
}`, h = `${m}

${g}
`, f = [], b = [], y = [];
  if (i.sans) {
    const E = i.sans.replace(/ /g, "_");
    f.push(`import { ${E} } from 'next/font/google';`), b.push(`const ${i.sans.toLowerCase().replace(/[_ ]/g, "")} = ${E}({
  subsets: ['latin'],
  variable: '--font-sans',
});`), y.push(`\${${i.sans.toLowerCase().replace(/[_ ]/g, "")}.variable}`);
  }
  if (i.display) {
    const E = i.display.replace(/ /g, "_");
    f.push(`import { ${E} } from 'next/font/google';`), b.push(`const ${i.display.toLowerCase().replace(/[_ ]/g, "")} = ${E}({
  subsets: ['latin'],
  variable: '--font-display',
});`), y.push(`\${${i.display.toLowerCase().replace(/[_ ]/g, "")}.variable}`);
  }
  const $ = `import type { Metadata } from 'next';
${f.join(`
`)}
import { Providers } from './providers';
import './globals.css';
// ThemeProvider is in providers.tsx (client component)
// Theme CSS variables are imported within globals.css via @org/design-system/theme.css

${b.join(`

`)}

export const metadata: Metadata = {
  metadataBase: new URL(process.env.NEXT_PUBLIC_APP_URL || 'https://${t}.com'),
  title: {
    default: '${a}',
    template: '%s | ${a}',
  },
  description: '${o}',
  openGraph: {
    type: 'website',
    locale: 'en_US',
    siteName: '${a}',
  },
  twitter: {
    card: 'summary_large_image',
  },
  robots: {
    index: true,
    follow: true,
  },
};

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en" className={\`${y.join(" ")}\`}>
      <body className="min-h-screen bg-background font-sans antialiased">
        <Providers>{children}</Providers>
      </body>
    </html>
  );
}
`, C = p ? `'use client';

import { createContext, useContext, useState, type ReactNode } from 'react';

interface User {
  id: string;
  email: string;
  name: string;
}

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const login = async (email: string, password: string) => {
    setIsLoading(true);
    try {
      // TODO: Implement actual login logic
      setUser({ id: '1', email, name: 'User' });
    } finally {
      setIsLoading(false);
    }
  };

  const logout = async () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
` : null, P = `{
  "name": "@org/${t}",
  "version": "0.0.1",
  "private": true,
  "scripts": {
    "dev": "next dev",
    "build": "next build",
    "start": "next start",
    "lint": "next lint"
  },
  "dependencies": {
    "@org/design-system": "workspace:*",
    "@tanstack/react-query": "^5.62.0",
    "next": "15.1.0",
    "react": "^19.0.0",
    "react-dom": "^19.0.0",
    "react-hook-form": "^7.54.0",
    "zod": "^3.24.0"
  },
  "devDependencies": {
    "@types/node": "^22.0.0",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "typescript": "^5.7.0"
  }
}
`, I = `{
  "compilerOptions": {
    "target": "ES2017",
    "lib": ["dom", "dom.iterable", "esnext"],
    "allowJs": true,
    "skipLibCheck": true,
    "strict": true,
    "noEmit": true,
    "esModuleInterop": true,
    "module": "esnext",
    "moduleResolution": "bundler",
    "resolveJsonModule": true,
    "isolatedModules": true,
    "jsx": "preserve",
    "incremental": true,
    "plugins": [{ "name": "next" }],
    "paths": {
      "@/*": ["./src/*"]
    }
  },
  "include": ["next-env.d.ts", "**/*.ts", "**/*.tsx", ".next/types/**/*.ts"],
  "exclude": ["node_modules"]
}
`, S = `import type { NextConfig } from 'next';

const nextConfig: NextConfig = {
  transpilePackages: ['@org/design-system'],
  images: {
    remotePatterns: [
      {
        protocol: 'https',
        hostname: '*.workers.dev',
      },
    ],
  },
};

export default nextConfig;
`, d = `import type { Config } from 'tailwindcss';
import sharedConfig from '@org/design-system/tailwind.config';

const config: Config = {
  presets: [sharedConfig],
  content: [
    './src/**/*.{js,ts,jsx,tsx,mdx}',
    '../../packages/design-system/src/**/*.{js,ts,jsx,tsx}',
  ],
};

export default config;
`, k = `module.exports = {
  plugins: {
    '@tailwindcss/postcss': {},
    autoprefixer: {},
  },
};
`, w = `/// <reference types="next" />
/// <reference types="next/image-types/global" />

// NOTE: This file should not be edited
// see https://nextjs.org/docs/app/api-reference/config/typescript for more information.
`, x = `# Dependencies
node_modules
.pnpm-debug.log

# Next.js
.next
out

# Production
build

# Environment
.env*.local

# IDEs
.idea
.vscode
*.swp
*.swo

# OS
.DS_Store
Thumbs.db

# Logs
*.log
`, v = c ? `NEXT_PUBLIC_API_URL=${c}
NEXT_PUBLIC_APP_URL=http://localhost:3000
` : null, A = {
    "src/app/globals.css": l,
    "src/app/providers.tsx": h,
    "src/app/layout.tsx": $,
    "package.json": P,
    "tsconfig.json": I,
    "next.config.ts": S,
    "tailwind.config.ts": d,
    "postcss.config.js": k,
    "next-env.d.ts": w,
    ".gitignore": x
  };
  return v && (A[".env.local"] = v), C && (A["src/lib/auth-context.tsx"] = C), {
    description: `Complete Next.js app scaffold for "${a}" with design system integration`,
    presetId: n,
    defaultTheme: s,
    features: r,
    files: A,
    instructions: [
      "1. All files have been generated - run 'pnpm install' to install dependencies",
      "2. Run 'pnpm dev' to start the development server"
    ],
    critical: [
      "NEVER add hardcoded CSS variables like --primary, --background to globals.css",
      "ALWAYS use --ds- prefixed variables from @org/design-system/theme.css",
      "ThemeProvider MUST be in a client component (providers.tsx), not in layout.tsx",
      "PresetProvider controls the design tokens - change presetId to switch themes"
    ]
  };
}
const Ae = "2.0.0", Ee = { lastUpdated: "2026-01-25", totalComponents: 165 }, De = { atoms: "Basic building blocks - buttons, inputs, typography", molecules: "Combinations of atoms - form fields, alerts, tabs", organisms: "Complex UI sections - headers, cards with rich content", primitives: "Layout and low-level UI primitives", patterns: "Domain-specific, reusable UI patterns", content: "Rich content rendering components", motion: "Animation and transition components", intents: "Intent-based components organized by user goals for SaaS applications" }, _e = /* @__PURE__ */ JSON.parse(`{"Avatar":{"name":"Avatar","path":"src/components/atoms/Avatar.tsx","category":"atoms","description":"User or entity representation with image, initials fallback, and status indicator.","capabilities":["display_user","show_status","show_initials"],"props":{"src":{"type":"string","description":"Image source URL"},"alt":{"type":"string","description":"Alt text for accessibility"},"fallback":{"type":"string","description":"Initials when no image available"},"size":{"type":"enum","values":["xs","sm","md","lg","xl","2xl"],"default":"md"},"shape":{"type":"enum","values":["circle","square"],"default":"circle"},"status":{"type":"enum","values":["online","offline","away","busy"],"description":"Status indicator dot"}},"propMetadata":{"defaultPropSets":[{"name":"User Avatar","props":{"size":"md","shape":"circle"}},{"name":"Team Member","props":{"size":"lg","shape":"circle","status":"online"}}],"contextualHints":{"fallback":"Use 2-letter initials (e.g., 'JD' for John Doe)","status":"Use for real-time presence indicators in chat/collaboration apps"}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"Badge":{"name":"Badge","path":"src/components/atoms/Badge.tsx","category":"atoms","description":"Small status indicator or label for categorization and status display.","capabilities":["display_status","label_category","show_count"],"props":{"variant":{"type":"enum","values":["gray","red","green","blue","yellow","purple","orange"],"default":"gray"},"size":{"type":"enum","values":["sm","md","lg"],"default":"md"}},"propMetadata":{"defaultPropSets":[{"name":"Neutral","props":{"variant":"gray"}},{"name":"Success","props":{"variant":"green"}},{"name":"Error","props":{"variant":"red"}},{"name":"Warning","props":{"variant":"yellow"}}],"contextualHints":{"variant":"green=success, red=error/critical, yellow=warning, blue=info, purple=special"}},"suitability":{"mobile":1,"desktop":1}},"Button":{"name":"Button","path":"src/components/atoms/Button.tsx","category":"atoms","description":"Primary interactive element for triggering actions, form submissions, and navigation.","capabilities":["trigger_action","navigation","submit","toggle"],"props":{"variant":{"type":"enum","values":["primary","secondary","outline","ghost","danger"],"default":"primary"},"size":{"type":"enum","values":["sm","md","lg"],"default":"md"},"isLoading":{"type":"boolean","default":false,"description":"Shows spinner and disables interaction"},"disabled":{"type":"boolean","default":false},"leftIcon":{"type":"node","description":"Icon before label"},"rightIcon":{"type":"node","description":"Icon after label"},"pressable":{"type":"boolean","description":"Enable press/scale micro-interaction"},"pill":{"type":"boolean","description":"Fully rounded button shape"},"as":{"type":"elementType","description":"Polymorphic - render as link or other element"}},"propMetadata":{"defaultPropSets":[{"name":"Primary Action","props":{"variant":"primary","size":"md"}},{"name":"Secondary Action","props":{"variant":"secondary","size":"md"}},{"name":"Destructive","props":{"variant":"danger","size":"md"}},{"name":"Icon Button","props":{"variant":"ghost","size":"sm"}}],"contextualHints":{"isLoading":"Use during async operations like form submission","variant":"ghost for low-priority actions, danger for destructive actions","leftIcon":"Preferred for directional context (Back, Previous)"}},"constraints":{"labelLength":{"max":30,"recommended":15}},"suitability":{"mobile":1,"desktop":1,"accessibility":1}},"Card":{"name":"Card","path":"src/components/atoms/Card.tsx","category":"atoms","description":"Generic container with optional header, footer, and visual styling.","capabilities":["contain_content","group_related","surface_elevation"],"props":{"variant":{"type":"enum","values":["default","bordered","elevated","ghost"],"default":"default"},"padding":{"type":"enum","values":["none","sm","md","lg"],"default":"md"},"interactive":{"type":"boolean","description":"Add hover effects for clickable cards"}},"propMetadata":{"defaultPropSets":[{"name":"Content Card","props":{"variant":"default","padding":"md"}},{"name":"Clickable Card","props":{"variant":"elevated","interactive":true}}]},"suitability":{"mobile":1,"desktop":1}},"Checkbox":{"name":"Checkbox","path":"src/components/atoms/Checkbox.tsx","category":"atoms","description":"Boolean input for selecting options or agreeing to terms.","capabilities":["toggle_selection","multi_select"],"props":{"checked":{"type":"boolean"},"indeterminate":{"type":"boolean","description":"Partial selection state"},"disabled":{"type":"boolean"},"label":{"type":"string"}},"suitability":{"mobile":0.9,"desktop":1,"touch":0.8}},"FilterChip":{"name":"FilterChip","path":"src/components/atoms/FilterChip.tsx","category":"atoms","description":"Compact, interactive filter tag for faceted search and filtering.","capabilities":["filter","toggle","remove"],"props":{"selected":{"type":"boolean"},"onRemove":{"type":"function"},"variant":{"type":"enum","values":["default","outline"],"default":"default"}},"suitability":{"mobile":1,"desktop":1}},"Input":{"name":"Input","path":"src/components/atoms/Input.tsx","category":"atoms","description":"Text input field with variants for different contexts (forms, search bars).","capabilities":["text_input","search","password"],"props":{"variant":{"type":"enum","values":["default","glass","filled"],"default":"default"},"hasError":{"type":"boolean"},"expandOnFocus":{"type":"boolean","description":"Expand animation for search bars"},"leftElement":{"type":"node","description":"Icon or element on left"},"rightElement":{"type":"node","description":"Icon or element on right"},"placeholder":{"type":"string"},"type":{"type":"string","default":"text"}},"propMetadata":{"defaultPropSets":[{"name":"Form Input","props":{"variant":"default"}},{"name":"Search Bar","props":{"variant":"glass","expandOnFocus":true}}],"contextualHints":{"variant":"glass for modern search bars, filled for dense forms","leftElement":"Common: search icon, user icon"}},"suitability":{"mobile":1,"desktop":1}},"Progress":{"name":"Progress","path":"src/components/atoms/Progress.tsx","category":"atoms","description":"Visual progress indicator for loading states and completion tracking.","capabilities":["show_progress","loading_indicator"],"props":{"value":{"type":"number","description":"Progress percentage 0-100"},"variant":{"type":"enum","values":["default","success","warning","danger"]},"size":{"type":"enum","values":["sm","md","lg"],"default":"md"},"showLabel":{"type":"boolean"}},"suitability":{"mobile":1,"desktop":1}},"Skeleton":{"name":"Skeleton","path":"src/components/atoms/Skeleton.tsx","category":"atoms","description":"Loading placeholder that mimics content shape during data fetching.","capabilities":["loading_placeholder","content_preview"],"props":{"variant":{"type":"enum","values":["text","circular","rectangular"],"default":"text"},"width":{"type":"string|number"},"height":{"type":"string|number"},"animation":{"type":"enum","values":["pulse","wave","none"],"default":"pulse"}},"suitability":{"mobile":1,"desktop":1}},"Spinner":{"name":"Spinner","path":"src/components/atoms/Spinner.tsx","category":"atoms","description":"Animated loading indicator for async operations.","capabilities":["loading_indicator"],"props":{"size":{"type":"enum","values":["sm","md","lg"],"default":"md"},"color":{"type":"string","description":"Color override"}},"suitability":{"mobile":1,"desktop":1}},"Typography":{"name":"Typography","path":"src/components/atoms/Typography.tsx","category":"atoms","description":"Semantic text rendering with consistent styling for headings, body, and captions.","capabilities":["render_text","semantic_headings"],"props":{"variant":{"type":"enum","values":["h1","h2","h3","h4","h5","h6","body","body-sm","caption","overline"],"default":"body"},"as":{"type":"elementType","description":"Override rendered element"},"color":{"type":"string"},"weight":{"type":"enum","values":["normal","medium","semibold","bold"]},"align":{"type":"enum","values":["left","center","right"]}},"suitability":{"mobile":1,"desktop":1,"accessibility":1}},"Alert":{"name":"Alert","path":"src/components/molecules/Alert.tsx","category":"molecules","description":"Callout box for displaying important messages, warnings, or errors.","capabilities":["notify_user","display_message","show_warning"],"props":{"variant":{"type":"enum","values":["info","success","warning","error"],"default":"info"},"title":{"type":"string","required":true},"description":{"type":"node"},"dismissible":{"type":"boolean"},"onDismiss":{"type":"function"},"icon":{"type":"node"}},"propMetadata":{"defaultPropSets":[{"name":"Info Alert","props":{"variant":"info","title":"Note"}},{"name":"Error Alert","props":{"variant":"error","title":"Error"}},{"name":"Success Alert","props":{"variant":"success","title":"Success"}}],"requiredProps":["title"]},"suitability":{"mobile":0.9,"desktop":1}},"Banner":{"name":"Banner","path":"src/components/molecules/Banner.tsx","category":"molecules","description":"Full-width notification banner for announcements and promotions.","capabilities":["announce","promote","alert"],"props":{"variant":{"type":"enum","values":["info","warning","success","promo"]},"dismissible":{"type":"boolean"},"action":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"Breadcrumbs":{"name":"Breadcrumbs","path":"src/components/molecules/Breadcrumbs.tsx","category":"molecules","description":"Navigation trail showing current location in hierarchy.","capabilities":["navigation","show_hierarchy","wayfinding"],"props":{"items":{"type":"array","description":"Array of { label, href }"},"separator":{"type":"node","default":"/"},"maxItems":{"type":"number","description":"Collapse middle items if exceeded"}},"suitability":{"mobile":0.7,"desktop":1}},"ErrorSummary":{"name":"ErrorSummary","path":"src/components/molecules/ErrorSummary.tsx","category":"molecules","description":"Aggregated display of form validation errors.","capabilities":["show_errors","form_validation"],"props":{"errors":{"type":"array","description":"Array of error messages"},"title":{"type":"string","default":"Please fix the following errors:"}},"suitability":{"mobile":1,"desktop":1,"accessibility":1}},"FieldMessage":{"name":"FieldMessage","path":"src/components/molecules/FieldMessage.tsx","category":"molecules","description":"Helper or error text displayed below form inputs.","capabilities":["show_error","show_hint"],"props":{"variant":{"type":"enum","values":["default","error","success"]},"children":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"FormField":{"name":"FormField","path":"src/components/molecules/FormField.tsx","category":"molecules","description":"Compound component combining Label, Input, and FieldMessage.","capabilities":["form_input","validation_display"],"props":{"label":{"type":"string","required":true},"error":{"type":"string"},"hint":{"type":"string"},"required":{"type":"boolean"}},"suitability":{"mobile":1,"desktop":1}},"HelperText":{"name":"HelperText","path":"src/components/molecules/HelperText.tsx","category":"molecules","description":"Descriptive text providing additional context for form inputs.","capabilities":["provide_context","show_hint"],"props":{"children":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"Label":{"name":"Label","path":"src/components/molecules/Label.tsx","category":"molecules","description":"Accessible form label with required indicator support.","capabilities":["label_input","accessibility"],"props":{"htmlFor":{"type":"string","required":true},"required":{"type":"boolean"}},"suitability":{"mobile":1,"desktop":1,"accessibility":1}},"Tabs":{"name":"Tabs","path":"src/components/molecules/Tabs.tsx","category":"molecules","description":"Tabbed content navigation for organizing related content.","capabilities":["tab_navigation","content_organization"],"props":{"defaultValue":{"type":"string"},"value":{"type":"string"},"onValueChange":{"type":"function"},"orientation":{"type":"enum","values":["horizontal","vertical"],"default":"horizontal"}},"suitability":{"mobile":0.8,"desktop":1}},"ContentCard":{"name":"ContentCard","path":"src/components/organisms/ContentCard.tsx","category":"organisms","description":"Rich content card with image, title, description, and actions.","capabilities":["display_content","show_preview","link_to_detail"],"props":{"title":{"type":"string","required":true},"description":{"type":"string"},"image":{"type":"string"},"badge":{"type":"string"},"actions":{"type":"array"},"href":{"type":"string"}},"suitability":{"mobile":1,"desktop":1}},"Header":{"name":"Header","path":"src/components/organisms/Header.tsx","category":"organisms","description":"Application header with logo, navigation, and user menu.","capabilities":["navigation","branding","user_menu"],"props":{"logo":{"type":"node"},"navigation":{"type":"array"},"userMenu":{"type":"node"},"actions":{"type":"node"}},"suitability":{"mobile":0.8,"desktop":1}},"MediaCard":{"name":"MediaCard","path":"src/components/organisms/MediaCard.tsx","category":"organisms","description":"Card optimized for media content with badges and overlay actions.","capabilities":["display_media","show_badges","overlay_actions"],"props":{"src":{"type":"string","required":true},"alt":{"type":"string"},"title":{"type":"string"},"badges":{"type":"array"},"actions":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"NotificationCenter":{"name":"NotificationCenter","path":"src/components/intents/NotificationCenter.tsx","category":"intents","description":"Intent: 'I want to view and manage my notifications' - Full notification management panel with categories, bulk actions, and real-time updates.","capabilities":["notification_list","bulk_actions","mark_read","filter_notifications","notification_settings"],"props":{"notifications":{"type":"array","required":true,"description":"Array of notification objects"},"onMarkAsRead":{"type":"function","description":"Handler for marking notifications as read"},"onMarkAllAsRead":{"type":"function","description":"Handler for marking all notifications as read"},"onDelete":{"type":"function","description":"Handler for deleting notifications"},"onAction":{"type":"function","description":"Handler for notification actions"},"categories":{"type":"array","description":"Filter categories"},"showCategories":{"type":"boolean","default":true},"showSearch":{"type":"boolean","default":true},"maxHeight":{"type":"string","default":"500px"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"Container":{"name":"Container","path":"src/components/primitives/Container.tsx","category":"primitives","description":"Responsive max-width container for page content.","capabilities":["contain_width","center_content"],"props":{"size":{"type":"enum","values":["sm","md","lg","xl","full"],"default":"lg"}},"suitability":{"mobile":1,"desktop":1}},"Grid":{"name":"Grid","path":"src/components/primitives/Grid.tsx","category":"primitives","description":"CSS Grid layout with responsive column support.","capabilities":["grid_layout","responsive_columns"],"props":{"columns":{"type":"number|object","description":"Columns or { mobile, tablet, desktop }"},"gap":{"type":"enum","values":["xs","sm","md","lg","xl"],"default":"md"}},"suitability":{"mobile":1,"desktop":1}},"Stack":{"name":"Stack","path":"src/components/primitives/Stack.tsx","category":"primitives","description":"Flexbox stack layout for vertical or horizontal arrangement.","capabilities":["flex_layout","spacing"],"props":{"direction":{"type":"enum","values":["row","column"],"default":"column"},"gap":{"type":"enum","values":["xs","sm","md","lg","xl"],"default":"md"},"align":{"type":"enum","values":["start","center","end","stretch"]},"justify":{"type":"enum","values":["start","center","end","between","around"]}},"suitability":{"mobile":1,"desktop":1}},"Inline":{"name":"Inline","path":"src/components/primitives/Inline.tsx","category":"primitives","description":"Inline element wrapper with consistent spacing.","capabilities":["inline_layout","spacing"],"props":{"gap":{"type":"enum","values":["xs","sm","md","lg"],"default":"sm"}},"suitability":{"mobile":1,"desktop":1}},"Dialog":{"name":"Dialog","path":"src/components/patterns/Dialog.tsx","category":"patterns","description":"Modal dialog for focused interactions and confirmations.","capabilities":["modal","focus_trap","confirmation"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"},"title":{"type":"string"},"description":{"type":"string"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":1}},"Drawer":{"name":"Drawer","path":"src/components/patterns/Drawer.tsx","category":"patterns","description":"Slide-out panel for secondary content and forms.","capabilities":["slide_panel","secondary_content"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"},"side":{"type":"enum","values":["left","right","top","bottom"],"default":"right"},"size":{"type":"enum","values":["sm","md","lg","xl","full"]}},"suitability":{"mobile":0.9,"desktop":1}},"DataTable":{"name":"DataTable","path":"src/components/patterns/DataTable.tsx","category":"patterns","description":"Full-featured data table with sorting, filtering, pagination, and column management.","capabilities":["display_data","sort","filter","paginate","select_rows","column_visibility"],"props":{"data":{"type":"array","required":true},"columns":{"type":"array","required":true},"pagination":{"type":"object"},"toolbar":{"type":"object"},"bulkActions":{"type":"node"},"showColumnVisibility":{"type":"boolean"},"savedViews":{"type":"object"}},"propMetadata":{"defaultPropSets":[{"name":"Basic Table","props":{}},{"name":"With Pagination","props":{"pagination":{"pageSize":10}}}]},"suitability":{"mobile":0.6,"desktop":1}},"DataGrid":{"name":"DataGrid","path":"src/components/patterns/DataGrid.tsx","category":"patterns","description":"Virtualized grid for large datasets with high performance.","capabilities":["virtualized_list","large_datasets","high_performance"],"props":{"data":{"type":"array","required":true},"columns":{"type":"array","required":true},"rowHeight":{"type":"number","default":40}},"suitability":{"mobile":0.5,"desktop":1}},"EmptyState":{"name":"EmptyState","path":"src/components/intents/EmptyState.tsx","category":"intents","description":"Intent: 'There's nothing here yet, help me get started' - Contextual empty state with presets and actions.","capabilities":["empty_display","call_to_action","helpful_guidance","preset_states"],"props":{"preset":{"type":"enum","values":["no-data","no-results","no-projects","no-team","no-notifications","error","custom"],"default":"custom"},"icon":{"type":"node","description":"Custom icon"},"title":{"type":"string","description":"Empty state title"},"description":{"type":"string","description":"Empty state description"},"action":{"type":"object","description":"Primary action button"},"secondaryAction":{"type":"object","description":"Secondary action"},"size":{"type":"enum","values":["sm","md","lg"],"default":"md"},"bordered":{"type":"boolean","default":false}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"ErrorState":{"name":"ErrorState","path":"src/components/patterns/ErrorState.tsx","category":"patterns","description":"Error display with retry action and customizable messaging.","capabilities":["error_display","retry_action"],"props":{"title":{"type":"string"},"description":{"type":"string"},"onRetry":{"type":"function"},"illustration":{"type":"enum","values":["empty","error"]}},"suitability":{"mobile":1,"desktop":1}},"ComponentErrorBoundary":{"name":"ComponentErrorBoundary","path":"src/components/patterns/ComponentErrorBoundary.tsx","category":"patterns","description":"React error boundary for catching and displaying component errors gracefully.","capabilities":["error_catching","graceful_degradation","retry"],"props":{"fallback":{"type":"node|function","description":"Static or render prop fallback UI"},"onError":{"type":"function","description":"Callback when error is caught"},"onReset":{"type":"function"},"errorTitle":{"type":"string"},"errorDescription":{"type":"string"},"showRetry":{"type":"boolean","default":true},"isolate":{"type":"boolean","description":"Prevent error propagation"}},"suitability":{"mobile":1,"desktop":1}},"LoadingState":{"name":"LoadingState","path":"src/components/patterns/LoadingState.tsx","category":"patterns","description":"Loading placeholder UI for async content.","capabilities":["loading_display","skeleton"],"props":{"variant":{"type":"enum","values":["spinner","skeleton","dots"]},"text":{"type":"string"}},"suitability":{"mobile":1,"desktop":1}},"Pagination":{"name":"Pagination","path":"src/components/patterns/Pagination.tsx","category":"patterns","description":"Navigation controls for paginated data.","capabilities":["page_navigation","page_size_selection"],"props":{"currentPage":{"type":"number","required":true},"totalPages":{"type":"number","required":true},"onPageChange":{"type":"function","required":true},"pageSize":{"type":"number"},"onPageSizeChange":{"type":"function"},"pageSizeOptions":{"type":"array"}},"suitability":{"mobile":0.8,"desktop":1}},"PageHeader":{"name":"PageHeader","path":"src/components/patterns/PageHeader.tsx","category":"patterns","description":"Standard page header with title, description, and actions.","capabilities":["page_title","page_actions","breadcrumb_integration"],"props":{"title":{"type":"string","required":true},"description":{"type":"string"},"actions":{"type":"node"},"breadcrumbs":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"Sidebar":{"name":"Sidebar","path":"src/components/patterns/Sidebar.tsx","category":"patterns","description":"Navigation sidebar with collapsible sections.","capabilities":["navigation","collapsible","nested_menu"],"props":{"items":{"type":"array","required":true},"collapsed":{"type":"boolean"},"onCollapse":{"type":"function"}},"suitability":{"mobile":0.6,"desktop":1}},"Toast":{"name":"Toast","path":"src/components/patterns/Toast.tsx","category":"patterns","description":"Temporary notification message.","capabilities":["notification","auto_dismiss","action"],"props":{"variant":{"type":"enum","values":["default","success","error","warning"]},"title":{"type":"string"},"description":{"type":"string"},"action":{"type":"node"},"duration":{"type":"number","default":5000}},"suitability":{"mobile":1,"desktop":1}},"Combobox":{"name":"Combobox","path":"src/components/patterns/Combobox.tsx","category":"patterns","description":"Searchable dropdown with autocomplete.","capabilities":["search","autocomplete","select"],"props":{"options":{"type":"array","required":true},"value":{"type":"string"},"onValueChange":{"type":"function"},"placeholder":{"type":"string"},"searchPlaceholder":{"type":"string"}},"suitability":{"mobile":0.8,"desktop":1}},"CommandPalette":{"name":"CommandPalette","path":"src/components/patterns/CommandPalette.tsx","category":"patterns","description":"Keyboard-driven command interface (Cmd+K style).","capabilities":["command_search","keyboard_navigation","quick_actions"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"},"commands":{"type":"array"}},"suitability":{"mobile":0.4,"desktop":1}},"DatePicker":{"name":"DatePicker","path":"src/components/patterns/DatePicker.tsx","category":"patterns","description":"Calendar-based date selection.","capabilities":["date_selection","range_selection","calendar"],"props":{"value":{"type":"Date"},"onChange":{"type":"function"},"mode":{"type":"enum","values":["single","range","multiple"]},"minDate":{"type":"Date"},"maxDate":{"type":"Date"}},"suitability":{"mobile":0.8,"desktop":1}},"FileUploader":{"name":"FileUploader","path":"src/components/patterns/FileUploader.tsx","category":"patterns","description":"Drag-and-drop file upload interface.","capabilities":["file_upload","drag_drop","progress"],"props":{"accept":{"type":"string"},"maxSize":{"type":"number"},"multiple":{"type":"boolean"},"onUpload":{"type":"function"}},"suitability":{"mobile":0.7,"desktop":1}},"ConfirmDialog":{"name":"ConfirmDialog","path":"src/components/patterns/ConfirmDialog.tsx","category":"patterns","description":"Confirmation dialog for destructive or important actions.","capabilities":["confirmation","destructive_action"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"},"title":{"type":"string"},"description":{"type":"string"},"onConfirm":{"type":"function"},"onCancel":{"type":"function"},"confirmLabel":{"type":"string","default":"Confirm"},"cancelLabel":{"type":"string","default":"Cancel"},"variant":{"type":"enum","values":["default","danger"]}},"suitability":{"mobile":1,"desktop":1}},"SelectionDialog":{"name":"SelectionDialog","path":"src/components/patterns/SelectionDialog.tsx","category":"patterns","description":"Dialog for selecting from a list of items.","capabilities":["multi_select","search","dialog"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"},"items":{"type":"array"},"onSelect":{"type":"function"},"multiple":{"type":"boolean"}},"suitability":{"mobile":0.8,"desktop":1}},"Stepper":{"name":"Stepper","path":"src/components/patterns/Stepper.tsx","category":"patterns","description":"Multi-step progress indicator for wizards and onboarding.","capabilities":["step_progress","wizard","onboarding"],"props":{"steps":{"type":"array","required":true},"currentStep":{"type":"number","required":true},"orientation":{"type":"enum","values":["horizontal","vertical"],"default":"horizontal"}},"suitability":{"mobile":0.7,"desktop":1}},"TenantSwitcher":{"name":"TenantSwitcher","path":"src/components/patterns/TenantSwitcher.tsx","category":"patterns","description":"Multi-tenant organization/workspace switcher.","capabilities":["tenant_switch","organization_select"],"props":{"tenants":{"type":"array","required":true},"currentTenant":{"type":"object"},"onTenantChange":{"type":"function"}},"suitability":{"mobile":0.9,"desktop":1}},"UserMenu":{"name":"UserMenu","path":"src/components/patterns/UserMenu.tsx","category":"patterns","description":"User profile dropdown with account actions.","capabilities":["user_profile","logout","settings_link"],"props":{"user":{"type":"object","required":true},"onLogout":{"type":"function"},"menuItems":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"PermissionGuard":{"name":"PermissionGuard","path":"src/components/patterns/PermissionGuard.tsx","category":"patterns","description":"Conditional rendering based on user permissions.","capabilities":["permission_check","access_control"],"props":{"permission":{"type":"string","required":true},"fallback":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"DataGuard":{"name":"DataGuard","path":"src/components/patterns/DataGuard.tsx","category":"patterns","description":"Permission-based data display wrapper.","capabilities":["data_protection","access_control"],"props":{"permission":{"type":"string"},"children":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"NetworkBoundary":{"name":"NetworkBoundary","path":"src/components/patterns/NetworkBoundary.tsx","category":"patterns","description":"Handles network states (loading, error, offline).","capabilities":["network_status","offline_handling","error_handling"],"props":{"loading":{"type":"boolean"},"error":{"type":"Error"},"onRetry":{"type":"function"}},"suitability":{"mobile":1,"desktop":1}},"RichTextEditor":{"name":"RichTextEditor","path":"src/components/patterns/RichTextEditor.tsx","category":"patterns","description":"TipTap-based rich text editor with formatting toolbar.","capabilities":["rich_text","formatting","wysiwyg"],"props":{"content":{"type":"string"},"onChange":{"type":"function"},"placeholder":{"type":"string"},"editable":{"type":"boolean","default":true}},"suitability":{"mobile":0.6,"desktop":1}},"RichTextViewer":{"name":"RichTextViewer","path":"src/components/patterns/RichTextViewer.tsx","category":"patterns","description":"Renders rich text/HTML content safely.","capabilities":["render_html","markdown_display"],"props":{"content":{"type":"string","required":true}},"suitability":{"mobile":1,"desktop":1}},"MarkdownRenderer":{"name":"MarkdownRenderer","path":"src/components/patterns/MarkdownRenderer.tsx","category":"patterns","description":"Renders markdown content as React components.","capabilities":["markdown_render","code_highlight"],"props":{"content":{"type":"string","required":true},"allowHtml":{"type":"boolean","default":false}},"suitability":{"mobile":1,"desktop":1}},"SafeHtml":{"name":"SafeHtml","path":"src/components/patterns/SafeHtml.tsx","category":"patterns","description":"Sanitized HTML rendering using DOMPurify.","capabilities":["sanitize_html","safe_render"],"props":{"html":{"type":"string","required":true},"allowedTags":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"SchemaTable":{"name":"SchemaTable","path":"src/components/patterns/SchemaTable.tsx","category":"patterns","description":"Auto-generates table from Zod schema.","capabilities":["schema_driven","auto_columns"],"props":{"schema":{"type":"ZodSchema","required":true},"data":{"type":"array","required":true}},"suitability":{"mobile":0.6,"desktop":1}},"SchemaFilters":{"name":"SchemaFilters","path":"src/components/patterns/SchemaFilters.tsx","category":"patterns","description":"Auto-generates filter UI from Zod schema.","capabilities":["schema_driven","auto_filters"],"props":{"schema":{"type":"ZodSchema","required":true},"onFilterChange":{"type":"function"}},"suitability":{"mobile":0.7,"desktop":1}},"FilterToolbar":{"name":"FilterToolbar","path":"src/components/patterns/FilterToolbar.tsx","category":"patterns","description":"Consolidated toolbar for search and filter controls.","capabilities":["search","filter","toolbar"],"props":{"search":{"type":"node"},"filters":{"type":"node"},"actions":{"type":"node"}},"suitability":{"mobile":0.8,"desktop":1}},"ChartArea":{"name":"ChartArea","path":"src/components/patterns/charts/ChartArea.tsx","category":"patterns","description":"Area chart visualization.","capabilities":["area_chart","time_series"],"props":{"data":{"type":"array","required":true},"xKey":{"type":"string"},"yKey":{"type":"string"}},"suitability":{"mobile":0.7,"desktop":1}},"ChartBar":{"name":"ChartBar","path":"src/components/patterns/charts/ChartBar.tsx","category":"patterns","description":"Bar chart visualization.","capabilities":["bar_chart","comparison"],"props":{"data":{"type":"array","required":true},"xKey":{"type":"string"},"yKey":{"type":"string"},"orientation":{"type":"enum","values":["horizontal","vertical"]}},"suitability":{"mobile":0.8,"desktop":1}},"ChartLine":{"name":"ChartLine","path":"src/components/patterns/charts/ChartLine.tsx","category":"patterns","description":"Line chart visualization.","capabilities":["line_chart","trend"],"props":{"data":{"type":"array","required":true},"xKey":{"type":"string"},"yKey":{"type":"string"}},"suitability":{"mobile":0.7,"desktop":1}},"ChartPie":{"name":"ChartPie","path":"src/components/patterns/charts/ChartPie.tsx","category":"patterns","description":"Pie/donut chart visualization.","capabilities":["pie_chart","distribution"],"props":{"data":{"type":"array","required":true},"valueKey":{"type":"string"},"nameKey":{"type":"string"},"donut":{"type":"boolean"}},"suitability":{"mobile":0.8,"desktop":1}},"KpiCard":{"name":"KpiCard","path":"src/components/patterns/charts/KpiCard.tsx","category":"patterns","description":"Key performance indicator card with trend.","capabilities":["kpi_display","trend_indicator"],"props":{"title":{"type":"string","required":true},"value":{"type":"string|number","required":true},"change":{"type":"number"},"changeLabel":{"type":"string"},"trend":{"type":"enum","values":["up","down","neutral"]}},"suitability":{"mobile":1,"desktop":1}},"Sparkline":{"name":"Sparkline","path":"src/components/patterns/charts/Sparkline.tsx","category":"patterns","description":"Compact inline chart for trends.","capabilities":["inline_chart","mini_trend"],"props":{"data":{"type":"array","required":true},"width":{"type":"number"},"height":{"type":"number"}},"suitability":{"mobile":1,"desktop":1}},"KanbanBoard":{"name":"KanbanBoard","path":"src/components/patterns/kanban/KanbanBoard.tsx","category":"patterns","description":"Drag-and-drop kanban board for task management.","capabilities":["kanban","drag_drop","columns"],"props":{"columns":{"type":"array","required":true},"onCardMove":{"type":"function"}},"suitability":{"mobile":0.5,"desktop":1}},"KanbanCard":{"name":"KanbanCard","path":"src/components/patterns/kanban/KanbanCard.tsx","category":"patterns","description":"Individual card within kanban board.","capabilities":["task_card","draggable"],"props":{"title":{"type":"string","required":true},"description":{"type":"string"},"labels":{"type":"array"},"assignee":{"type":"object"}},"suitability":{"mobile":0.6,"desktop":1}},"AuthenticatedAppShell":{"name":"AuthenticatedAppShell","path":"src/components/patterns/layouts/AuthenticatedAppShell.tsx","category":"patterns","description":"Complete app shell for authenticated users with sidebar and header.","capabilities":["app_layout","navigation","user_context"],"props":{"sidebar":{"type":"node"},"header":{"type":"node"},"children":{"type":"node"}},"suitability":{"mobile":0.8,"desktop":1}},"SidebarLayout":{"name":"SidebarLayout","path":"src/components/patterns/layouts/SidebarLayout.tsx","category":"patterns","description":"Layout with collapsible sidebar navigation.","capabilities":["sidebar_layout","collapsible"],"props":{"sidebar":{"type":"node"},"collapsed":{"type":"boolean"},"children":{"type":"node"}},"suitability":{"mobile":0.7,"desktop":1}},"SettingsLayout":{"name":"SettingsLayout","path":"src/components/patterns/layouts/SettingsLayout.tsx","category":"patterns","description":"Settings page layout with navigation tabs.","capabilities":["settings_page","tab_navigation"],"props":{"tabs":{"type":"array"},"children":{"type":"node"}},"suitability":{"mobile":0.8,"desktop":1}},"SplitPaneLayout":{"name":"SplitPaneLayout","path":"src/components/patterns/layouts/SplitPaneLayout.tsx","category":"patterns","description":"Resizable split pane layout.","capabilities":["split_view","resizable"],"props":{"left":{"type":"node"},"right":{"type":"node"},"defaultSize":{"type":"number"},"minSize":{"type":"number"}},"suitability":{"mobile":0.3,"desktop":1}},"HeroSection":{"name":"HeroSection","path":"src/components/patterns/marketing/HeroSection.tsx","category":"patterns","description":"Marketing hero section with headline and CTA.","capabilities":["hero","marketing","cta"],"props":{"title":{"type":"string","required":true},"subtitle":{"type":"string"},"primaryAction":{"type":"node"},"secondaryAction":{"type":"node"},"image":{"type":"string"}},"suitability":{"mobile":1,"desktop":1}},"FeatureGrid":{"name":"FeatureGrid","path":"src/components/patterns/marketing/FeatureGrid.tsx","category":"patterns","description":"Grid of feature cards for marketing pages.","capabilities":["feature_showcase","marketing"],"props":{"features":{"type":"array","required":true},"columns":{"type":"number","default":3}},"suitability":{"mobile":1,"desktop":1}},"PricingCards":{"name":"PricingCards","path":"src/components/patterns/marketing/PricingCards.tsx","category":"patterns","description":"Pricing tier comparison cards.","capabilities":["pricing","comparison","marketing"],"props":{"plans":{"type":"array","required":true},"billingPeriod":{"type":"enum","values":["monthly","yearly"]}},"suitability":{"mobile":0.9,"desktop":1}},"TestimonialGrid":{"name":"TestimonialGrid","path":"src/components/patterns/marketing/TestimonialGrid.tsx","category":"patterns","description":"Grid of customer testimonials.","capabilities":["testimonials","social_proof"],"props":{"testimonials":{"type":"array","required":true}},"suitability":{"mobile":1,"desktop":1}},"CTABanner":{"name":"CTABanner","path":"src/components/patterns/marketing/CTABanner.tsx","category":"patterns","description":"Call-to-action banner for conversions.","capabilities":["cta","conversion","marketing"],"props":{"title":{"type":"string","required":true},"description":{"type":"string"},"action":{"type":"node"}},"suitability":{"mobile":1,"desktop":1}},"WorkflowBuilder":{"name":"WorkflowBuilder","path":"src/components/patterns/workflow/WorkflowBuilder.tsx","category":"patterns","description":"Visual workflow/automation builder.","capabilities":["workflow_design","node_graph","automation"],"props":{"nodes":{"type":"array"},"edges":{"type":"array"},"onNodesChange":{"type":"function"},"onEdgesChange":{"type":"function"}},"suitability":{"mobile":0.2,"desktop":1}},"OfflineBanner":{"name":"OfflineBanner","path":"src/components/patterns/offline/OfflineBanner.tsx","category":"patterns","description":"Banner indicating offline status.","capabilities":["offline_indicator","connection_status"],"props":{"onRetry":{"type":"function"}},"suitability":{"mobile":1,"desktop":1}},"SearchBar":{"name":"SearchBar","path":"src/components/patterns/search/SearchBar.tsx","category":"patterns","description":"Search input with suggestions.","capabilities":["search","autocomplete"],"props":{"value":{"type":"string"},"onChange":{"type":"function"},"onSearch":{"type":"function"},"suggestions":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"ListPageTemplate":{"name":"ListPageTemplate","path":"src/components/patterns/templates/ListPageTemplate.tsx","category":"patterns","description":"Pre-built template for list/table pages.","capabilities":["list_page","crud_list"],"props":{"title":{"type":"string"},"data":{"type":"array"},"columns":{"type":"array"}},"suitability":{"mobile":0.7,"desktop":1}},"DetailPageTemplate":{"name":"DetailPageTemplate","path":"src/components/patterns/templates/DetailPageTemplate.tsx","category":"patterns","description":"Pre-built template for detail/view pages.","capabilities":["detail_page","entity_view"],"props":{"title":{"type":"string"},"sections":{"type":"array"}},"suitability":{"mobile":1,"desktop":1}},"FormPageTemplate":{"name":"FormPageTemplate","path":"src/components/patterns/templates/FormPageTemplate.tsx","category":"patterns","description":"Pre-built template for form pages.","capabilities":["form_page","create_edit"],"props":{"title":{"type":"string"},"onSubmit":{"type":"function"}},"suitability":{"mobile":1,"desktop":1}},"MotionDialog":{"name":"MotionDialog","path":"src/components/motion/MotionDialog.tsx","category":"motion","description":"Animated dialog with theme-aware motion.","capabilities":["animated_modal","spring_animation"],"props":{"open":{"type":"boolean"},"onOpenChange":{"type":"function"}},"suitability":{"mobile":0.9,"desktop":1}},"MotionList":{"name":"MotionList","path":"src/components/motion/MotionList.tsx","category":"motion","description":"Animated list with staggered item animations.","capabilities":["animated_list","stagger"],"props":{"items":{"type":"array"},"staggerDelay":{"type":"number"}},"suitability":{"mobile":1,"desktop":1}},"MotionToast":{"name":"MotionToast","path":"src/components/motion/MotionToast.tsx","category":"motion","description":"Animated toast notification.","capabilities":["animated_toast","slide_animation"],"props":{"variant":{"type":"enum","values":["default","success","error"]}},"suitability":{"mobile":1,"desktop":1}},"ApprovalRequest":{"name":"ApprovalRequest","path":"src/components/intents/ApprovalRequest.tsx","category":"intents","description":"Intent: 'I need to request or grant approval for something' - Multi-level approval workflows with status tracking and escalation.","capabilities":["approval_workflow","status_tracking","approver_management","escalation","comments"],"props":{"title":{"type":"string","required":true,"description":"Title of the approval request"},"description":{"type":"string","description":"Description of the approval request"},"status":{"type":"enum","values":["pending","approved","rejected","escalated"],"default":"pending"},"approvers":{"type":"array","required":true,"description":"List of approvers"},"onApprove":{"type":"function","description":"Handler for approval action"},"onReject":{"type":"function","description":"Handler for rejection action"},"onEscalate":{"type":"function","description":"Handler for escalation"},"onComment":{"type":"function","description":"Handler for adding comments"},"showTimeline":{"type":"boolean","default":true},"allowComments":{"type":"boolean","default":true}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"BulkActionBar":{"name":"BulkActionBar","path":"src/components/intents/BulkActionBar.tsx","category":"intents","description":"Intent: 'I want to perform actions on multiple items at once' - Floating action bar for bulk operations on selected items.","capabilities":["bulk_selection","batch_operations","selection_count","quick_actions"],"props":{"selectedCount":{"type":"number","required":true,"description":"Number of selected items"},"totalCount":{"type":"number","description":"Total number of items"},"actions":{"type":"array","required":true,"description":"Available bulk actions"},"onSelectAll":{"type":"function","description":"Handler for select all action"},"onClearSelection":{"type":"function","description":"Handler for clearing selection"},"position":{"type":"enum","values":["top","bottom","floating"],"default":"bottom"},"showSelectAll":{"type":"boolean","default":true}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"DataImportWizard":{"name":"DataImportWizard","path":"src/components/intents/DataImportWizard.tsx","category":"intents","description":"Intent: 'I want to import data from a file' - Step-by-step data import wizard with column mapping and validation.","capabilities":["file_upload","column_mapping","data_validation","preview","import_progress"],"props":{"acceptedFormats":{"type":"array","description":"Accepted file formats"},"targetColumns":{"type":"array","required":true,"description":"Target columns for mapping"},"onImport":{"type":"function","required":true,"description":"Handler for import completion"},"onCancel":{"type":"function","description":"Handler for cancellation"},"validateRow":{"type":"function","description":"Row validation function"},"maxFileSize":{"type":"number","description":"Maximum file size in bytes"},"showPreview":{"type":"boolean","default":true}},"suitability":{"mobile":0.5,"desktop":1,"accessibility":0.8}},"QuickActions":{"name":"QuickActions","path":"src/components/intents/QuickActions.tsx","category":"intents","description":"Intent: 'I want quick access to common actions' - Floating action button or quick action menu for frequent operations.","capabilities":["quick_access","action_menu","keyboard_shortcuts","context_actions"],"props":{"actions":{"type":"array","required":true,"description":"Available quick actions"},"variant":{"type":"enum","values":["fab","menu","palette"],"default":"fab"},"position":{"type":"enum","values":["bottom-right","bottom-left","top-right","top-left"],"default":"bottom-right"},"onAction":{"type":"function","description":"Handler for action execution"},"showLabels":{"type":"boolean","default":false},"keyboardShortcuts":{"type":"boolean","default":true}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"FeatureAnnouncement":{"name":"FeatureAnnouncement","path":"src/components/intents/FeatureAnnouncement.tsx","category":"intents","description":"Intent: 'I want to announce a new feature to users' - Feature announcement modal or banner with media and CTA.","capabilities":["announcement","feature_highlight","media_display","call_to_action","dismissible"],"props":{"title":{"type":"string","required":true,"description":"Feature title"},"description":{"type":"string","description":"Feature description"},"media":{"type":"object","description":"Image or video for the announcement"},"primaryAction":{"type":"object","description":"Primary CTA button"},"secondaryAction":{"type":"object","description":"Secondary action"},"onDismiss":{"type":"function","description":"Handler for dismissal"},"variant":{"type":"enum","values":["modal","banner","spotlight"],"default":"modal"},"showDontShowAgain":{"type":"boolean","default":false}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"StatusTimeline":{"name":"StatusTimeline","path":"src/components/intents/StatusTimeline.tsx","category":"intents","description":"Intent: 'I want to track the status of something over time' - Visual timeline showing status changes and progress.","capabilities":["timeline_display","status_tracking","event_history","progress_indicator"],"props":{"events":{"type":"array","required":true,"description":"Timeline events"},"currentStatus":{"type":"string","description":"Current status"},"orientation":{"type":"enum","values":["vertical","horizontal"],"default":"vertical"},"showConnectors":{"type":"boolean","default":true},"showTimestamps":{"type":"boolean","default":true},"onEventClick":{"type":"function","description":"Handler for event click"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"ComparisonPicker":{"name":"ComparisonPicker","path":"src/components/intents/ComparisonPicker.tsx","category":"intents","description":"Intent: 'I want to compare options and make a decision' - Side-by-side comparison view for decision making.","capabilities":["comparison_view","feature_matrix","option_selection","highlight_differences"],"props":{"options":{"type":"array","required":true,"description":"Options to compare"},"features":{"type":"array","required":true,"description":"Features to compare"},"onSelect":{"type":"function","description":"Handler for option selection"},"selectedId":{"type":"string","description":"Currently selected option ID"},"highlightBest":{"type":"boolean","default":true},"showRecommendation":{"type":"boolean","default":false}},"suitability":{"mobile":0.6,"desktop":1,"accessibility":0.8}},"ErrorRecovery":{"name":"ErrorRecovery","path":"src/components/intents/ErrorRecovery.tsx","category":"intents","description":"Intent: 'Something went wrong and I need help fixing it' - Error recovery UI with suggested actions and support options.","capabilities":["error_display","recovery_steps","retry_action","support_contact","error_details"],"props":{"error":{"type":"object","required":true,"description":"Error information"},"recoverySteps":{"type":"array","description":"Suggested recovery steps"},"onRetry":{"type":"function","description":"Handler for retry action"},"onContactSupport":{"type":"function","description":"Handler for contacting support"},"showErrorDetails":{"type":"boolean","default":false},"showReportButton":{"type":"boolean","default":true}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"InviteMember":{"name":"InviteMember","path":"src/components/intents/InviteMember.tsx","category":"intents","description":"Intent: 'I want to invite people to my team or project' - Team member invitation with roles and pending invites.","capabilities":["email_invitation","role_assignment","pending_invites","bulk_invite","resend_invite"],"props":{"roles":{"type":"array","required":true,"description":"Available roles"},"pendingInvites":{"type":"array","description":"List of pending invitations"},"onSendInvites":{"type":"function","required":true,"description":"Handler for sending invites"},"onResendInvite":{"type":"function","description":"Handler for resending invite"},"onCancelInvite":{"type":"function","description":"Handler for canceling invite"},"maxInvites":{"type":"number","description":"Maximum invites allowed"},"defaultRole":{"type":"string","description":"Default role for new invites"}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"SmartSearch":{"name":"SmartSearch","path":"src/components/intents/SmartSearch.tsx","category":"intents","description":"Intent: 'I want to quickly find something' - Intelligent search with suggestions, recent searches, and filters.","capabilities":["instant_search","suggestions","recent_searches","filters","keyboard_navigation"],"props":{"onSearch":{"type":"function","required":true,"description":"Handler for search execution"},"suggestions":{"type":"array","description":"Search suggestions"},"recentSearches":{"type":"array","description":"Recent search history"},"filters":{"type":"array","description":"Available search filters"},"placeholder":{"type":"string","default":"Search..."},"showRecent":{"type":"boolean","default":true},"debounceMs":{"type":"number","default":300}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"OnboardingChecklist":{"name":"OnboardingChecklist","path":"src/components/intents/OnboardingChecklist.tsx","category":"intents","description":"Intent: 'I want to guide users through setup steps' - Onboarding checklist with progress tracking and completion rewards.","capabilities":["checklist_display","progress_tracking","step_guidance","completion_celebration"],"props":{"items":{"type":"array","required":true,"description":"Checklist items"},"onItemClick":{"type":"function","description":"Handler for item click"},"onComplete":{"type":"function","description":"Handler for checklist completion"},"showProgress":{"type":"boolean","default":true},"showDismiss":{"type":"boolean","default":true},"celebrateCompletion":{"type":"boolean","default":true}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"TrialBanner":{"name":"TrialBanner","path":"src/components/intents/TrialBanner.tsx","category":"intents","description":"Intent: 'I want to show trial status and upgrade prompts' - Trial status banner with countdown and upgrade CTA.","capabilities":["trial_countdown","upgrade_prompt","feature_teaser","dismissible"],"props":{"daysRemaining":{"type":"number","required":true,"description":"Days remaining in trial"},"trialEndDate":{"type":"Date","description":"Trial end date"},"onUpgrade":{"type":"function","description":"Handler for upgrade action"},"onDismiss":{"type":"function","description":"Handler for dismissal"},"variant":{"type":"enum","values":["banner","card","inline"],"default":"banner"},"showFeatures":{"type":"boolean","default":false}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"FeedbackCollector":{"name":"FeedbackCollector","path":"src/components/intents/FeedbackCollector.tsx","category":"intents","description":"Intent: 'I want to collect user feedback' - Feedback collection widget with ratings, categories, and attachments.","capabilities":["rating_collection","feedback_form","category_selection","attachment_upload","sentiment_emoji"],"props":{"feedbackTypes":{"type":"array","description":"Available feedback types"},"onSubmit":{"type":"function","required":true,"description":"Handler for feedback submission"},"showRating":{"type":"boolean","default":true},"showCategory":{"type":"boolean","default":true},"allowAttachments":{"type":"boolean","default":false},"placeholder":{"type":"string","description":"Feedback textarea placeholder"},"variant":{"type":"enum","values":["inline","modal","floating"],"default":"inline"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"SettingsSection":{"name":"SettingsSection","path":"src/components/intents/SettingsSection.tsx","category":"intents","description":"Intent: 'I want to organize settings into sections' - Settings section with grouped items and various input types.","capabilities":["settings_grouping","input_types","validation","save_state"],"props":{"title":{"type":"string","required":true,"description":"Section title"},"description":{"type":"string","description":"Section description"},"items":{"type":"array","required":true,"description":"Setting items in the section"},"onChange":{"type":"function","description":"Handler for setting changes"},"collapsible":{"type":"boolean","default":false},"defaultExpanded":{"type":"boolean","default":true}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"UsageMeter":{"name":"UsageMeter","path":"src/components/intents/UsageMeter.tsx","category":"intents","description":"Intent: 'I want to see my usage and limits' - Usage meter showing consumption against limits with upgrade prompts.","capabilities":["usage_display","limit_tracking","progress_bar","upgrade_prompt","history"],"props":{"metrics":{"type":"array","required":true,"description":"Usage metrics"},"onUpgrade":{"type":"function","description":"Handler for upgrade action"},"showHistory":{"type":"boolean","default":false},"warningThreshold":{"type":"number","default":80,"description":"Percentage to show warning"},"variant":{"type":"enum","values":["compact","detailed","card"],"default":"detailed"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"PaymentMethod":{"name":"PaymentMethod","path":"src/components/intents/PaymentMethod.tsx","category":"intents","description":"Intent: 'I want to manage my payment methods' - Payment method management with card display and actions.","capabilities":["card_display","add_payment","remove_payment","set_default","card_validation"],"props":{"cards":{"type":"array","description":"Saved payment cards"},"defaultCardId":{"type":"string","description":"Default payment method ID"},"onAddCard":{"type":"function","description":"Handler for adding card"},"onRemoveCard":{"type":"function","description":"Handler for removing card"},"onSetDefault":{"type":"function","description":"Handler for setting default"},"showAddCard":{"type":"boolean","default":true},"maxCards":{"type":"number","description":"Maximum cards allowed"}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.8}},"ExportData":{"name":"ExportData","path":"src/components/intents/ExportData.tsx","category":"intents","description":"Intent: 'I want to export my data' - Data export dialog with format selection and options.","capabilities":["format_selection","column_selection","date_range","export_progress"],"props":{"formats":{"type":"array","required":true,"description":"Available export formats"},"columns":{"type":"array","description":"Columns available for export"},"onExport":{"type":"function","required":true,"description":"Handler for export action"},"showDateRange":{"type":"boolean","default":true},"showColumnSelection":{"type":"boolean","default":true},"defaultFormat":{"type":"string","description":"Default export format"}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.9}},"ConfirmDestructive":{"name":"ConfirmDestructive","path":"src/components/intents/ConfirmDestructive.tsx","category":"intents","description":"Intent: 'I want to confirm a destructive action' - Destructive action confirmation with typing verification.","capabilities":["confirmation_dialog","type_to_confirm","consequence_display","undo_info"],"props":{"title":{"type":"string","required":true,"description":"Confirmation title"},"description":{"type":"string","description":"Confirmation description"},"consequences":{"type":"array","description":"List of consequences"},"confirmText":{"type":"string","description":"Text user must type to confirm"},"onConfirm":{"type":"function","required":true,"description":"Handler for confirmation"},"onCancel":{"type":"function","description":"Handler for cancellation"},"requireTyping":{"type":"boolean","default":true},"showUndo":{"type":"boolean","default":false}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"ActivityNotification":{"name":"ActivityNotification","path":"src/components/intents/ActivityNotification.tsx","category":"intents","description":"Intent: 'I want to show activity updates' - Activity notification item with actions and formatting.","capabilities":["activity_display","actor_info","action_buttons","timestamp"],"props":{"type":{"type":"enum","values":["info","success","warning","error","mention","update"],"required":true},"title":{"type":"string","required":true,"description":"Notification title"},"message":{"type":"string","description":"Notification message"},"actor":{"type":"object","description":"Actor information"},"timestamp":{"type":"Date","description":"Activity timestamp"},"actions":{"type":"array","description":"Available actions"},"onAction":{"type":"function","description":"Handler for action click"},"read":{"type":"boolean","default":false}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"NaturalLanguageInput":{"name":"NaturalLanguageInput","path":"src/components/intents/NaturalLanguageInput.tsx","category":"intents","description":"Intent: 'I want to interact using natural language' - AI-powered natural language input with suggestions and chat mode.","capabilities":["natural_language","ai_suggestions","chat_interface","command_parsing"],"props":{"onSubmit":{"type":"function","required":true,"description":"Handler for input submission"},"suggestions":{"type":"array","description":"Suggestion chips"},"messages":{"type":"array","description":"Chat history for chat mode"},"mode":{"type":"enum","values":["single","chat"],"default":"single"},"placeholder":{"type":"string","description":"Input placeholder"},"isProcessing":{"type":"boolean","default":false},"showSuggestions":{"type":"boolean","default":true}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.8}},"TemplateGallery":{"name":"TemplateGallery","path":"src/components/intents/TemplateGallery.tsx","category":"intents","description":"Intent: 'I want to start from a template' - Template gallery with categories, preview, and favorites.","capabilities":["template_browsing","category_filter","preview","favorites","search"],"props":{"templates":{"type":"array","required":true,"description":"Available templates"},"categories":{"type":"array","description":"Template categories"},"onSelect":{"type":"function","required":true,"description":"Handler for template selection"},"onPreview":{"type":"function","description":"Handler for template preview"},"onFavorite":{"type":"function","description":"Handler for favoriting"},"showSearch":{"type":"boolean","default":true},"viewMode":{"type":"enum","values":["grid","list"],"default":"grid"}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"CollaborationPresence":{"name":"CollaborationPresence","path":"src/components/intents/CollaborationPresence.tsx","category":"intents","description":"Intent: 'I want to see who's working with me' - Real-time collaboration presence with cursors and activity.","capabilities":["presence_display","live_cursors","activity_tracking","follow_mode"],"props":{"collaborators":{"type":"array","required":true,"description":"Active collaborators"},"currentUserId":{"type":"string","description":"Current user ID"},"onCollaboratorClick":{"type":"function","description":"Handler for collaborator click"},"onFollowCollaborator":{"type":"function","description":"Handler for following"},"followingId":{"type":"string","description":"Currently followed collaborator"},"showCursors":{"type":"boolean","default":true},"showActivity":{"type":"boolean","default":true},"maxVisible":{"type":"number","default":4},"variant":{"type":"enum","values":["avatars","list","minimal"],"default":"avatars"}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.8}},"AISuggestions":{"name":"AISuggestions","path":"src/components/intents/AISuggestions.tsx","category":"intents","description":"Intent: 'I want AI-powered suggestions' - AI suggestions panel with feedback and prioritization.","capabilities":["ai_suggestions","feedback_collection","priority_display","apply_action"],"props":{"suggestions":{"type":"array","required":true,"description":"AI suggestions"},"onApply":{"type":"function","description":"Handler for applying suggestion"},"onDismiss":{"type":"function","description":"Handler for dismissing"},"onFeedback":{"type":"function","description":"Handler for feedback"},"groupByType":{"type":"boolean","default":false},"variant":{"type":"enum","values":["panel","inline","floating"],"default":"panel"},"isLoading":{"type":"boolean","default":false}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.8}},"ExportAsset":{"name":"ExportAsset","path":"src/components/intents/ExportAsset.tsx","category":"intents","description":"Intent: 'I want to export or share an asset' - Asset export dialog with format options and sharing.","capabilities":["format_export","share_options","quality_settings","preview"],"props":{"formats":{"type":"array","required":true,"description":"Available export formats"},"shareOptions":{"type":"array","description":"Share platform options"},"onExport":{"type":"function","required":true,"description":"Handler for export"},"onShare":{"type":"function","description":"Handler for sharing"},"showAdvancedSettings":{"type":"boolean","default":false},"previewUrl":{"type":"string","description":"Preview image URL"},"defaultFormat":{"type":"string","description":"Default export format"}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"VersionHistory":{"name":"VersionHistory","path":"src/components/intents/VersionHistory.tsx","category":"intents","description":"Intent: 'I want to see previous versions' - Version history with diff view and restore capability.","capabilities":["version_list","diff_view","restore","compare","author_info"],"props":{"versions":{"type":"array","required":true,"description":"Version history"},"currentVersionId":{"type":"string","description":"Current version ID"},"onPreview":{"type":"function","description":"Handler for version preview"},"onRestore":{"type":"function","description":"Handler for restore"},"onCompare":{"type":"function","description":"Handler for comparison"},"variant":{"type":"enum","values":["list","timeline","compact"],"default":"list"},"groupByDate":{"type":"boolean","default":true},"showDiff":{"type":"boolean","default":false}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.8}},"PermissionManager":{"name":"PermissionManager","path":"src/components/intents/PermissionManager.tsx","category":"intents","description":"Intent: 'I want to manage user permissions and access control' - Role-based permission management with visual matrix and granular controls.","capabilities":["permission_matrix","role_management","access_control","bulk_permissions","permission_inheritance"],"props":{"permissions":{"type":"array","required":true,"description":"Available permissions"},"roles":{"type":"array","required":true,"description":"Defined roles"},"rolePermissions":{"type":"object","description":"Current role-permission mappings"},"onPermissionChange":{"type":"function","description":"Handler for permission changes"},"onRoleCreate":{"type":"function","description":"Handler for creating new roles"},"showInheritance":{"type":"boolean","default":true},"readOnly":{"type":"boolean","default":false}},"suitability":{"mobile":0.5,"desktop":1,"accessibility":0.8}},"SchedulingCalendar":{"name":"SchedulingCalendar","path":"src/components/intents/SchedulingCalendar.tsx","category":"intents","description":"Intent: 'I want to schedule meetings or manage availability' - Interactive calendar for booking, scheduling, and availability management.","capabilities":["calendar_view","event_scheduling","availability_slots","time_selection","recurring_events"],"props":{"events":{"type":"array","description":"Calendar events"},"availability":{"type":"array","description":"Available time slots"},"onEventCreate":{"type":"function","description":"Handler for creating events"},"onEventUpdate":{"type":"function","description":"Handler for updating events"},"onSlotSelect":{"type":"function","description":"Handler for slot selection"},"view":{"type":"enum","values":["day","week","month"],"default":"week"},"minDate":{"type":"Date","description":"Minimum selectable date"},"maxDate":{"type":"Date","description":"Maximum selectable date"}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.8}},"AnalyticsDashboard":{"name":"AnalyticsDashboard","path":"src/components/intents/AnalyticsDashboard.tsx","category":"intents","description":"Intent: 'I want to view my analytics and metrics' - Comprehensive analytics dashboard with KPIs, charts, and date range filtering.","capabilities":["metric_display","chart_visualization","date_filtering","data_comparison","export_data"],"props":{"metrics":{"type":"array","required":true,"description":"KPI metrics to display"},"charts":{"type":"array","description":"Chart configurations"},"dateRange":{"type":"object","description":"Selected date range"},"onDateRangeChange":{"type":"function","description":"Handler for date range changes"},"onExport":{"type":"function","description":"Handler for data export"},"isLoading":{"type":"boolean","default":false},"compareMode":{"type":"boolean","default":false}},"suitability":{"mobile":0.6,"desktop":1,"accessibility":0.8}},"MultiStepWizard":{"name":"MultiStepWizard","path":"src/components/intents/MultiStepWizard.tsx","category":"intents","description":"Intent: 'I want to complete a multi-step process' - Guided multi-step form wizard with progress tracking and validation.","capabilities":["step_navigation","progress_tracking","form_validation","step_completion","save_progress"],"props":{"steps":{"type":"array","required":true,"description":"Wizard step configurations"},"currentStep":{"type":"number","default":0},"onStepChange":{"type":"function","description":"Handler for step changes"},"onComplete":{"type":"function","description":"Handler for wizard completion"},"allowSkip":{"type":"boolean","default":false},"showProgress":{"type":"boolean","default":true},"orientation":{"type":"enum","values":["horizontal","vertical"],"default":"horizontal"}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"FileAssetManager":{"name":"FileAssetManager","path":"src/components/intents/FileAssetManager.tsx","category":"intents","description":"Intent: 'I want to browse, upload, and manage files' - Full-featured file manager with folders, upload, preview, and organization.","capabilities":["file_browser","file_upload","folder_management","file_preview","bulk_operations","drag_drop"],"props":{"files":{"type":"array","required":true,"description":"File and folder items"},"onUpload":{"type":"function","description":"Handler for file upload"},"onDelete":{"type":"function","description":"Handler for file deletion"},"onFolderCreate":{"type":"function","description":"Handler for folder creation"},"onSelect":{"type":"function","description":"Handler for file selection"},"viewMode":{"type":"enum","values":["grid","list"],"default":"grid"},"allowMultiple":{"type":"boolean","default":true},"acceptedTypes":{"type":"array","description":"Accepted file MIME types"}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.8}},"AdvancedSearch":{"name":"AdvancedSearch","path":"src/components/intents/AdvancedSearch.tsx","category":"intents","description":"Intent: 'I want to find something with specific criteria' - Advanced search with filters, saved searches, and faceted navigation.","capabilities":["text_search","filter_facets","saved_searches","search_suggestions","recent_searches"],"props":{"filters":{"type":"array","description":"Available filter configurations"},"activeFilters":{"type":"array","description":"Currently active filters"},"onSearch":{"type":"function","required":true,"description":"Handler for search execution"},"onFilterChange":{"type":"function","description":"Handler for filter changes"},"savedSearches":{"type":"array","description":"User's saved searches"},"suggestions":{"type":"array","description":"Search suggestions"},"isSearching":{"type":"boolean","default":false}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"KeyboardShortcuts":{"name":"KeyboardShortcuts","path":"src/components/intents/KeyboardShortcuts.tsx","category":"intents","description":"Intent: 'I want to learn and use keyboard shortcuts' - Keyboard shortcut reference panel with categories and search.","capabilities":["shortcut_display","category_grouping","shortcut_search","modifier_keys","custom_shortcuts"],"props":{"shortcuts":{"type":"array","required":true,"description":"Keyboard shortcut definitions"},"categories":{"type":"array","description":"Shortcut categories"},"onShortcutEdit":{"type":"function","description":"Handler for editing shortcuts"},"showSearch":{"type":"boolean","default":true},"allowCustomization":{"type":"boolean","default":false},"platform":{"type":"enum","values":["mac","windows","auto"],"default":"auto"}},"suitability":{"mobile":0.3,"desktop":1,"accessibility":0.7}},"ChangelogFeed":{"name":"ChangelogFeed","path":"src/components/intents/ChangelogFeed.tsx","category":"intents","description":"Intent: 'I want to see what's new in the product' - Product changelog and release notes feed with version history.","capabilities":["changelog_display","version_history","feature_announcements","filtering","subscription"],"props":{"entries":{"type":"array","required":true,"description":"Changelog entries"},"onSubscribe":{"type":"function","description":"Handler for changelog subscription"},"showFilters":{"type":"boolean","default":true},"groupByVersion":{"type":"boolean","default":true},"maxEntries":{"type":"number","description":"Maximum entries to display"}},"suitability":{"mobile":1,"desktop":1,"accessibility":0.9}},"ApiKeyManager":{"name":"ApiKeyManager","path":"src/components/intents/ApiKeyManager.tsx","category":"intents","description":"Intent: 'I want to manage my API keys' - API key management with creation, revocation, and usage tracking.","capabilities":["api_key_list","key_creation","key_revocation","usage_stats","scope_management"],"props":{"apiKeys":{"type":"array","required":true,"description":"Existing API keys"},"onCreateKey":{"type":"function","description":"Handler for key creation"},"onRevokeKey":{"type":"function","description":"Handler for key revocation"},"onRegenerateKey":{"type":"function","description":"Handler for key regeneration"},"availableScopes":{"type":"array","description":"Available permission scopes"},"showUsage":{"type":"boolean","default":true}},"suitability":{"mobile":0.6,"desktop":1,"accessibility":0.8}},"WebhookConfigurator":{"name":"WebhookConfigurator","path":"src/components/intents/WebhookConfigurator.tsx","category":"intents","description":"Intent: 'I want to set up webhooks for integrations' - Webhook configuration with endpoint management and event subscriptions.","capabilities":["webhook_setup","event_subscription","endpoint_testing","delivery_logs","retry_config"],"props":{"webhooks":{"type":"array","required":true,"description":"Configured webhooks"},"availableEvents":{"type":"array","required":true,"description":"Available webhook events"},"onCreateWebhook":{"type":"function","description":"Handler for webhook creation"},"onUpdateWebhook":{"type":"function","description":"Handler for webhook updates"},"onDeleteWebhook":{"type":"function","description":"Handler for webhook deletion"},"onTestWebhook":{"type":"function","description":"Handler for testing webhooks"},"showDeliveryLogs":{"type":"boolean","default":true}},"suitability":{"mobile":0.5,"desktop":1,"accessibility":0.8}},"AuditLogViewer":{"name":"AuditLogViewer","path":"src/components/intents/AuditLogViewer.tsx","category":"intents","description":"Intent: 'I want to review activity and audit logs' - Audit log viewer with filtering, search, and export capabilities.","capabilities":["log_display","filtering","search","export","user_activity","timeline_view"],"props":{"events":{"type":"array","required":true,"description":"Audit log events"},"onFilterChange":{"type":"function","description":"Handler for filter changes"},"onExport":{"type":"function","description":"Handler for log export"},"filters":{"type":"object","description":"Current filter state"},"showTimeline":{"type":"boolean","default":false},"pageSize":{"type":"number","default":50}},"suitability":{"mobile":0.6,"desktop":1,"accessibility":0.8}},"WorkspaceSwitcher":{"name":"WorkspaceSwitcher","path":"src/components/intents/WorkspaceSwitcher.tsx","category":"intents","description":"Intent: 'I want to switch between workspaces or teams' - Multi-tenant workspace switcher with roles and quick actions.","capabilities":["workspace_list","workspace_switch","workspace_search","role_display","quick_actions"],"props":{"workspaces":{"type":"array","required":true,"description":"Available workspaces"},"currentWorkspace":{"type":"object","description":"Currently active workspace"},"onSwitch":{"type":"function","description":"Handler for workspace switching"},"onCreate":{"type":"function","description":"Handler for workspace creation"},"onSettings":{"type":"function","description":"Handler for workspace settings"},"showSearch":{"type":"boolean","default":true},"showPlan":{"type":"boolean","default":true},"showMemberCount":{"type":"boolean","default":true}},"suitability":{"mobile":0.9,"desktop":1,"accessibility":0.9}},"PreferencesPanel":{"name":"PreferencesPanel","path":"src/components/intents/PreferencesPanel.tsx","category":"intents","description":"Intent: 'I want to customize my settings' - Comprehensive preferences panel with theme, sections, and various input types.","capabilities":["preference_sections","theme_selection","setting_types","save_reset","grouped_settings"],"props":{"sections":{"type":"array","required":true,"description":"Preference sections"},"themeMode":{"type":"enum","values":["light","dark","system"],"default":"system"},"onThemeChange":{"type":"function","description":"Handler for theme changes"},"onPreferenceChange":{"type":"function","description":"Handler for preference changes"},"onSave":{"type":"function","description":"Handler for saving preferences"},"onReset":{"type":"function","description":"Handler for resetting preferences"},"hasChanges":{"type":"boolean","default":false},"showThemeSelector":{"type":"boolean","default":true},"compact":{"type":"boolean","default":false}},"suitability":{"mobile":0.8,"desktop":1,"accessibility":0.9}},"GuidedTour":{"name":"GuidedTour","path":"src/components/intents/GuidedTour.tsx","category":"intents","description":"Intent: 'I want to learn how to use this feature' - Interactive guided tour with spotlights, tooltips, and progress tracking.","capabilities":["step_spotlight","tooltip_guidance","progress_tracking","skip_controls","hotspot_highlighting"],"props":{"steps":{"type":"array","required":true,"description":"Tour step configurations"},"isActive":{"type":"boolean","default":false},"currentStep":{"type":"number","default":0},"onComplete":{"type":"function","description":"Handler for tour completion"},"onSkip":{"type":"function","description":"Handler for skipping tour"},"onStepChange":{"type":"function","description":"Handler for step changes"},"showProgress":{"type":"boolean","default":true},"allowSkip":{"type":"boolean","default":true}},"suitability":{"mobile":0.7,"desktop":1,"accessibility":0.8}}}`), L = {
  version: Ae,
  meta: Ee,
  categories: De,
  components: _e
};
function Le(e) {
  const t = L.components, a = {
    atoms: [],
    molecules: [],
    organisms: [],
    primitives: [],
    patterns: [],
    content: [],
    motion: [],
    intents: []
  };
  for (const [s, r] of Object.entries(t)) {
    const i = r.category;
    a[i] && a[i].push(s);
  }
  for (const s of Object.keys(a))
    a[s].sort();
  if (e)
    return {
      components: { [e]: a[e] || [] },
      totals: { [e]: (a[e] || []).length },
      total: (a[e] || []).length
    };
  const o = {};
  let n = 0;
  for (const [s, r] of Object.entries(a))
    o[s] = r.length, n += r.length;
  return { components: a, totals: o, total: n };
}
function Fe(e) {
  return L.components[e] || null;
}
function na(e) {
  const t = L.components;
  return Object.values(t).filter((a) => a.category === e).sort((a, o) => a.name.localeCompare(o.name));
}
function oa(e) {
  const t = L.components;
  return Object.values(t).filter((a) => {
    var o;
    return (o = a.capabilities) == null ? void 0 : o.some((n) => n.toLowerCase().includes(e.toLowerCase()));
  }).sort((a, o) => a.name.localeCompare(o.name));
}
function sa() {
  return {
    version: L.version,
    lastUpdated: L.meta.lastUpdated,
    totalComponents: L.meta.totalComponents,
    categories: L.categories
  };
}
function ee() {
  const e = L.components, t = Object.values(e).filter((o) => o.category === "intents").sort((o, n) => o.name.localeCompare(n.name)), a = {
    ApprovalRequest: {
      userGoal: "Request approval for an action or content",
      whenToUse: ["Workflow approval needed", "Multi-stage approval process", "Document review"],
      relatedIntents: ["StatusTimeline", "MultiStepWizard"]
    },
    BulkActionBar: {
      userGoal: "Perform actions on multiple selected items",
      whenToUse: ["DataTable with selection", "Batch operations", "Mass updates"],
      relatedIntents: ["DataImportWizard", "ExportData"]
    },
    ConfirmDestructive: {
      userGoal: "Confirm dangerous/irreversible actions",
      whenToUse: ["Delete operations", "Account cancellation", "Data purge"],
      relatedIntents: ["ErrorRecovery"]
    },
    DataImportWizard: {
      userGoal: "Import data from external sources",
      whenToUse: ["CSV/Excel import", "Data migration", "Bulk data entry"],
      relatedIntents: ["ExportData", "BulkActionBar"]
    },
    EmptyState: {
      userGoal: "Guide users when there is no content",
      whenToUse: ["Empty lists", "No search results", "New user onboarding"],
      relatedIntents: ["OnboardingChecklist", "TemplateGallery"]
    },
    ErrorRecovery: {
      userGoal: "Help users recover from errors",
      whenToUse: ["API failures", "Form validation errors", "Network issues"],
      relatedIntents: ["ConfirmDestructive", "FeedbackCollector"]
    },
    ExportData: {
      userGoal: "Export data to various formats",
      whenToUse: ["CSV/PDF export", "Report generation", "Data backup"],
      relatedIntents: ["DataImportWizard", "BulkActionBar"]
    },
    FeedbackCollector: {
      userGoal: "Collect user feedback",
      whenToUse: ["Feature feedback", "Bug reports", "User surveys"],
      relatedIntents: ["FeatureAnnouncement", "NaturalLanguageInput"]
    },
    FeatureAnnouncement: {
      userGoal: "Announce new features to users",
      whenToUse: ["Product updates", "New releases", "Beta features"],
      relatedIntents: ["ChangelogFeed", "GuidedTour"]
    },
    InviteMember: {
      userGoal: "Invite users to a team/organization",
      whenToUse: ["Team management", "Collaboration", "Sharing access"],
      relatedIntents: ["PermissionManager", "WorkspaceSwitcher"]
    },
    NotificationCenter: {
      userGoal: "Display and manage notifications",
      whenToUse: ["System alerts", "User notifications", "Activity feed"],
      relatedIntents: ["ActivityNotification", "FeatureAnnouncement"]
    },
    OnboardingChecklist: {
      userGoal: "Guide new users through setup",
      whenToUse: ["New user flow", "Account setup", "Feature discovery"],
      relatedIntents: ["GuidedTour", "EmptyState"]
    },
    PermissionManager: {
      userGoal: "Manage user permissions and roles",
      whenToUse: ["Access control", "Role management", "Team permissions"],
      relatedIntents: ["InviteMember", "SettingsSection"]
    },
    QuickActions: {
      userGoal: "Provide fast access to common actions",
      whenToUse: ["Keyboard shortcuts", "Action menu", "Contextual actions"],
      relatedIntents: ["KeyboardShortcuts", "SmartSearch"]
    },
    SettingsSection: {
      userGoal: "Organize settings into sections",
      whenToUse: ["Settings pages", "Preferences", "Configuration"],
      relatedIntents: ["PreferencesPanel", "PermissionManager"]
    },
    SmartSearch: {
      userGoal: "Provide intelligent search",
      whenToUse: ["Global search", "Command palette", "Quick navigation"],
      relatedIntents: ["AdvancedSearch", "QuickActions"]
    },
    StatusTimeline: {
      userGoal: "Show status history/progression",
      whenToUse: ["Order tracking", "Workflow status", "Audit trail"],
      relatedIntents: ["ApprovalRequest", "VersionHistory"]
    },
    TrialBanner: {
      userGoal: "Show trial/subscription status",
      whenToUse: ["Free trial", "Plan limits", "Upgrade prompts"],
      relatedIntents: ["UsageMeter", "PaymentMethod"]
    },
    UsageMeter: {
      userGoal: "Display resource usage",
      whenToUse: ["API limits", "Storage quota", "Plan usage"],
      relatedIntents: ["TrialBanner", "AnalyticsDashboard"]
    },
    ApiKeyManager: {
      userGoal: "Manage API keys and tokens",
      whenToUse: ["Developer settings", "API access", "Token management"],
      relatedIntents: ["WebhookConfigurator", "SettingsSection"]
    },
    WebhookConfigurator: {
      userGoal: "Configure webhook endpoints",
      whenToUse: ["Integration setup", "Event subscriptions", "API callbacks"],
      relatedIntents: ["ApiKeyManager", "SettingsSection"]
    },
    AuditLogViewer: {
      userGoal: "View audit/activity logs",
      whenToUse: ["Security audit", "Activity tracking", "Compliance"],
      relatedIntents: ["StatusTimeline", "VersionHistory"]
    },
    WorkspaceSwitcher: {
      userGoal: "Switch between workspaces/orgs",
      whenToUse: ["Multi-tenant apps", "Team switching", "Project selection"],
      relatedIntents: ["InviteMember", "PermissionManager"]
    },
    VersionHistory: {
      userGoal: "View and restore versions",
      whenToUse: ["Document history", "Change tracking", "Rollback"],
      relatedIntents: ["AuditLogViewer", "StatusTimeline"]
    },
    GuidedTour: {
      userGoal: "Walk users through features",
      whenToUse: ["Feature introduction", "Onboarding", "Help system"],
      relatedIntents: ["OnboardingChecklist", "KeyboardShortcuts"]
    },
    AdvancedSearch: {
      userGoal: "Complex search with filters",
      whenToUse: ["Filtered search", "Query builder", "Faceted search"],
      relatedIntents: ["SmartSearch", "DataTable"]
    },
    KeyboardShortcuts: {
      userGoal: "Display available shortcuts",
      whenToUse: ["Help dialog", "Power users", "Accessibility"],
      relatedIntents: ["QuickActions", "GuidedTour"]
    },
    ChangelogFeed: {
      userGoal: "Show product changelog",
      whenToUse: ["Release notes", "Updates feed", "What's new"],
      relatedIntents: ["FeatureAnnouncement", "NotificationCenter"]
    },
    AnalyticsDashboard: {
      userGoal: "Display analytics overview",
      whenToUse: ["Dashboard", "Metrics", "KPIs"],
      relatedIntents: ["UsageMeter", "KpiCard"]
    },
    MultiStepWizard: {
      userGoal: "Guide through multi-step process",
      whenToUse: ["Complex forms", "Onboarding", "Setup flow"],
      relatedIntents: ["OnboardingChecklist", "ApprovalRequest"]
    },
    PaymentMethod: {
      userGoal: "Manage payment methods",
      whenToUse: ["Billing settings", "Checkout", "Subscriptions"],
      relatedIntents: ["TrialBanner", "SettingsSection"]
    },
    ActivityNotification: {
      userGoal: "Show activity updates",
      whenToUse: ["Real-time updates", "Collaboration", "Mentions"],
      relatedIntents: ["NotificationCenter", "CollaborationPresence"]
    },
    CollaborationPresence: {
      userGoal: "Show who is online/active",
      whenToUse: ["Real-time collaboration", "Team awareness", "Cursors"],
      relatedIntents: ["ActivityNotification", "InviteMember"]
    },
    NaturalLanguageInput: {
      userGoal: "Accept natural language input",
      whenToUse: ["AI prompts", "Search queries", "Command input"],
      relatedIntents: ["SmartSearch", "AISuggestions"]
    },
    AISuggestions: {
      userGoal: "Show AI-powered suggestions",
      whenToUse: ["Auto-complete", "Smart recommendations", "AI assist"],
      relatedIntents: ["NaturalLanguageInput", "SmartSearch"]
    },
    TemplateGallery: {
      userGoal: "Browse and select templates",
      whenToUse: ["Template selection", "Starting points", "Presets"],
      relatedIntents: ["EmptyState", "MultiStepWizard"]
    },
    ComparisonPicker: {
      userGoal: "Compare and select options",
      whenToUse: ["Plan comparison", "Product comparison", "Feature diff"],
      relatedIntents: ["TemplateGallery", "SettingsSection"]
    },
    SchedulingCalendar: {
      userGoal: "Schedule events/appointments",
      whenToUse: ["Booking", "Calendar view", "Availability"],
      relatedIntents: ["AnalyticsDashboard"]
    },
    FileAssetManager: {
      userGoal: "Manage files and assets",
      whenToUse: ["File upload", "Media library", "Asset browser"],
      relatedIntents: ["ExportAsset", "DataImportWizard"]
    },
    ExportAsset: {
      userGoal: "Export assets/files",
      whenToUse: ["Download files", "Export media", "Asset export"],
      relatedIntents: ["FileAssetManager", "ExportData"]
    },
    PreferencesPanel: {
      userGoal: "Manage user preferences",
      whenToUse: ["User settings", "Customization", "Preferences"],
      relatedIntents: ["SettingsSection", "PermissionManager"]
    }
  };
  return t.map((o) => {
    const n = a[o.name] || {
      userGoal: o.description,
      whenToUse: [],
      relatedIntents: []
    };
    return {
      ...o,
      userGoal: n.userGoal,
      whenToUse: n.whenToUse,
      relatedIntents: n.relatedIntents,
      exampleUsage: `import { ${o.name} } from '@org/design-system';

<${o.name}
  // Add props based on your use case
/>`
    };
  });
}
function Ne(e) {
  return ee().find((a) => a.name === e) || null;
}
function ia(e) {
  const t = ee(), a = e.toLowerCase();
  return t.filter((o) => {
    var c;
    const n = o.userGoal.toLowerCase().includes(a), s = o.description.toLowerCase().includes(a), r = o.whenToUse.some((p) => p.toLowerCase().includes(a)), i = (c = o.capabilities) == null ? void 0 : c.some((p) => p.toLowerCase().includes(a));
    return n || s || r || i;
  });
}
function ca(e) {
  const t = Ne(e);
  return t ? ee().filter((o) => t.relatedIntents.includes(o.name)) : [];
}
function pa(e, t) {
  const a = ee(), o = {
    list: ["EmptyState", "BulkActionBar", "AdvancedSearch", "SmartSearch"],
    create: ["MultiStepWizard", "TemplateGallery"],
    edit: ["VersionHistory", "ConfirmDestructive"],
    delete: ["ConfirmDestructive"],
    view: ["StatusTimeline", "ActivityNotification"],
    import: ["DataImportWizard"],
    export: ["ExportData"],
    invite: ["InviteMember"],
    approve: ["ApprovalRequest", "StatusTimeline"],
    settings: ["SettingsSection", "PreferencesPanel"],
    billing: ["PaymentMethod", "UsageMeter", "TrialBanner"],
    api: ["ApiKeyManager", "WebhookConfigurator"],
    audit: ["AuditLogViewer", "VersionHistory"],
    search: ["SmartSearch", "AdvancedSearch"],
    onboarding: ["OnboardingChecklist", "GuidedTour", "FeatureAnnouncement"],
    notifications: ["NotificationCenter", "ActivityNotification"],
    collaboration: ["CollaborationPresence", "InviteMember"],
    ai: ["AISuggestions", "NaturalLanguageInput"]
  };
  return t.map((n) => {
    const s = o[n.toLowerCase()] || [], r = a.filter((i) => s.includes(i.name));
    return {
      operation: n,
      suggestedIntents: r
    };
  });
}
const ue = {
  analytics: {
    patterns: [/\/analytics/i, /\/metrics/i, /\/dashboards?/i, /\/reports?/i, /\/insights?/i],
    preset: "analytics-mixpanel-style"
  },
  ecommerce: {
    patterns: [/\/products?/i, /\/orders?/i, /\/cart/i, /\/checkout/i, /\/inventory/i, /\/catalog/i],
    preset: "ecommerce-modern-marketplace"
  },
  crm: {
    patterns: [/\/leads?/i, /\/contacts?/i, /\/deals?/i, /\/pipeline/i, /\/opportunities/i],
    preset: "crm-hubspot-modern"
  },
  saas: {
    patterns: [/\/users?/i, /\/settings/i, /\/admin/i, /\/billing/i, /\/subscriptions?/i, /\/tenants?/i],
    preset: "saas-modern-minimal"
  },
  devtools: {
    patterns: [/\/repos?/i, /\/commits?/i, /\/deployments?/i, /\/api-keys?/i, /\/webhooks?/i, /\/logs?/i],
    preset: "devtools-github-inspired"
  },
  fintech: {
    patterns: [/\/accounts?/i, /\/transactions?/i, /\/payments?/i, /\/transfers?/i, /\/wallets?/i],
    preset: "fintech-banking-professional"
  },
  healthcare: {
    patterns: [/\/patients?/i, /\/appointments?/i, /\/prescriptions?/i, /\/records?/i, /\/diagnos/i],
    preset: "healthcare-clinical-clean"
  },
  education: {
    patterns: [/\/courses?/i, /\/lessons?/i, /\/students?/i, /\/grades?/i, /\/assignments?/i],
    preset: "education-learning-platform"
  },
  social: {
    patterns: [/\/posts?/i, /\/comments?/i, /\/followers?/i, /\/messages?/i, /\/feed/i, /\/likes?/i],
    preset: "social-community-forum"
  },
  productivity: {
    patterns: [/\/tasks?/i, /\/projects?/i, /\/teams?/i, /\/notes?/i, /\/workspaces?/i, /\/boards?/i],
    preset: "productivity-task-manager"
  }
}, de = {
  list: [
    { component: "DataTable", category: "patterns", reason: "Display list of items", priority: "primary" },
    { component: "PageHeader", category: "patterns", reason: "Page title and actions", priority: "primary" },
    { component: "Pagination", category: "patterns", reason: "Navigate pages", priority: "secondary" },
    { component: "BulkActionBar", category: "intents", reason: "Bulk operations", priority: "secondary" },
    { component: "EmptyState", category: "intents", reason: "No data state", priority: "secondary" },
    { component: "SmartSearch", category: "intents", reason: "Search functionality", priority: "optional" }
  ],
  get: [
    { component: "Card", category: "atoms", reason: "Content container", priority: "primary" },
    { component: "PageHeader", category: "patterns", reason: "Entity title and actions", priority: "primary" },
    { component: "Tabs", category: "molecules", reason: "Organize sections", priority: "secondary" },
    { component: "StatusTimeline", category: "intents", reason: "Activity history", priority: "optional" },
    { component: "Breadcrumbs", category: "molecules", reason: "Navigation path", priority: "secondary" }
  ],
  create: [
    { component: "SmartForm", category: "forms", reason: "Form with validation", priority: "primary" },
    { component: "PageHeader", category: "patterns", reason: "Form title", priority: "primary" },
    { component: "TextField", category: "forms", reason: "Text inputs", priority: "primary" },
    { component: "SelectField", category: "forms", reason: "Select inputs", priority: "secondary" },
    { component: "FileUploader", category: "patterns", reason: "File uploads", priority: "optional" }
  ],
  update: [
    { component: "SmartForm", category: "forms", reason: "Edit form with validation", priority: "primary" },
    { component: "PageHeader", category: "patterns", reason: "Edit page title", priority: "primary" },
    { component: "ConfirmDialog", category: "patterns", reason: "Confirm changes", priority: "optional" }
  ],
  delete: [
    { component: "ConfirmDestructive", category: "intents", reason: "Confirm deletion", priority: "primary" },
    { component: "Toast", category: "patterns", reason: "Success feedback", priority: "secondary" }
  ]
}, qe = [
  {
    pattern: /\/invite/i,
    components: [
      { component: "InviteMember", category: "intents", reason: "Team invitation", priority: "primary" }
    ]
  },
  {
    pattern: /\/billing|\/usage/i,
    components: [
      { component: "UsageMeter", category: "intents", reason: "Usage display", priority: "primary" },
      { component: "PaymentMethod", category: "intents", reason: "Payment management", priority: "secondary" }
    ]
  },
  {
    pattern: /\/notifications?/i,
    components: [
      { component: "NotificationCenter", category: "intents", reason: "Notification management", priority: "primary" }
    ]
  },
  {
    pattern: /\/analytics|\/metrics|\/dashboard/i,
    components: [
      { component: "AnalyticsDashboard", category: "intents", reason: "Analytics display", priority: "primary" },
      { component: "KpiCard", category: "patterns", reason: "KPI metrics", priority: "secondary" },
      { component: "ChartLine", category: "patterns", reason: "Trend charts", priority: "secondary" }
    ]
  },
  {
    pattern: /\/api-keys?/i,
    components: [
      { component: "ApiKeyManager", category: "intents", reason: "API key management", priority: "primary" }
    ]
  },
  {
    pattern: /\/webhooks?/i,
    components: [
      { component: "WebhookConfigurator", category: "intents", reason: "Webhook setup", priority: "primary" }
    ]
  },
  {
    pattern: /\/audit(-logs?)?|\/activity(-logs?)?/i,
    components: [
      { component: "AuditLogViewer", category: "intents", reason: "Audit log display", priority: "primary" }
    ]
  },
  {
    pattern: /\/import/i,
    components: [
      { component: "DataImportWizard", category: "intents", reason: "Data import", priority: "primary" }
    ]
  },
  {
    pattern: /\/export/i,
    components: [
      { component: "ExportData", category: "intents", reason: "Data export", priority: "primary" }
    ]
  },
  {
    pattern: /\/permissions?|\/roles?/i,
    components: [
      { component: "PermissionManager", category: "intents", reason: "Permission management", priority: "primary" }
    ]
  },
  {
    pattern: /\/calendar|\/schedule|\/appointments?/i,
    components: [
      { component: "SchedulingCalendar", category: "intents", reason: "Calendar view", priority: "primary" }
    ]
  },
  {
    pattern: /\/files?|\/assets?|\/media/i,
    components: [
      { component: "FileAssetManager", category: "intents", reason: "File management", priority: "primary" }
    ]
  },
  {
    pattern: /\/workspaces?|\/tenants?|\/organizations?/i,
    components: [
      { component: "WorkspaceSwitcher", category: "intents", reason: "Workspace switching", priority: "primary" }
    ]
  },
  {
    pattern: /\/settings?|\/preferences?/i,
    components: [
      { component: "PreferencesPanel", category: "intents", reason: "Settings UI", priority: "primary" },
      { component: "SettingsSection", category: "intents", reason: "Settings grouping", priority: "secondary" }
    ]
  },
  {
    pattern: /\/onboarding|\/setup/i,
    components: [
      { component: "OnboardingChecklist", category: "intents", reason: "Setup flow", priority: "primary" },
      { component: "MultiStepWizard", category: "intents", reason: "Multi-step process", priority: "secondary" }
    ]
  },
  {
    pattern: /\/search/i,
    components: [
      { component: "AdvancedSearch", category: "intents", reason: "Advanced search", priority: "primary" },
      { component: "SmartSearch", category: "intents", reason: "Smart search", priority: "secondary" }
    ]
  },
  {
    pattern: /\/templates?/i,
    components: [
      { component: "TemplateGallery", category: "intents", reason: "Template selection", priority: "primary" }
    ]
  },
  {
    pattern: /\/versions?|\/history/i,
    components: [
      { component: "VersionHistory", category: "intents", reason: "Version tracking", priority: "primary" }
    ]
  },
  {
    pattern: /\/changelog|\/releases?/i,
    components: [
      { component: "ChangelogFeed", category: "intents", reason: "Changelog display", priority: "primary" }
    ]
  },
  {
    pattern: /\/feedback/i,
    components: [
      { component: "FeedbackCollector", category: "intents", reason: "Feedback collection", priority: "primary" }
    ]
  },
  {
    pattern: /\/approvals?/i,
    components: [
      { component: "ApprovalRequest", category: "intents", reason: "Approval workflow", priority: "primary" }
    ]
  }
];
function Be(e) {
  const a = e.replace(/^\/api\/(v\d+\/)?/, "/").split("/").filter(Boolean);
  for (const o of a)
    if (!o.startsWith("{") && !o.startsWith(":"))
      return ne(Re(o));
}
function ne(e) {
  return e.replace(/[-_](.)/g, (t, a) => a.toUpperCase()).replace(/^(.)/, (t, a) => a.toUpperCase());
}
function Re(e) {
  return e.endsWith("ies") ? e.slice(0, -3) + "y" : e.endsWith("es") && !e.endsWith("ses") ? e.slice(0, -2) : e.endsWith("s") && !e.endsWith("ss") ? e.slice(0, -1) : e;
}
function je(e) {
  return e.endsWith("y") && !/[aeiou]y$/i.test(e) ? e.slice(0, -1) + "ies" : e.endsWith("s") || e.endsWith("x") || e.endsWith("z") || e.endsWith("ch") || e.endsWith("sh") ? e + "es" : e + "s";
}
function $e(e, t, a) {
  const o = /\{[^}]+\}/.test(t) || /:[\w]+/.test(t);
  switch (e.toUpperCase()) {
    case "GET":
      return o ? "get" : "list";
    case "POST":
      return o || /\/(invite|approve|reject|cancel|submit|publish)/i.test(t) ? "action" : "create";
    case "PUT":
    case "PATCH":
      return "update";
    case "DELETE":
      return "delete";
    default:
      return "unknown";
  }
}
function Me(e) {
  const t = [], a = /\{([^}]+)\}|:(\w+)/g;
  let o;
  for (; (o = a.exec(e)) !== null; )
    t.push(o[1] || o[2]);
  return t;
}
function Ue(e) {
  return e != null && e.parameters ? e.parameters.filter((t) => t.in === "query").map((t) => t.name) : [];
}
function K(e) {
  const t = e.split("/");
  return t[t.length - 1];
}
function oe(e, t = {}) {
  const a = [];
  if (e.$ref) {
    const n = K(e.$ref), s = t[n];
    return s ? oe(s, t) : a;
  }
  if (e.allOf) {
    for (const n of e.allOf)
      a.push(...oe(n, t));
    return a;
  }
  if (!e.properties) return a;
  const o = e.required || [];
  for (const [n, s] of Object.entries(e.properties)) {
    let r = s;
    if (s.$ref) {
      const c = K(s.$ref);
      r = t[c] || s;
    }
    const i = {
      name: n,
      type: r.type || "string",
      format: r.format,
      required: o.includes(n),
      description: r.description,
      enum: r.enum,
      isId: n === "id" || n.endsWith("Id") || n.endsWith("_id"),
      isTimestamp: r.format === "date-time" || r.format === "date" || /(_at|At|_date|Date|timestamp)$/.test(n),
      isReference: n.endsWith("Id") || n.endsWith("_id"),
      referencedEntity: n.endsWith("Id") ? ne(n.slice(0, -2)) : n.endsWith("_id") ? ne(n.slice(0, -3)) : void 0,
      validation: r.minimum !== void 0 || r.maximum !== void 0 || r.minLength !== void 0 || r.maxLength !== void 0 || r.pattern !== void 0 ? {
        min: r.minimum,
        max: r.maximum,
        minLength: r.minLength,
        maxLength: r.maxLength,
        pattern: r.pattern
      } : void 0
    };
    a.push(i);
  }
  return a;
}
function ve(e) {
  var r;
  const t = {};
  for (const [i, c] of Object.entries(ue)) {
    t[i] = { score: 0, matches: [] };
    for (const p of e)
      for (const u of c.patterns)
        if (u.test(p)) {
          t[i].score++, t[i].matches.push(p);
          break;
        }
  }
  let a = "saas", o = 0;
  for (const [i, c] of Object.entries(t))
    c.score > o && (o = c.score, a = i);
  const n = ue[a], s = Math.min(o / 3, 1);
  return {
    presetId: (n == null ? void 0 : n.preset) || "saas-modern-minimal",
    confidence: s,
    reasons: ((r = t[a]) == null ? void 0 : r.matches) || []
  };
}
function we(e, t, a) {
  const o = [];
  for (const { pattern: n, components: s } of qe)
    n.test(e) && o.push(...s);
  if (de[a]) {
    const n = new Set(o.map((s) => s.component));
    for (const s of de[a])
      n.has(s.component) || o.push(s);
  }
  return o;
}
function la(e) {
  var g, h, f, b, y, $, C, P, I, S;
  const t = typeof e.spec == "string" ? JSON.parse(e.spec) : e.spec, a = ((g = t.components) == null ? void 0 : g.schemas) || {}, o = /* @__PURE__ */ new Map(), n = [], s = [];
  for (const [d, k] of Object.entries(t.paths)) {
    s.push(d);
    const w = [
      { method: "GET", operation: k.get },
      { method: "POST", operation: k.post },
      { method: "PUT", operation: k.put },
      { method: "PATCH", operation: k.patch },
      { method: "DELETE", operation: k.delete }
    ].filter((x) => x.operation);
    for (const { method: x, operation: v } of w) {
      if (!v) continue;
      const A = Be(d), E = $e(x, d), ce = Me(d), z = Ue(v);
      let W;
      const J = ((h = v.responses) == null ? void 0 : h["200"]) || ((f = v.responses) == null ? void 0 : f["201"]);
      if ((y = (b = J == null ? void 0 : J.content) == null ? void 0 : b["application/json"]) != null && y.schema) {
        const q = J.content["application/json"].schema;
        q.$ref ? W = K(q.$ref) : ($ = q.items) != null && $.$ref && (W = K(q.items.$ref));
      }
      let pe;
      if ((I = (P = (C = v.requestBody) == null ? void 0 : C.content) == null ? void 0 : P["application/json"]) != null && I.schema) {
        const q = v.requestBody.content["application/json"].schema;
        q.$ref && (pe = K(q.$ref));
      }
      const Pe = v.security && v.security.length > 0 || ((S = t.components) == null ? void 0 : S.securitySchemes) && Object.keys(t.components.securitySchemes).length > 0, Ie = we(d, x, E);
      if (n.push({
        path: d,
        method: x,
        operationId: v.operationId,
        summary: v.summary,
        tags: v.tags || [],
        entity: A,
        operationType: E,
        pathParams: ce,
        queryParams: z,
        requestSchema: pe,
        responseSchema: W,
        requiresAuth: !!Pe,
        suggestedComponents: Ie
      }), A && W) {
        if (!o.has(A)) {
          const D = a[W], le = D ? oe(D, a) : [];
          o.set(A, {
            name: A,
            pluralName: je(A.toLowerCase()),
            description: D == null ? void 0 : D.description,
            fields: le,
            relationships: le.filter((G) => G.isReference && G.referencedEntity).map((G) => ({
              type: "belongsTo",
              relatedEntity: G.referencedEntity,
              fieldName: G.name
            })),
            crudOperations: []
          });
        }
        const q = o.get(A);
        E !== "action" && E !== "unknown" && q.crudOperations.push({
          operation: E,
          method: x,
          path: d,
          operationId: v.operationId,
          hasPathParams: ce.length > 0,
          hasQueryParams: z.length > 0,
          hasPagination: z.some(
            (D) => ["page", "limit", "offset", "pageSize", "per_page"].includes(D)
          ),
          hasFilters: z.some(
            (D) => !["page", "limit", "offset", "pageSize", "per_page", "sort", "order"].includes(D)
          ),
          hasSearch: z.some(
            (D) => ["q", "query", "search", "filter"].includes(D)
          )
        });
      }
    }
  }
  const r = Array.from(o.values()), i = ve(s), c = {};
  for (const d of n)
    if (d.entity) {
      const k = `${d.entity}.${d.operationType}`;
      c[k] || (c[k] = d.suggestedComponents);
    }
  const p = n.some(
    (d) => d.queryParams.some((k) => ["page", "limit", "offset"].includes(k))
  ), u = n.some((d) => d.requiresAuth), l = s.some((d) => /\/upload|\/files?|\/media|\/assets?/i.test(d)), m = s.some((d) => /\/websocket|\/events?|\/stream/i.test(d));
  return {
    apiInfo: {
      title: t.info.title,
      version: t.info.version,
      description: t.info.description,
      baseEndpoints: Array.from(new Set(s.map((d) => "/" + d.split("/").filter(Boolean)[0])))
    },
    entities: r,
    endpoints: n,
    relationships: r.flatMap((d) => d.relationships),
    suggestedPreset: i,
    componentMap: c,
    summary: {
      totalEntities: r.length,
      totalEndpoints: n.length,
      hasPagination: p,
      hasAuth: u,
      hasFileUpload: l,
      hasRealtime: m,
      domainType: i.presetId.split("-")[0]
    }
  };
}
function ua(e) {
  return ve(e);
}
function da(e) {
  const t = $e(e.method, e.endpoint), a = we(e.endpoint, e.method, t);
  return {
    pageType: {
      list: "list-page",
      get: "detail-page",
      create: "form-page",
      update: "form-page",
      delete: "dialog",
      action: "form-page",
      unknown: "custom"
    }[t] || "custom",
    primaryComponents: a.filter((n) => n.priority === "primary"),
    supportingComponents: a.filter((n) => n.priority === "secondary"),
    intentComponents: a.filter((n) => n.category === "intents")
  };
}
function ma(e) {
  const { entity: t, operation: a, hasRelatedEntities: o, hasTabs: n } = e, s = {
    list: {
      pageType: "list-page",
      template: "ListPageTemplate",
      layout: "SidebarLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Page title with actions", priority: "primary" },
        { component: "DataTable", category: "patterns", reason: "Data display", priority: "primary" },
        { component: "SmartSearch", category: "intents", reason: "Search and filter", priority: "secondary" },
        { component: "BulkActionBar", category: "intents", reason: "Bulk operations", priority: "optional" },
        { component: "Pagination", category: "patterns", reason: "Page navigation", priority: "secondary" },
        { component: "EmptyState", category: "intents", reason: "Empty data state", priority: "secondary" }
      ],
      structure: {
        header: ["PageHeader", "SmartSearch"],
        body: ["DataTable", "Pagination", "EmptyState", "BulkActionBar"]
      }
    },
    detail: {
      pageType: "detail-page",
      template: "DetailPageTemplate",
      layout: "SidebarLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Entity title with actions", priority: "primary" },
        { component: "Breadcrumbs", category: "molecules", reason: "Navigation path", priority: "secondary" },
        { component: "Card", category: "atoms", reason: "Content sections", priority: "primary" },
        ...n ? [{ component: "Tabs", category: "molecules", reason: "Section organization", priority: "primary" }] : [],
        ...o ? [{ component: "DataTable", category: "patterns", reason: "Related entities", priority: "secondary" }] : [],
        { component: "StatusTimeline", category: "intents", reason: "Activity history", priority: "optional" }
      ],
      structure: {
        header: ["Breadcrumbs", "PageHeader"],
        body: n ? ["Tabs", "Card"] : ["Card"],
        sidebar: o ? ["DataTable", "StatusTimeline"] : void 0
      }
    },
    create: {
      pageType: "form-page",
      template: "FormPageTemplate",
      layout: "SidebarLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Form title", priority: "primary" },
        { component: "SmartForm", category: "forms", reason: "Form with validation", priority: "primary" },
        { component: "Card", category: "atoms", reason: "Form sections", priority: "primary" },
        { component: "TextField", category: "forms", reason: "Text inputs", priority: "primary" },
        { component: "SelectField", category: "forms", reason: "Select inputs", priority: "secondary" },
        { component: "Button", category: "atoms", reason: "Submit action", priority: "primary" }
      ],
      structure: {
        header: ["PageHeader"],
        body: ["Card", "SmartForm"],
        footer: ["Button"]
      }
    },
    edit: {
      pageType: "form-page",
      template: "FormPageTemplate",
      layout: "SidebarLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Edit form title", priority: "primary" },
        { component: "Breadcrumbs", category: "molecules", reason: "Navigation path", priority: "secondary" },
        { component: "SmartForm", category: "forms", reason: "Edit form", priority: "primary" },
        { component: "Card", category: "atoms", reason: "Form sections", priority: "primary" },
        { component: "ConfirmDialog", category: "patterns", reason: "Discard changes", priority: "optional" }
      ],
      structure: {
        header: ["Breadcrumbs", "PageHeader"],
        body: ["Card", "SmartForm"],
        footer: ["Button"]
      }
    },
    settings: {
      pageType: "settings-page",
      template: "SettingsLayout",
      layout: "SettingsLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Settings title", priority: "primary" },
        { component: "Tabs", category: "molecules", reason: "Settings categories", priority: "primary" },
        { component: "SettingsSection", category: "intents", reason: "Settings groups", priority: "primary" },
        { component: "PreferencesPanel", category: "intents", reason: "Preferences UI", priority: "secondary" }
      ],
      structure: {
        header: ["PageHeader"],
        body: ["Tabs", "SettingsSection"],
        sidebar: ["PreferencesPanel"]
      }
    },
    dashboard: {
      pageType: "dashboard-page",
      template: "DashboardTemplate",
      layout: "SidebarLayout",
      components: [
        { component: "PageHeader", category: "patterns", reason: "Dashboard title", priority: "primary" },
        { component: "AnalyticsDashboard", category: "intents", reason: "Analytics display", priority: "primary" },
        { component: "KpiCard", category: "patterns", reason: "KPI metrics", priority: "primary" },
        { component: "ChartLine", category: "patterns", reason: "Trend charts", priority: "secondary" },
        { component: "ChartBar", category: "patterns", reason: "Comparison charts", priority: "secondary" },
        { component: "Grid", category: "primitives", reason: "Layout grid", priority: "primary" }
      ],
      structure: {
        header: ["PageHeader"],
        body: ["Grid", "KpiCard", "ChartLine", "ChartBar"]
      }
    }
  };
  return s[a] || s.list;
}
const me = {
  string: "string",
  number: "number",
  integer: "number",
  boolean: "boolean",
  object: "Record<string, unknown>",
  array: "unknown[]"
}, ge = {
  date: "string",
  // ISO date string
  "date-time": "string",
  // ISO datetime string
  time: "string",
  email: "string",
  uri: "string",
  uuid: "string",
  binary: "Blob",
  byte: "string",
  // base64
  int32: "number",
  int64: "number",
  float: "number",
  double: "number",
  password: "string"
};
function B(e) {
  const t = e.split("/");
  return t[t.length - 1];
}
function R(e) {
  return e.replace(/[-_.](.)/g, (t, a) => a.toUpperCase()).replace(/^(.)/, (t, a) => a.toUpperCase());
}
function ke(e) {
  const t = R(e);
  return t.charAt(0).toLowerCase() + t.slice(1);
}
function re(e, t = "") {
  const a = [];
  return e.description && (a.push(`${t}/**`), a.push(`${t} * ${e.description}`), e.example !== void 0 && a.push(`${t} * @example ${JSON.stringify(e.example)}`), e.default !== void 0 && a.push(`${t} * @default ${JSON.stringify(e.default)}`), a.push(`${t} */`)), a.join(`
`);
}
function N(e, t, a = 0) {
  if (e.$ref)
    return B(e.$ref);
  if (e.allOf)
    return e.allOf.map((s) => N(s, t, a)).join(" & ");
  if (e.oneOf || e.anyOf)
    return (e.oneOf || e.anyOf || []).map((r) => N(r, t, a)).join(" | ");
  if (e.enum)
    return e.enum.map((n) => JSON.stringify(n)).join(" | ");
  const o = e.nullable ? " | null" : "";
  return e.type === "array" ? e.items ? `${N(e.items, t, a)}[]${o}` : `unknown[]${o}` : e.type === "object" && e.additionalProperties ? typeof e.additionalProperties == "boolean" ? `Record<string, unknown>${o}` : `Record<string, ${N(e.additionalProperties, t, a)}>${o}` : e.type === "object" && e.properties && a < 3 ? `{ ${Object.entries(e.properties).map(([s, r]) => {
    var p;
    const i = (p = e.required) != null && p.includes(s) ? "" : "?", c = N(r, t, a + 1);
    return `${s}${i}: ${c}`;
  }).join("; ")} }${o}` : e.format && ge[e.format] ? ge[e.format] + o : e.type && me[e.type] ? me[e.type] + o : "unknown" + o;
}
function Y(e, t, a, o) {
  var r, i, c;
  const n = [];
  if (t.description && (n.push("/**"), n.push(` * ${t.description}`), n.push(" */")), t.allOf) {
    const p = [], u = [];
    for (const l of t.allOf)
      l.$ref ? p.push(B(l.$ref)) : l.properties && u.push(l);
    if (p.length > 0 && u.length === 0)
      n.push(`export interface ${e} extends ${p.join(", ")} {}`);
    else if (p.length > 0) {
      n.push(`export interface ${e} extends ${p.join(", ")} {`);
      for (const l of u)
        if (l.properties)
          for (const [m, g] of Object.entries(l.properties)) {
            const h = (r = l.required) != null && r.includes(m) ? "" : "?", f = re(g, "  ");
            f && n.push(f), n.push(`  ${m}${h}: ${N(g, a)};`);
          }
      n.push("}");
    } else {
      n.push(`export interface ${e} {`);
      for (const l of u)
        if (l.properties)
          for (const [m, g] of Object.entries(l.properties)) {
            const h = (i = l.required) != null && i.includes(m) ? "" : "?", f = re(g, "  ");
            f && n.push(f), n.push(`  ${m}${h}: ${N(g, a)};`);
          }
      n.push("}");
    }
    return n.join(`
`);
  }
  if (t.oneOf || t.anyOf) {
    const u = (t.oneOf || t.anyOf || []).map((l) => l.$ref ? B(l.$ref) : N(l, a));
    return n.push(`export type ${e} = ${u.join(" | ")};`), n.join(`
`);
  }
  if (t.enum) {
    if (o.enumStyle === "enum") {
      n.push(`export enum ${e} {`);
      for (const p of t.enum) {
        const u = String(p).replace(/[^a-zA-Z0-9_]/g, "_").toUpperCase();
        n.push(`  ${u} = ${JSON.stringify(p)},`);
      }
      n.push("}");
    } else {
      const p = t.enum.map((u) => JSON.stringify(u)).join(" | ");
      n.push(`export type ${e} = ${p};`);
    }
    return n.join(`
`);
  }
  if (t.properties) {
    n.push(`export interface ${e} {`);
    for (const [p, u] of Object.entries(t.properties)) {
      const l = (c = t.required) != null && c.includes(p) ? "" : "?", m = u.readOnly ? "readonly " : "", g = re(u, "  ");
      g && n.push(g), n.push(`  ${m}${p}${l}: ${N(u, a)};`);
    }
    return n.push("}"), n.join(`
`);
  }
  const s = N(t, a);
  return n.push(`export type ${e} = ${s};`), n.join(`
`);
}
function Se(e) {
  var a, o, n, s, r, i, c, p, u, l, m, g, h, f, b, y, $;
  const t = {};
  if (!e.paths) return t;
  for (const [C, P] of Object.entries(e.paths)) {
    const I = ["get", "post", "put", "patch", "delete"];
    for (const S of I) {
      const d = P[S];
      if (!d) continue;
      const k = d.operationId || `${S}${C.replace(/[^a-zA-Z0-9]/g, "")}`, w = R(k);
      if ((n = (o = (a = d.requestBody) == null ? void 0 : a.content) == null ? void 0 : o["application/json"]) != null && n.schema) {
        const v = d.requestBody.content["application/json"].schema;
        !v.$ref && v.properties && (t[`${w}Request`] = v);
      }
      const x = ((s = d.responses) == null ? void 0 : s["200"]) || ((r = d.responses) == null ? void 0 : r["201"]);
      if ((c = (i = x == null ? void 0 : x.content) == null ? void 0 : i["application/json"]) != null && c.schema) {
        const v = x.content["application/json"].schema;
        !v.$ref && v.properties && (t[`${w}Response`] = v), !v.$ref && v.type === "array" && v.items && !v.items.$ref && v.items.properties && (t[`${w}Item`] = v.items);
      }
    }
  }
  for (const [C, P] of Object.entries(e.paths || {})) {
    const I = C.match(/\/v1\/([a-z-]+)(?:\/\{[^}]+\})?$/i);
    if (!I) continue;
    const S = R(I[1].replace(/-/g, "_")), d = S.endsWith("s") ? S.slice(0, -1) : S;
    if (t[d]) continue;
    const k = P.post, w = P.get;
    if ((m = (l = (u = (p = w == null ? void 0 : w.responses) == null ? void 0 : p["200"]) == null ? void 0 : u.content) == null ? void 0 : l["application/json"]) != null && m.schema) {
      const x = w.responses[200].content["application/json"].schema;
      (f = (h = (g = x.properties) == null ? void 0 : g.data) == null ? void 0 : h.items) != null && f.properties && (t[d] = x.properties.data.items);
    }
    if (!t[d] && (($ = (y = (b = k == null ? void 0 : k.requestBody) == null ? void 0 : b.content) == null ? void 0 : y["application/json"]) != null && $.schema)) {
      const x = k.requestBody.content["application/json"].schema;
      x.properties && !x.$ref && (t[`Create${d}Request`] = x);
    }
  }
  return t;
}
function He(e) {
  const t = {};
  for (const [a, o] of Object.entries(e))
    if (o.properties) {
      for (const [n, s] of Object.entries(o.properties))
        if (s.enum && s.type === "string") {
          const r = R(`${a}_${n}`);
          t[r] || (t[r] = s);
        }
    }
  return t;
}
function Oe(e, t) {
  var o, n, s, r, i, c, p, u;
  const a = [];
  if (!e.paths) return a;
  for (const [l, m] of Object.entries(e.paths)) {
    const g = ["get", "post", "put", "patch", "delete"];
    for (const h of g) {
      const f = m[h];
      if (!f) continue;
      const b = {
        operationId: f.operationId || `${h}${l.replace(/[^a-zA-Z0-9]/g, "")}`,
        method: h.toUpperCase(),
        path: l
      };
      if ((s = (n = (o = f.requestBody) == null ? void 0 : o.content) == null ? void 0 : n["application/json"]) != null && s.schema) {
        const $ = f.requestBody.content["application/json"].schema;
        $.$ref ? b.requestType = B($.$ref) : $.properties && (b.requestSchema = $, b.requestType = `${R(b.operationId)}Request`);
      }
      const y = ((r = f.responses) == null ? void 0 : r["200"]) || ((i = f.responses) == null ? void 0 : i["201"]);
      if ((p = (c = y == null ? void 0 : y.content) == null ? void 0 : c["application/json"]) != null && p.schema) {
        const $ = y.content["application/json"].schema;
        $.$ref ? b.responseType = B($.$ref) : (u = $.items) != null && u.$ref ? b.responseType = `${B($.items.$ref)}[]` : $.properties && (b.responseSchema = $, b.responseType = `${R(b.operationId)}Response`);
      }
      a.push(b);
    }
  }
  return a;
}
function ga(e) {
  var g;
  const t = typeof e.spec == "string" ? JSON.parse(e.spec) : e.spec;
  let a = ((g = t.components) == null ? void 0 : g.schemas) || {};
  const o = Object.keys(a).length > 0;
  o || (a = Se(t));
  const n = He(a), s = {}, r = [], i = e.typePrefix || "", c = e.typeSuffix || "";
  for (const [h, f] of Object.entries(n)) {
    const b = `${i}${h}${c}`;
    if (!s[b]) {
      const y = Y(b, f, a, {
        ...e,
        enumStyle: e.enumStyle || "union"
      });
      s[b] = y, r.push(b);
    }
  }
  for (const [h, f] of Object.entries(a)) {
    const b = `${i}${h}${c}`;
    if (!s[b]) {
      const y = Y(b, f, a, {
        ...e,
        enumStyle: e.enumStyle || "union"
      });
      s[b] = y, r.push(b);
    }
  }
  const p = Oe(t);
  if (e.includeOperationTypes !== !1)
    for (const h of p) {
      if (h.requestSchema && h.requestType) {
        const f = h.requestType;
        if (!s[f]) {
          const b = Y(f, h.requestSchema, a, {
            ...e,
            enumStyle: e.enumStyle || "union"
          });
          s[f] = b, r.push(f);
        }
      } else if (h.requestType && !s[h.requestType]) {
        const f = `${R(h.operationId)}Request`;
        !s[f] && s[h.requestType] && (s[f] = `export type ${f} = ${h.requestType};`, r.push(f));
      }
      if (h.responseSchema && h.responseType) {
        const f = h.responseType;
        if (!s[f]) {
          const b = Y(f, h.responseSchema, a, {
            ...e,
            enumStyle: e.enumStyle || "union"
          });
          s[f] = b, r.push(f);
        }
      } else if (h.responseType && !s[h.responseType]) {
        const f = `${R(h.operationId)}Response`;
        !s[f] && s[h.responseType] && (s[f] = `export type ${f} = ${h.responseType};`, r.push(f));
      }
    }
  const u = o ? "" : ` * Note: Types were derived from path request/response bodies (no components/schemas found)
`;
  return {
    code: `/**
 * Auto-generated TypeScript types from OpenAPI specification
 * Generated at: ${(/* @__PURE__ */ new Date()).toISOString()}
 *
${u} * DO NOT EDIT MANUALLY
 */

` + Object.values(s).join(`

`),
    types: s,
    typeNames: r,
    operations: p
  };
}
function U(e) {
  const t = [];
  if (e.$ref && t.push(B(e.$ref)), e.allOf)
    for (const a of e.allOf)
      t.push(...U(a));
  if (e.oneOf)
    for (const a of e.oneOf)
      t.push(...U(a));
  if (e.anyOf)
    for (const a of e.anyOf)
      t.push(...U(a));
  if (e.type === "array" && e.items && t.push(...U(e.items)), e.type === "object" && e.properties)
    for (const a of Object.values(e.properties))
      t.push(...U(a));
  return e.additionalProperties && typeof e.additionalProperties == "object" && t.push(...U(e.additionalProperties)), t;
}
function ze(e) {
  const t = Object.keys(e), a = /* @__PURE__ */ new Set(), o = [], n = /* @__PURE__ */ new Map();
  for (const [r, i] of Object.entries(e)) {
    const c = U(i).filter(
      (p) => t.includes(p) && p !== r
    );
    n.set(r, c);
  }
  function s(r) {
    if (a.has(r)) return;
    a.add(r);
    const i = n.get(r) || [];
    for (const c of i)
      s(c);
    o.push(r);
  }
  for (const r of t)
    s(r);
  return o;
}
function O(e, t) {
  if (e.$ref) {
    const a = B(e.$ref);
    return `${ke(a)}Schema`;
  }
  if (e.allOf)
    return e.allOf.map((o) => O(o)).reduce(
      (o, n, s) => s === 0 ? n : `${o}.merge(${n})`
    );
  if (e.oneOf || e.anyOf)
    return `z.union([${(e.oneOf || e.anyOf || []).map((n) => O(n)).join(", ")}])`;
  if (e.enum)
    return `z.enum([${e.enum.map((o) => JSON.stringify(o)).join(", ")}])`;
  if (e.type === "array")
    return `z.array(${e.items ? O(e.items) : "z.unknown()"})`;
  if (e.type === "object")
    return e.additionalProperties ? `z.record(${typeof e.additionalProperties == "object" ? O(e.additionalProperties) : "z.unknown()"})` : e.properties ? `z.object({
${Object.entries(e.properties).map(([o, n]) => {
      var r;
      let s = O(n);
      return (r = e.required) != null && r.includes(o) || (s = `${s}.optional()`), n.nullable && (s = `${s}.nullable()`), `  ${o}: ${s}`;
    }).join(`,
`)}
})` : "z.record(z.unknown())";
  if (e.type === "string") {
    let a = "z.string()";
    return e.format === "email" ? a = "z.string().email()" : e.format === "uuid" ? a = "z.string().uuid()" : e.format === "uri" ? a = "z.string().url()" : e.format === "date-time" && (a = "z.string().datetime()"), e.minLength !== void 0 && (a = `${a}.min(${e.minLength})`), e.maxLength !== void 0 && (a = `${a}.max(${e.maxLength})`), e.pattern && (a = `${a}.regex(/${e.pattern}/)`), a;
  }
  if (e.type === "number" || e.type === "integer") {
    let a = e.type === "integer" ? "z.number().int()" : "z.number()";
    return e.minimum !== void 0 && (a = `${a}.min(${e.minimum})`), e.maximum !== void 0 && (a = `${a}.max(${e.maximum})`), a;
  }
  return e.type === "boolean" ? "z.boolean()" : "z.unknown()";
}
function ya(e) {
  var h;
  const t = typeof e.spec == "string" ? JSON.parse(e.spec) : e.spec;
  let a = ((h = t.components) == null ? void 0 : h.schemas) || {};
  const o = Object.keys(a).length > 0;
  o || (a = Se(t));
  const n = {}, s = [], r = e.schemaPrefix || "", i = e.schemaSuffix || "Schema", c = ze(a);
  for (const f of c) {
    const b = a[f], y = `${r}${ke(f)}${i}`, $ = O(b), C = b.description ? `/**
 * ${b.description}
 */
` : "";
    n[y] = `${C}export const ${y} = ${$};`, s.push(y);
  }
  const p = s.map((f) => `export type ${f.replace(/Schema$/, "")} = z.infer<typeof ${f}>;`).join(`
`), u = o ? "" : ` * Note: Schemas were derived from path request/response bodies (no components/schemas found)
`, l = `/**
 * Auto-generated Zod schemas from OpenAPI specification
 * Generated at: ${(/* @__PURE__ */ new Date()).toISOString()}
 *
${u} * DO NOT EDIT MANUALLY
 */

import { z } from 'zod';

`, m = s.map((f) => n[f]).join(`

`);
  return {
    code: l + m + `

// Type inference
` + p,
    schemas: n,
    schemaNames: s
  };
}
function xe(e) {
  return e.replace(/[-_./](.)/g, (t, a) => a.toUpperCase()).replace(/^(.)/, (t, a) => a.toUpperCase());
}
function j(e) {
  const t = xe(e);
  return t.charAt(0).toLowerCase() + t.slice(1);
}
function We(e) {
  return e.endsWith("ies") ? e.slice(0, -3) + "y" : e.endsWith("es") && !e.endsWith("ses") ? e.slice(0, -2) : e.endsWith("s") && !e.endsWith("ss") ? e.slice(0, -1) : e;
}
function M(e) {
  return e.endsWith("y") && !/[aeiou]y$/i.test(e) ? e.slice(0, -1) + "ies" : e.endsWith("s") || e.endsWith("x") || e.endsWith("z") || e.endsWith("ch") || e.endsWith("sh") ? e + "es" : e + "s";
}
function Ge(e) {
  const a = e.replace(/^\/api\/(v\d+\/)?/, "/").replace(/^\/v\d+\//, "/").split("/").filter(Boolean);
  for (const o of a)
    if (!(o.startsWith("{") || o.startsWith(":")) && !["public", "api", "auth", "admin", "internal"].includes(o.toLowerCase()))
      return xe(We(o));
}
function Q(e) {
  const t = [], a = /\{([^}]+)\}|:(\w+)/g;
  let o;
  for (; (o = a.exec(e)) !== null; )
    t.push(o[1] || o[2]);
  return t;
}
function se(e) {
  const t = e.split("/");
  return t[t.length - 1];
}
function Ke(e, t) {
  const a = /\{[^}]+\}/.test(t) || /:[\w]+/.test(t);
  switch (e.toUpperCase()) {
    case "GET":
      return a ? "get" : "list";
    case "POST":
      return a || /\/(invite|approve|reject|cancel|submit|publish)/i.test(t) ? "action" : "create";
    case "PUT":
    case "PATCH":
      return "update";
    case "DELETE":
      return "delete";
    default:
      return "action";
  }
}
function Ve(e, t) {
  var n, s, r;
  const a = [
    "/**",
    " * Auto-generated TypeScript types from OpenAPI specification",
    ` * Generated at: ${(/* @__PURE__ */ new Date()).toISOString()}`,
    " *",
    " * These types are used by the generated API hooks.",
    " * DO NOT EDIT MANUALLY",
    " */",
    ""
  ], o = ((n = t.components) == null ? void 0 : n.schemas) || {};
  for (const i of e) {
    const c = Object.keys(o).find(
      (u) => u.toLowerCase() === i.toLowerCase()
    ), p = c ? o[c] : null;
    if (p && p.properties) {
      a.push(`export interface ${i} {`), a.push("  id: string;");
      for (const [u, l] of Object.entries(p.properties)) {
        if (u === "id") continue;
        const m = V(l), g = (s = p.required) == null ? void 0 : s.includes(u);
        a.push(`  ${u}${g ? "" : "?"}: ${m};`);
      }
      a.push("}");
    } else
      a.push(`export interface ${i} {`), a.push("  id: string;"), a.push("  created_at?: string;"), a.push("  updated_at?: string;"), a.push("  [key: string]: unknown;"), a.push("}");
    if (a.push(""), a.push(`export interface Create${i}Input {`), p && p.properties)
      for (const [u, l] of Object.entries(p.properties)) {
        if (["id", "created_at", "updated_at"].includes(u)) continue;
        const m = V(l), g = (r = p.required) == null ? void 0 : r.includes(u);
        a.push(`  ${u}${g ? "" : "?"}: ${m};`);
      }
    else
      a.push("  [key: string]: unknown;");
    if (a.push("}"), a.push(""), a.push(`export interface Update${i}Input {`), p && p.properties)
      for (const [u, l] of Object.entries(p.properties)) {
        if (["id", "created_at", "updated_at"].includes(u)) continue;
        const m = V(l);
        a.push(`  ${u}?: ${m};`);
      }
    else
      a.push("  [key: string]: unknown;");
    a.push("}"), a.push("");
  }
  return a.join(`
`);
}
function V(e) {
  if (e.$ref)
    return se(e.$ref);
  switch (e.type) {
    case "string":
      return "string";
    case "number":
    case "integer":
      return "number";
    case "boolean":
      return "boolean";
    case "array":
      return e.items ? `${V(e.items)}[]` : "unknown[]";
    case "object":
      return e.properties ? `{ ${Object.entries(e.properties).map(([a, o]) => `${a}: ${V(o)}`).join("; ")} }` : "Record<string, unknown>";
    default:
      return "unknown";
  }
}
function Qe(e, t, a, o) {
  var l;
  const n = `use${e}List`, s = j(M(e)), r = o.fetchFn || "apiFetch";
  o.typesImportPath;
  const i = ((l = a.parameters) == null ? void 0 : l.filter((m) => m.in === "query")) || [], c = i.length > 0, p = c ? `{ ${i.map((m) => {
    var g, h;
    return `${m.name}${m.required ? "" : "?"}: ${((g = m.schema) == null ? void 0 : g.type) === "number" || ((h = m.schema) == null ? void 0 : h.type) === "integer" ? "number" : "string"}`;
  }).join("; ")} }` : "void", u = `/**
 * Fetch list of ${M(e.toLowerCase())}
 */
export function ${n}(${c ? `params?: ${p}` : ""}) {
  return useQuery({
    queryKey: ['${s}'${c ? ", params" : ""}],
    queryFn: async () => {
      const response = await ${r}<${e}[]>('${t}'${c ? ", { params }" : ""});
      return response;
    },
  });
}`;
  return {
    name: n,
    type: "query",
    entity: e,
    operation: "list",
    code: u,
    imports: ["useQuery"]
  };
}
function Je(e, t, a, o) {
  const n = `use${e}ListInfinite`, s = j(M(e)), r = o.fetchFn || "apiFetch", i = `/**
 * Fetch paginated list of ${M(e.toLowerCase())} with infinite scroll
 */
export function ${n}(params?: { pageSize?: number }) {
  const pageSize = params?.pageSize ?? 20;

  return useInfiniteQuery({
    queryKey: ['${s}', 'infinite', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await ${r}<{ data: ${e}[]; total: number; page: number }>('${t}', {
        params: { page: pageParam, limit: pageSize },
      });
      return response;
    },
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage.total / pageSize);
      const nextPage = allPages.length + 1;
      return nextPage <= totalPages ? nextPage : undefined;
    },
    initialPageParam: 1,
  });
}`;
  return {
    name: n,
    type: "infinite",
    entity: e,
    operation: "list",
    code: i,
    imports: ["useInfiniteQuery"]
  };
}
function Ye(e, t, a, o) {
  const n = `use${e}`, s = j(e), r = o.fetchFn || "apiFetch", c = Q(t).find((l) => l === "id" || l.endsWith("Id")) || "id", p = t.replace(/\{([^}]+)\}/g, "${$1}").replace(/:(\w+)/g, "${$1}"), u = `/**
 * Fetch a single ${e.toLowerCase()} by ID
 */
export function ${n}(${c}: string | undefined) {
  return useQuery({
    queryKey: ['${s}', ${c}],
    queryFn: async () => {
      const response = await ${r}<${e}>(\`${p}\`);
      return response;
    },
    enabled: !!${c},
  });
}`;
  return {
    name: n,
    type: "query",
    entity: e,
    operation: "get",
    code: u,
    imports: ["useQuery"]
  };
}
function Ze(e, t, a, o) {
  var u, l, m, g;
  const n = `useCreate${e}`, s = j(M(e)), r = o.fetchFn || "apiFetch";
  let i = `Create${e}Input`;
  (g = (m = (l = (u = a.requestBody) == null ? void 0 : u.content) == null ? void 0 : l["application/json"]) == null ? void 0 : m.schema) != null && g.$ref && (i = se(a.requestBody.content["application/json"].schema.$ref));
  const c = o.optimisticUpdates !== !1 ? `
    onMutate: async (newData) => {
      // Cancel outgoing queries
      await queryClient.cancelQueries({ queryKey: ['${s}'] });

      // Snapshot previous value
      const previous = queryClient.getQueryData<${e}[]>(['${s}']);

      // Optimistically update
      queryClient.setQueryData<${e}[]>(['${s}'], (old) => [
        ...(old || []),
        { ...newData, id: 'temp-' + Date.now() } as ${e},
      ]);

      return { previous };
    },
    onError: (_err, _newData, context) => {
      // Rollback on error
      if (context?.previous) {
        queryClient.setQueryData(['${s}'], context.previous);
      }
    },
    onSettled: () => {
      // Refetch after mutation
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },` : `
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },`, p = `/**
 * Create a new ${e.toLowerCase()}
 */
export function ${n}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ${i}) => {
      const response = await ${r}<${e}>('${t}', {
        method: 'POST',
        body: data,
      });
      return response;
    },${c}
  });
}`;
  return {
    name: n,
    type: "mutation",
    entity: e,
    operation: "create",
    code: p,
    imports: ["useMutation", "useQueryClient"]
  };
}
function Xe(e, t, a, o) {
  var h, f, b, y;
  const n = `useUpdate${e}`, s = j(M(e)), r = j(e), i = o.fetchFn || "apiFetch", p = Q(t).find(($) => $ === "id" || $.endsWith("Id")) || "id";
  let u = `Update${e}Input`;
  (y = (b = (f = (h = a.requestBody) == null ? void 0 : h.content) == null ? void 0 : f["application/json"]) == null ? void 0 : b.schema) != null && y.$ref && (u = se(a.requestBody.content["application/json"].schema.$ref));
  const l = t.replace(/\{([^}]+)\}/g, "${$1}").replace(/:(\w+)/g, "${$1}"), m = o.optimisticUpdates !== !1 ? `
    onMutate: async ({ ${p}, data }) => {
      // Cancel outgoing queries
      await queryClient.cancelQueries({ queryKey: ['${r}', ${p}] });
      await queryClient.cancelQueries({ queryKey: ['${s}'] });

      // Snapshot previous values
      const previousItem = queryClient.getQueryData<${e}>(['${r}', ${p}]);
      const previousList = queryClient.getQueryData<${e}[]>(['${s}']);

      // Optimistically update single item
      queryClient.setQueryData<${e}>(['${r}', ${p}], (old) =>
        old ? { ...old, ...data } : old
      );

      // Optimistically update list
      queryClient.setQueryData<${e}[]>(['${s}'], (old) =>
        old?.map((item) => (item.id === ${p} ? { ...item, ...data } : item))
      );

      return { previousItem, previousList };
    },
    onError: (_err, { ${p} }, context) => {
      // Rollback on error
      if (context?.previousItem) {
        queryClient.setQueryData(['${r}', ${p}], context.previousItem);
      }
      if (context?.previousList) {
        queryClient.setQueryData(['${s}'], context.previousList);
      }
    },
    onSettled: (_data, _err, { ${p} }) => {
      // Refetch after mutation
      queryClient.invalidateQueries({ queryKey: ['${r}', ${p}] });
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },` : `
    onSuccess: (_data, { ${p} }) => {
      queryClient.invalidateQueries({ queryKey: ['${r}', ${p}] });
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },`, g = `/**
 * Update an existing ${e.toLowerCase()}
 */
export function ${n}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ ${p}, data }: { ${p}: string; data: Partial<${u}> }) => {
      const response = await ${i}<${e}>(\`${l}\`, {
        method: 'PATCH',
        body: data,
      });
      return response;
    },${m}
  });
}`;
  return {
    name: n,
    type: "mutation",
    entity: e,
    operation: "update",
    code: g,
    imports: ["useMutation", "useQueryClient"]
  };
}
function et(e, t, a, o) {
  const n = `useDelete${e}`, s = j(M(e)), r = j(e), i = o.fetchFn || "apiFetch", p = Q(t).find((g) => g === "id" || g.endsWith("Id")) || "id", u = t.replace(/\{([^}]+)\}/g, "${$1}").replace(/:(\w+)/g, "${$1}"), l = o.optimisticUpdates !== !1 ? `
    onMutate: async (${p}) => {
      // Cancel outgoing queries
      await queryClient.cancelQueries({ queryKey: ['${s}'] });

      // Snapshot previous value
      const previous = queryClient.getQueryData<${e}[]>(['${s}']);

      // Optimistically remove from list
      queryClient.setQueryData<${e}[]>(['${s}'], (old) =>
        old?.filter((item) => item.id !== ${p})
      );

      // Remove single item cache
      queryClient.removeQueries({ queryKey: ['${r}', ${p}] });

      return { previous };
    },
    onError: (_err, _${p}, context) => {
      // Rollback on error
      if (context?.previous) {
        queryClient.setQueryData(['${s}'], context.previous);
      }
    },
    onSettled: () => {
      // Refetch after mutation
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },` : `
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },`, m = `/**
 * Delete a ${e.toLowerCase()}
 */
export function ${n}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (${p}: string) => {
      await ${i}<void>(\`${u}\`, {
        method: 'DELETE',
      });
    },${l}
  });
}`;
  return {
    name: n,
    type: "mutation",
    entity: e,
    operation: "delete",
    code: m,
    imports: ["useMutation", "useQueryClient"]
  };
}
function tt(e, t, a, o) {
  var p;
  const n = `use${e}List`, s = o.fetchFn || "apiFetch", i = (((p = a.parameters) == null ? void 0 : p.filter((u) => u.in === "query")) || []).length > 0, c = `/**
 * Fetch list of ${M(e.toLowerCase())}
 */
export function ${n}(${i ? "params?: Record<string, string>" : ""}) {
  const key = ${i ? `params ? ['${t}', params] : null` : `'${t}'`};

  const { data, error, isLoading, mutate } = useSWR<${e}[]>(
    key,
    ([url, params]) => ${s}(url, { params })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}`;
  return {
    name: n,
    type: "query",
    entity: e,
    operation: "list",
    code: c,
    imports: ["useSWR"]
  };
}
function at(e, t, a, o) {
  const n = `use${e}`, s = o.fetchFn || "apiFetch", i = Q(t).find((u) => u === "id" || u.endsWith("Id")) || "id", c = t.replace(/\{([^}]+)\}/g, "${$1}").replace(/:(\w+)/g, "${$1}"), p = `/**
 * Fetch a single ${e.toLowerCase()} by ID
 */
export function ${n}(${i}: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<${e}>(
    ${i} ? \`${c}\` : null,
    ${s}
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}`;
  return {
    name: n,
    type: "query",
    entity: e,
    operation: "get",
    code: p,
    imports: ["useSWR"]
  };
}
function rt(e, t, a, o, n) {
  const s = n.fetchFn || "apiFetch", i = Q(t).find((l) => l === "id" || l.endsWith("Id")) || "id", c = t.replace(/\{([^}]+)\}/g, "${$1}").replace(/:(\w+)/g, "${$1}");
  let p, u;
  switch (o) {
    case "create":
      p = `useCreate${e}`, u = `/**
 * Create a new ${e.toLowerCase()}
 */
export function ${p}() {
  const { trigger, isMutating, error } = useSWRMutation<${e}, Error, string, Create${e}Input>(
    '${t}',
    (url, { arg }) => ${s}(url, { method: 'POST', body: arg })
  );

  return {
    create: trigger,
    isCreating: isMutating,
    error,
  };
}`;
      break;
    case "update":
      p = `useUpdate${e}`, u = `/**
 * Update an existing ${e.toLowerCase()}
 */
export function ${p}(${i}: string) {
  const { trigger, isMutating, error } = useSWRMutation<${e}, Error, string, Partial<Update${e}Input>>(
    \`${c}\`,
    (url, { arg }) => ${s}(url, { method: 'PATCH', body: arg })
  );

  return {
    update: trigger,
    isUpdating: isMutating,
    error,
  };
}`;
      break;
    case "delete":
      p = `useDelete${e}`, u = `/**
 * Delete a ${e.toLowerCase()}
 */
export function ${p}(${i}: string) {
  const { trigger, isMutating, error } = useSWRMutation<void, Error, string>(
    \`${c}\`,
    (url) => ${s}(url, { method: 'DELETE' })
  );

  return {
    delete: trigger,
    isDeleting: isMutating,
    error,
  };
}`;
      break;
  }
  return {
    name: p,
    type: "mutation",
    entity: e,
    operation: o,
    code: u,
    imports: ["useSWRMutation"]
  };
}
function fa(e) {
  const t = typeof e.spec == "string" ? JSON.parse(e.spec) : e.spec, a = e.library || "tanstack-query", o = [], n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
  for (const [y, $] of Object.entries(t.paths)) {
    const C = [
      { method: "GET", operation: $.get },
      { method: "POST", operation: $.post },
      { method: "PUT", operation: $.put },
      { method: "PATCH", operation: $.patch },
      { method: "DELETE", operation: $.delete }
    ].filter((P) => P.operation);
    for (const { method: P, operation: I } of C) {
      if (!I) continue;
      const S = Ge(y);
      if (!S) continue;
      n.add(S);
      const d = Ke(P, y), k = `${S}:${d}`;
      if (r.has(k)) continue;
      r.add(k);
      let w = null;
      if (a === "tanstack-query")
        switch (d) {
          case "list":
            if (w = Qe(S, y, I, e), o.push(w), w.imports.forEach((x) => s.add(x)), e.infiniteQueries !== !1) {
              const x = Je(S, y, I, e);
              o.push(x), x.imports.forEach((v) => s.add(v));
            }
            break;
          case "get":
            w = Ye(S, y, I, e);
            break;
          case "create":
            w = Ze(S, y, I, e);
            break;
          case "update":
            w = Xe(S, y, I, e);
            break;
          case "delete":
            w = et(S, y, I, e);
            break;
        }
      else
        switch (d) {
          case "list":
            w = tt(S, y, I, e);
            break;
          case "get":
            w = at(S, y, I, e);
            break;
          case "create":
          case "update":
          case "delete":
            w = rt(S, y, I, d, e);
            break;
        }
      w && d !== "list" && (o.push(w), w.imports.forEach((x) => s.add(x)));
    }
  }
  const i = Array.from(s), c = e.typesImportPath || "./types", p = e.baseUrlVar || "API_BASE_URL", u = e.fetchFn || "apiFetch", l = a === "tanstack-query" ? `import { ${i.join(", ")} } from '@tanstack/react-query';` : `import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';`, m = Array.from(n), h = `/**
 * Auto-generated API hooks from OpenAPI specification
 * Generated at: ${(/* @__PURE__ */ new Date()).toISOString()}
 *
 * DO NOT EDIT MANUALLY
 */

${l}
import type { ${m.join(", ")}${m.map((y) => `, Create${y}Input, Update${y}Input`).join("")} } from '${c}';

const ${p} = process.env.NEXT_PUBLIC_API_URL || '';

/**
 * Generic fetch wrapper
 */
async function ${u}<T>(
  url: string,
  options?: {
    method?: string;
    body?: unknown;
    params?: Record<string, string | number | undefined>;
  }
): Promise<T> {
  const { method = 'GET', body, params } = options || {};

  let fullUrl = \`\${${p}}\${url}\`;

  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        searchParams.append(key, String(value));
      }
    });
    const queryString = searchParams.toString();
    if (queryString) {
      fullUrl += \`?\${queryString}\`;
    }
  }

  const response = await fetch(fullUrl, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    throw new Error(\`API Error: \${response.status} \${response.statusText}\`);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json();
}

` + o.map((y) => y.code).join(`

`), b = e.generateTypes !== !1 ? Ve(m, t) : void 0;
  return {
    code: h,
    hooks: o,
    imports: i,
    entities: m,
    typesCode: b
  };
}
function H(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
function F(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function te(e) {
  return e.endsWith("y") && !/[aeiou]y$/i.test(e) ? e.slice(0, -1) + "ies" : e.endsWith("s") || e.endsWith("x") || e.endsWith("z") || e.endsWith("ch") || e.endsWith("sh") ? e + "es" : e + "s";
}
function X(e) {
  return e.replace(/([A-Z])/g, " $1").replace(/^./, (t) => t.toUpperCase()).replace(/Id$/, " ID").trim();
}
function nt(e) {
  var a, o, n, s, r, i;
  let t;
  switch (e.type) {
    case "string":
    case "text":
      t = "z.string()", ((a = e.validation) == null ? void 0 : a.minLength) !== void 0 && (t += `.min(${e.validation.minLength})`), ((o = e.validation) == null ? void 0 : o.maxLength) !== void 0 && (t += `.max(${e.validation.maxLength})`), (n = e.validation) != null && n.pattern && (t += `.regex(/${e.validation.pattern}/)`);
      break;
    case "email":
      t = "z.string().email()";
      break;
    case "url":
      t = "z.string().url()";
      break;
    case "number":
      t = "z.number()", ((s = e.validation) == null ? void 0 : s.min) !== void 0 && (t += `.min(${e.validation.min})`), ((r = e.validation) == null ? void 0 : r.max) !== void 0 && (t += `.max(${e.validation.max})`);
      break;
    case "boolean":
      t = "z.boolean()";
      break;
    case "date":
    case "datetime":
      t = "z.string().datetime()";
      break;
    case "enum":
      (i = e.enumValues) != null && i.length ? t = `z.enum([${e.enumValues.map((c) => `'${c}'`).join(", ")}])` : t = "z.string()";
      break;
    case "reference":
      t = "z.string()";
      break;
    default:
      t = "z.unknown()";
  }
  return e.required || (t += ".optional()"), t;
}
function Z(e) {
  var t;
  switch (e.type) {
    case "string":
    case "text":
    case "email":
    case "url":
    case "date":
    case "datetime":
    case "reference":
      return "string";
    case "number":
      return "number";
    case "boolean":
      return "boolean";
    case "enum":
      return (t = e.enumValues) != null && t.length ? e.enumValues.map((a) => `'${a}'`).join(" | ") : "string";
    default:
      return "unknown";
  }
}
function ot(e) {
  const { entity: t, fields: a } = e;
  H(t);
  const o = F(t), n = a.map((c) => `  ${c.name}${c.required ? "" : "?"}: ${Z(c)};`).join(`
`), s = a.filter((c) => c.showInForm !== !1 && c.name !== "id" && !c.name.endsWith("At")).map((c) => `  ${c.name}${c.required ? "" : "?"}: ${Z(c)};`).join(`
`), r = a.filter((c) => c.showInForm !== !1 && c.name !== "id" && !c.name.endsWith("At")).map((c) => `  ${c.name}?: ${Z(c)};`).join(`
`), i = `/**
 * ${t} Types
 * Auto-generated - DO NOT EDIT
 */

export interface ${t} {
  id: string;
${n}
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Create${t}Input {
${s}
}

export interface Update${t}Input {
${r}
}

export interface ${t}ListParams {
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  search?: string;
  ${a.filter((c) => c.filterable).map((c) => `${c.name}?: ${Z(c)};`).join(`
  `)}
}

export interface ${t}ListResponse {
  data: ${t}[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}
`;
  return {
    path: `src/features/${o}/types.ts`,
    content: i,
    type: "types"
  };
}
function st(e) {
  const { entity: t, fields: a } = e, o = F(t), n = a.filter((r) => r.showInForm !== !1 && r.name !== "id" && !r.name.endsWith("At") && !r.name.endsWith("_at")).map((r) => `  ${r.name}: ${nt(r)},`).join(`
`), s = `/**
 * ${t} Validation Schemas
 * Auto-generated - DO NOT EDIT
 */

import { z } from 'zod';

export const create${t}Schema = z.object({
${n}
});

export const update${t}Schema = create${t}Schema.partial();

export type Create${t}FormData = z.infer<typeof create${t}Schema>;
export type Update${t}FormData = z.infer<typeof update${t}Schema>;
`;
  return {
    path: `src/features/${o}/schemas.ts`,
    content: s,
    type: "schemas"
  };
}
function it(e) {
  const { entity: t, apiBasePath: a } = e, o = e.pluralEntity || te(t), n = H(t), s = H(o), r = F(t), i = a || `/${F(o)}`, c = `/**
 * ${t} Hooks
 * Auto-generated - DO NOT EDIT
 */

import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import type {
  ${t},
  Create${t}Input,
  Update${t}Input,
  ${t}ListParams,
  ${t}ListResponse,
} from './types';

const API_BASE = process.env.NEXT_PUBLIC_API_URL || '';

async function apiFetch<T>(
  url: string,
  options?: RequestInit & { params?: Record<string, unknown> }
): Promise<T> {
  let fullUrl = \`\${API_BASE}\${url}\`;

  if (options?.params) {
    const searchParams = new URLSearchParams();
    Object.entries(options.params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value));
      }
    });
    const queryString = searchParams.toString();
    if (queryString) fullUrl += \`?\${queryString}\`;
  }

  const response = await fetch(fullUrl, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(\`API Error: \${response.status}\`);
  }

  if (response.status === 204) return undefined as T;
  return response.json();
}

// ============================================
// Query Hooks
// ============================================

/**
 * Fetch paginated list of ${s}
 */
export function use${t}List(params?: ${t}ListParams) {
  return useQuery({
    queryKey: ['${s}', params],
    queryFn: () => apiFetch<${t}ListResponse>('${i}', { params: params as Record<string, unknown> }),
  });
}

/**
 * Fetch infinite list of ${s}
 */
export function use${t}ListInfinite(params?: Omit<${t}ListParams, 'page'>) {
  const limit = params?.limit ?? 20;

  return useInfiniteQuery({
    queryKey: ['${s}', 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiFetch<${t}ListResponse>('${i}', {
        params: { ...params, page: pageParam, limit },
      }),
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.page + 1;
      return nextPage <= lastPage.totalPages ? nextPage : undefined;
    },
    initialPageParam: 1,
  });
}

/**
 * Fetch single ${n} by ID
 */
export function use${t}(id: string | undefined) {
  return useQuery({
    queryKey: ['${n}', id],
    queryFn: () => apiFetch<${t}>(\`${i}/\${id}\`),
    enabled: !!id,
  });
}

// ============================================
// Mutation Hooks
// ============================================

/**
 * Create new ${n}
 */
export function useCreate${t}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Create${t}Input) =>
      apiFetch<${t}>('${i}', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },
  });
}

/**
 * Update existing ${n}
 */
export function useUpdate${t}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Update${t}Input }) =>
      apiFetch<${t}>(\`${i}/\${id}\`, {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['${n}', id] });
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },
  });
}

/**
 * Delete ${n}
 */
export function useDelete${t}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(\`${i}/\${id}\`, { method: 'DELETE' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },
  });
}

${e.bulkActions ? `
/**
 * Bulk delete ${s}
 */
export function useBulkDelete${o}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: string[]) =>
      apiFetch<void>('${i}/bulk-delete', {
        method: 'POST',
        body: JSON.stringify({ ids }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['${s}'] });
    },
  });
}
` : ""}
`;
  return {
    path: `src/features/${r}/hooks.ts`,
    content: c,
    type: "hooks"
  };
}
function ct(e, t) {
  const { entity: a, fields: o, bulkActions: n, exportable: s } = e, r = e.pluralEntity || te(a), i = H(a), c = H(r), p = F(r), u = F(a), m = o.filter((f) => f.showInList !== !1).map((f) => {
    const b = f.label || X(f.name);
    return f.type === "enum" || f.name.includes("status") ? `  {
    key: '${f.name}',
    header: '${b}',
    render: (item: ${a}) => (
      <Badge variant={getStatusVariant(item.${f.name})} badgeStyle="soft">
        {item.${f.name}?.replace('_', ' ') || '-'}
      </Badge>
    ),
    ${f.sortable ? "sortable: true," : ""}
  }` : f.type === "date" || f.type === "datetime" ? `  {
    key: '${f.name}',
    header: '${b}',
    render: (item: ${a}) => formatDate(item.${f.name}),
    ${f.sortable ? "sortable: true," : ""}
  }` : `  {
    key: '${f.name}',
    header: '${b}',
    render: (item: ${a}) => item.${f.name} ?? '-',
    ${f.sortable ? "sortable: true," : ""}
  }`;
  }).join(`,
`), g = `/**
 * ${a} List Page
 */

'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  PageHeader,
  DataTable,
  Button,
  Badge,
  EmptyState,
  LoadingState,
  ErrorState,
  SmartSearch,
  ${n ? "BulkActionBar," : ""}
  ${s ? "ExportData," : ""}
  ConfirmDestructive,
  Stack,
  Inline,
  useToast,
} from '@org/design-system';
import { use${a}List, useDelete${a}${n ? `, useBulkDelete${r}` : ""} } from '@/features/${u}';
import type { ${a} } from '@/features/${u}';

function formatDate(dateString: string | undefined) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString();
}

function getStatusVariant(status: string | undefined): 'green' | 'yellow' | 'red' | 'blue' | 'gray' {
  if (!status) return 'gray';
  const variants: Record<string, 'green' | 'yellow' | 'red' | 'blue' | 'gray'> = {
    active: 'green',
    new: 'blue',
    pending: 'yellow',
    in_progress: 'yellow',
    completed: 'green',
    qualified: 'green',
    inactive: 'gray',
    disqualified: 'red',
    error: 'red',
    won: 'green',
    lost: 'red',
    archived: 'gray',
  };
  return variants[status.toLowerCase()] || 'gray';
}

export default function ${a}ListPage() {
  const router = useRouter();
  const { toast } = useToast();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  ${n ? "const [selectedIds, setSelectedIds] = useState<string[]>([]);" : ""}

  const { data, isLoading, error, refetch } = use${a}List({ page, search });
  const deleteMutation = useDelete${a}();
  ${n ? `const bulkDeleteMutation = useBulkDelete${r}();` : ""}

  const columns = [
${m},
    {
      key: 'actions',
      header: '',
      render: (item: ${a}) => (
        <Inline gap={2}>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => router.push(\`/${p}/\${item.id}\`)}
          >
            View
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => router.push(\`/${p}/\${item.id}/edit\`)}
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setDeleteId(item.id)}
          >
            Delete
          </Button>
        </Inline>
      ),
    },
  ];

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteMutation.mutateAsync(deleteId);
      toast({ title: '${a} deleted successfully', variant: 'success' });
      setDeleteId(null);
    } catch {
      toast({ title: 'Failed to delete ${a}', variant: 'destructive' });
    }
  };

  ${n ? `
  const handleBulkDelete = async () => {
    try {
      await bulkDeleteMutation.mutateAsync(selectedIds);
      toast({ title: \`\${selectedIds.length} ${c} deleted\`, variant: 'success' });
      setSelectedIds([]);
    } catch {
      toast({ title: 'Failed to delete ${c}', variant: 'destructive' });
    }
  };` : ""}

  if (isLoading) return <LoadingState message="Loading ${c}..." />;
  if (error) return <ErrorState title="Failed to load ${c}" onRetry={refetch} />;

  return (
    <Stack gap={6}>
      <PageHeader
        title="${r}"
        description="Manage your ${c}"
        actions={[
          {
            label: 'Add ${a}',
            onClick: () => router.push('/${p}/new'),
          },
        ]}
      />

      <SmartSearch
        value={search}
        onChange={setSearch}
        placeholder="Search ${c}..."
      />

      {data?.data.length === 0 ? (
        <EmptyState
          preset="no-data"
          title="No ${c} yet"
          description="Get started by creating your first ${i}."
          action={{
            label: 'Add ${a}',
            onClick: () => router.push('/${p}/new'),
          }}
        />
      ) : (
        <>
          <DataTable
            data={data?.data || []}
            columns={columns}
            keyExtractor={(item) => item.id}
            ${n ? `
            selectable
            selectedRows={selectedIds}
            onSelectionChange={setSelectedIds}
            ` : ""}
          />

          ${n ? `
          {selectedIds.length > 0 && (
            <BulkActionBar
              selectedCount={selectedIds.length}
              totalCount={data?.total || 0}
              actions={[
                {
                  label: 'Delete Selected',
                  variant: 'danger',
                  onClick: handleBulkDelete,
                },
              ]}
              onClearSelection={() => setSelectedIds([])}
            />
          )}
          ` : ""}
        </>
      )}

      <ConfirmDestructive
        isOpen={!!deleteId}
        onClose={() => setDeleteId(null)}
        title="Delete ${a}"
        description="Are you sure you want to delete this ${i}? This action cannot be undone."
        onConfirm={handleDelete}
        confirmLabel="Delete"
      />
    </Stack>
  );
}
`;
  return {
    path: t ? `src/app/(dashboard)/${p}/page.tsx` : `pages/${p}/index.tsx`,
    content: g,
    type: "pages"
  };
}
function pt(e, t) {
  const { entity: a, fields: o } = e, n = e.pluralEntity || te(a), s = H(a), r = F(n), i = F(a), p = o.filter((m) => m.showInDetail !== !1).map((m) => {
    const g = m.label || X(m.name);
    return m.type === "enum" || m.name.includes("status") ? `          <Stack gap={1}>
            <Typography variant="caption" color="muted">${g}</Typography>
            <Badge variant={getStatusVariant(data.${m.name})} badgeStyle="soft">
              {data.${m.name}?.replace('_', ' ') || '-'}
            </Badge>
          </Stack>` : m.type === "date" || m.type === "datetime" ? `          <Stack gap={1}>
            <Typography variant="caption" color="muted">${g}</Typography>
            <Typography variant="body">{formatDate(data.${m.name})}</Typography>
          </Stack>` : m.type === "boolean" ? `          <Stack gap={1}>
            <Typography variant="caption" color="muted">${g}</Typography>
            <Typography variant="body">{data.${m.name} ? 'Yes' : 'No'}</Typography>
          </Stack>` : `          <Stack gap={1}>
            <Typography variant="caption" color="muted">${g}</Typography>
            <Typography variant="body">{data.${m.name} || '-'}</Typography>
          </Stack>`;
  }).join(`
`), u = `/**
 * ${a} Detail Page
 */

'use client';

import { useState } from 'react';
import { useParams, useRouter } from 'next/navigation';
import {
  PageHeader,
  Card,
  Badge,
  Button,
  Breadcrumbs,
  LoadingState,
  ErrorState,
  ConfirmDestructive,
  Stack,
  Inline,
  Grid,
  Typography,
  useToast,
} from '@org/design-system';
import { use${a}, useDelete${a} } from '@/features/${i}';

function formatDate(dateString: string | undefined) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString();
}

function getStatusVariant(status: string | undefined): 'green' | 'yellow' | 'red' | 'blue' | 'gray' {
  if (!status) return 'gray';
  const variants: Record<string, 'green' | 'yellow' | 'red' | 'blue' | 'gray'> = {
    active: 'green',
    new: 'blue',
    pending: 'yellow',
    in_progress: 'yellow',
    completed: 'green',
    qualified: 'green',
    inactive: 'gray',
    disqualified: 'red',
    error: 'red',
    won: 'green',
    lost: 'red',
    archived: 'gray',
  };
  return variants[status.toLowerCase()] || 'gray';
}

export default function ${a}DetailPage() {
  const params = useParams();
  const router = useRouter();
  const { toast } = useToast();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const id = params.id as string;
  const { data, isLoading, error, refetch } = use${a}(id);
  const deleteMutation = useDelete${a}();

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(id);
      toast({ title: '${a} deleted successfully', variant: 'success' });
      router.push('/${r}');
    } catch {
      toast({ title: 'Failed to delete ${a}', variant: 'destructive' });
    }
  };

  if (isLoading) return <LoadingState message="Loading ${s} details..." />;
  if (error) return <ErrorState title="Failed to load ${s}" onRetry={refetch} />;
  if (!data) return <ErrorState title="${a} not found" />;

  return (
    <Stack gap={6}>
      <Breadcrumbs
        items={[
          { label: '${n}', href: '/${r}' },
          { label: (data as unknown as Record<string, unknown>).name as string || data.id },
        ]}
      />

      <PageHeader
        title="${a} Details"
        actions={[
          {
            label: 'Edit',
            onClick: () => router.push(\`/${r}/\${id}/edit\`),
            variant: 'outline' as const,
          },
          {
            label: 'Delete',
            onClick: () => setShowDeleteDialog(true),
            variant: 'danger' as const,
          },
        ]}
      />

      <Card padding="lg" variant="elevated">
        <Grid columns={{ base: 1, sm: 2 }} gap={6}>
${p}
        </Grid>
      </Card>

      <ConfirmDestructive
        isOpen={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        title="Delete ${a}"
        description="Are you sure you want to delete this ${s}? This action cannot be undone."
        onConfirm={handleDelete}
        confirmLabel="Delete"
      />
    </Stack>
  );
}
`;
  return {
    path: t ? `src/app/(dashboard)/${r}/[id]/page.tsx` : `pages/${r}/[id]/index.tsx`,
    content: u,
    type: "pages"
  };
}
function ye(e, t, a) {
  const { entity: o, fields: n } = e, s = e.pluralEntity || te(o), r = H(o), i = F(s), c = F(o), u = n.filter(
    (y) => y.showInForm !== !1 && y.name !== "id" && !y.name.endsWith("At") && !y.name.endsWith("_at")
  ).map((y) => {
    var C;
    const $ = y.label || X(y.name);
    return y.type === "enum" && ((C = y.enumValues) != null && C.length) ? `            <SelectField
              name="${y.name}"
              label="${$}"
              options={[
                ${y.enumValues.map((P) => `{ value: '${P}', label: '${X(P)}' }`).join(`,
                `)}
              ]}
            />` : y.type === "boolean" ? `            <div className="flex items-center gap-2">
              <Checkbox name="${y.name}" />
              <label htmlFor="${y.name}" className="text-sm">${$}</label>
            </div>` : y.type === "text" ? `            <FormTextarea
              name="${y.name}"
              label="${$}"
            />` : y.type === "date" || y.type === "datetime" ? `            <TextField
              name="${y.name}"
              label="${$}"
              type="${y.type === "datetime" ? "datetime-local" : "date"}"
            />` : y.type === "number" ? `            <TextField
              name="${y.name}"
              label="${$}"
              type="number"
            />` : `            <TextField
              name="${y.name}"
              label="${$}"
              ${y.type === "email" ? 'type="email"' : ""}
              ${y.type === "url" ? 'type="url"' : ""}
            />`;
  }).join(`
`), l = t === "edit", m = l ? `Edit ${o}` : `Create ${o}`, g = l ? `useUpdate${o}` : `useCreate${o}`, h = l ? `update${o}Schema` : `create${o}Schema`, f = `/**
 * ${m} Page
 */

'use client';

${l ? "import { useParams, useRouter } from 'next/navigation';" : "import { useRouter } from 'next/navigation';"}
import {
  PageHeader,
  Card,
  Button,
  Breadcrumbs,
  SmartForm,
  TextField,
  SelectField,
  FormTextarea,
  Checkbox,
  LoadingState,
  ErrorState,
  Stack,
  Inline,
  useToast,
} from '@org/design-system';
import { ${g}${l ? `, use${o}` : ""}, ${h} } from '@/features/${c}';
import type { ${l ? `Update${o}Input` : `Create${o}Input`} } from '@/features/${c}';

export default function ${t === "edit" ? `Edit${o}Page` : `Create${o}Page`}() {
  const router = useRouter();
  const { toast } = useToast();
  ${l ? `const params = useParams();
  const id = params.id as string;
  const { data: ${r}, isLoading, error, refetch } = use${o}(id);` : ""}
  const mutation = ${g}();

  ${l ? `if (isLoading) return <LoadingState message="Loading ${r}..." />;
  if (error) return <ErrorState title="Failed to load ${r}" onRetry={refetch} />;
  if (!${r}) return <ErrorState title="${o} not found" />;` : ""}

  const handleSubmit = async (data: unknown) => {
    try {
      ${l ? `await mutation.mutateAsync({ id, data: data as Update${o}Input });
      toast({ title: '${o} updated successfully', variant: 'success' });` : `await mutation.mutateAsync(data as Create${o}Input);
      toast({ title: '${o} created successfully', variant: 'success' });`}
      router.push('/${i}');
    } catch {
      toast({ title: 'Failed to ${l ? "update" : "create"} ${o}', variant: 'destructive' });
    }
  };

  return (
    <Stack gap={6}>
      <Breadcrumbs
        items={[
          { label: '${s}', href: '/${i}' },
          ${l ? `{ label: (${r} as unknown as Record<string, unknown>).name as string || id },` : ""}
          { label: '${l ? "Edit" : "New"}' },
        ]}
      />

      <PageHeader title="${m}" />

      <Card padding="lg" variant="elevated">
        <SmartForm
          schema={${h}}
          ${l ? `defaultValues={${r}}` : ""}
          onSubmit={handleSubmit}
        >
          <Stack gap={4}>
${u}
          </Stack>

          <Inline gap={2} className="mt-6">
            <Button type="submit" isLoading={mutation.isPending}>
              ${l ? "Save Changes" : "Create"}
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={() => router.back()}
            >
              Cancel
            </Button>
          </Inline>
        </SmartForm>
      </Card>
    </Stack>
  );
}
`;
  return {
    path: a ? t === "edit" ? `src/app/(dashboard)/${i}/[id]/edit/page.tsx` : `src/app/(dashboard)/${i}/new/page.tsx` : t === "edit" ? `pages/${i}/[id]/edit.tsx` : `pages/${i}/new.tsx`,
    content: f,
    type: "pages"
  };
}
function lt(e) {
  const { entity: t } = e, a = F(t), o = `/**
 * ${t} Feature Exports
 */

// Types
export * from './types';

// Schemas
export * from './schemas';

// Hooks
export * from './hooks';
`;
  return {
    path: `src/features/${a}/index.ts`,
    content: o,
    type: "types"
  };
}
function ha(e) {
  const { config: t, nextAppRouter: a = !0 } = e, o = t.pages || ["list", "detail", "create", "edit"], n = [];
  n.push(ot(t)), n.push(st(t)), n.push(it(t)), n.push(lt(t)), o.includes("list") && n.push(ct(t, a)), o.includes("detail") && n.push(pt(t, a)), o.includes("create") && n.push(ye(t, "create", a)), o.includes("edit") && n.push(ye(t, "edit", a));
  const s = n.filter((u) => u.path.includes("/features/")), r = n.filter((u) => u.path.includes("/app/")), i = s.map((u) => u.path).sort().map((u) => `├── ${u}`).join(`
`), c = r.map((u) => u.path).sort().map((u) => `├── ${u}`).join(`
`), p = `Feature files:
${i}

Page files:
${c}`;
  return {
    files: n,
    structure: p,
    summary: {
      entity: t.entity,
      pagesGenerated: o,
      filesGenerated: n.length
    }
  };
}
function ba(e) {
  return e.map((t) => ({
    name: t.name,
    type: ut(t),
    required: t.required,
    enumValues: t.enum,
    referencedEntity: t.referencedEntity,
    showInList: !t.isId && !t.isTimestamp && t.name !== "id",
    showInDetail: !0,
    showInForm: !t.isId && !t.isTimestamp && !t.name.endsWith("At"),
    sortable: t.isTimestamp || ["name", "title", "createdAt", "updatedAt"].includes(t.name),
    filterable: t.type === "string" && t.enum !== void 0,
    searchable: ["name", "title", "email", "description"].includes(t.name),
    validation: t.validation
  }));
}
function ut(e) {
  return e.enum ? "enum" : e.isReference ? "reference" : e.format === "date-time" ? "datetime" : e.format === "date" ? "date" : e.format === "email" ? "email" : e.format === "uri" ? "url" : e.type === "boolean" ? "boolean" : e.type === "number" || e.type === "integer" ? "number" : "string";
}
function ae(e) {
  return L.components[e] || null;
}
function dt(e, t) {
  if (e == null)
    return { valid: !0 };
  const { type: a, values: o } = t;
  switch (a) {
    case "string":
      if (typeof e != "string")
        return { valid: !1, message: `Expected string, got ${typeof e}` };
      break;
    case "number":
      if (typeof e != "number")
        return { valid: !1, message: `Expected number, got ${typeof e}` };
      break;
    case "boolean":
      if (typeof e != "boolean")
        return { valid: !1, message: `Expected boolean, got ${typeof e}` };
      break;
    case "function":
      if (typeof e != "function")
        return { valid: !1, message: `Expected function, got ${typeof e}` };
      break;
    case "node":
    case "ReactNode":
      if (e == null)
        return { valid: !0 };
      break;
    case "array":
      if (!Array.isArray(e))
        return { valid: !1, message: `Expected array, got ${typeof e}` };
      break;
    case "object":
      if (typeof e != "object" || Array.isArray(e))
        return { valid: !1, message: `Expected object, got ${typeof e}` };
      break;
    case "enum":
      if (o && !o.includes(e))
        return {
          valid: !1,
          message: `Invalid enum value "${e}". Expected one of: ${o.join(", ")}`
        };
      break;
    case "Date":
      if (!(e instanceof Date) && typeof e != "string")
        return { valid: !1, message: `Expected Date or date string, got ${typeof e}` };
      break;
  }
  return { valid: !0 };
}
function mt(e, t) {
  var n;
  const a = [], o = e.toLowerCase();
  for (const s of t) {
    const r = s.toLowerCase();
    if (o === r && e !== s) {
      a.push(s);
      continue;
    }
    if (Math.abs(e.length - s.length) <= 2) {
      let c = 0;
      for (let p = 0; p < Math.min(e.length, s.length); p++)
        o[p] !== r[p] && c++;
      c += Math.abs(e.length - s.length), c <= 2 && a.push(s);
    }
    (n = {
      onclick: ["onClick"],
      onchange: ["onChange"],
      classname: ["className"],
      readonly: ["readOnly"],
      tabindex: ["tabIndex"],
      isloading: ["isLoading"],
      isdisabled: ["isDisabled", "disabled"],
      variant: ["variants"],
      size: ["sizes"]
    }[o]) != null && n.includes(s) && a.push(s);
  }
  return a;
}
function ie(e) {
  const { componentName: t, props: a, allowExtraProps: o = !1 } = e, n = [], s = [];
  let r = 0;
  const i = ae(t);
  if (!i)
    return {
      valid: !1,
      errors: [{
        component: t,
        prop: "",
        message: `Component "${t}" not found in manifest`,
        severity: "error",
        suggestion: gt(t)
      }],
      warnings: [],
      componentExists: !1,
      propsChecked: 0
    };
  const c = Object.keys(i.props);
  for (const [p, u] of Object.entries(a)) {
    r++;
    const l = i.props[p];
    if (!l) {
      if (!o) {
        const g = mt(p, c), h = {
          component: t,
          prop: p,
          message: `Unknown prop "${p}" for component ${t}`,
          severity: "warning"
        };
        g.length > 0 && (h.suggestion = `Did you mean: ${g.join(", ")}?`), s.push(h);
      }
      continue;
    }
    const m = dt(u, l);
    m.valid || n.push({
      component: t,
      prop: p,
      message: m.message || `Invalid type for prop "${p}"`,
      severity: "error"
    });
  }
  for (const [p, u] of Object.entries(i.props))
    u.required && !(p in a) && n.push({
      component: t,
      prop: p,
      message: `Required prop "${p}" is missing`,
      severity: "error"
    });
  return {
    valid: n.length === 0,
    errors: n,
    warnings: s,
    componentExists: !0,
    propsChecked: r
  };
}
function gt(e) {
  const a = Object.keys(L.components), o = e.toLowerCase(), n = a.filter((s) => {
    const r = s.toLowerCase();
    if (o === r || r.includes(o) || o.includes(r)) return !0;
    if (Math.abs(e.length - s.length) <= 2) {
      let i = 0;
      for (let c = 0; c < Math.min(e.length, s.length); c++)
        o[c] !== r[c] && i++;
      return i <= 2;
    }
    return !1;
  });
  if (n.length > 0)
    return `Did you mean: ${n.slice(0, 3).join(", ")}?`;
}
function $a(e) {
  const t = {};
  let a = 0, o = 0;
  for (const { name: r, props: i } of e) {
    const c = ie({
      componentName: r,
      props: i
    });
    t[r] = c, c.valid ? a++ : o++;
  }
  const n = e.length, s = `Validated ${n} components: ${a} valid, ${o} invalid`;
  return {
    totalComponents: n,
    validComponents: a,
    invalidComponents: o,
    results: t,
    summary: s
  };
}
function va(e) {
  const t = ae(e);
  return t ? Object.entries(t.props).map(([a, o]) => ({
    prop: a,
    type: o.type,
    description: o.description,
    default: o.default,
    required: !!o.required,
    values: o.values
  })) : null;
}
function wa(e, t) {
  const a = ae(e);
  return a ? a.capabilities.some(
    (o) => o.toLowerCase().includes(t.toLowerCase())
  ) : !1;
}
function ka(e, t) {
  var n;
  const a = ae(e);
  if (!a) return null;
  if ((n = a.propMetadata) != null && n.defaultPropSets) {
    if (t) {
      const s = a.propMetadata.defaultPropSets.find(
        (r) => r.name.toLowerCase() === t.toLowerCase()
      );
      if (s) return s.props;
    }
    if (a.propMetadata.defaultPropSets.length > 0)
      return a.propMetadata.defaultPropSets[0].props;
  }
  const o = {};
  for (const [s, r] of Object.entries(a.props))
    r.default !== void 0 && (o[s] = r.default);
  return o;
}
function Sa(e) {
  const t = ie({
    componentName: "Button",
    props: e
  });
  if ("variant" in e) {
    const a = e.variant, o = ["primary", "secondary", "outline", "ghost", "link", "danger"];
    a === "destructive" && t.warnings.push({
      component: "Button",
      prop: "variant",
      message: 'variant="destructive" is shadcn/ui syntax',
      severity: "warning",
      suggestion: 'Use variant="danger" instead'
    }), o.includes(a) || (t.errors.push({
      component: "Button",
      prop: "variant",
      message: `Invalid variant "${a}"`,
      severity: "error",
      suggestion: `Valid variants: ${o.join(", ")}`
    }), t.valid = !1);
  }
  return t;
}
function xa(e) {
  const t = ie({
    componentName: "Badge",
    props: e
  });
  return "variant" in e && e.variant === "destructive" && t.warnings.push({
    component: "Badge",
    prop: "variant",
    message: 'variant="destructive" is shadcn/ui syntax',
    severity: "warning",
    suggestion: 'Use variant="red" instead'
  }), t;
}
function Ca(e) {
  const {
    pageType: t,
    entity: a = "Item",
    columns: o = 4,
    rows: n = 5,
    includeHeader: s = !0,
    includeFilters: r = !1
  } = e, i = `${a}${t.charAt(0).toUpperCase() + t.slice(1)}Loading`, c = ["Skeleton", "Stack", "Card"];
  let p = "";
  switch (t) {
    case "list":
      c.push("Grid"), p = `
        {/* Page Header Skeleton */}
        ${s ? `<Stack gap={2}>
          <Skeleton variant="text" className="h-8 w-48" />
          <Skeleton variant="text" className="h-4 w-72" />
        </Stack>` : ""}

        ${r ? `{/* Filters Skeleton */}
        <div className="flex gap-3">
          <Skeleton variant="rectangular" className="h-10 w-64" />
          <Skeleton variant="rectangular" className="h-10 w-32" />
          <Skeleton variant="rectangular" className="h-10 w-32" />
        </div>` : ""}

        {/* Table Skeleton */}
        <Card padding="none">
          <div className="border-b border-border px-4 py-3">
            <div className="flex gap-4">
              {Array.from({ length: ${o} }).map((_, i) => (
                <Skeleton key={i} variant="text" className="h-4 w-24" />
              ))}
            </div>
          </div>
          <Stack gap={0}>
            {Array.from({ length: ${n} }).map((_, rowIdx) => (
              <div key={rowIdx} className="flex gap-4 px-4 py-3 border-b border-border last:border-0">
                {Array.from({ length: ${o} }).map((_, colIdx) => (
                  <Skeleton key={colIdx} variant="text" className="h-4 w-24" />
                ))}
              </div>
            ))}
          </Stack>
        </Card>`;
      break;
    case "detail":
      p = `
        {/* Header Skeleton */}
        <div className="flex justify-between items-start">
          <Stack gap={2}>
            <Skeleton variant="text" className="h-8 w-56" />
            <Skeleton variant="text" className="h-4 w-32" />
          </Stack>
          <div className="flex gap-2">
            <Skeleton variant="rectangular" className="h-10 w-24" />
            <Skeleton variant="rectangular" className="h-10 w-24" />
          </div>
        </div>

        {/* Content Skeleton */}
        <div className="grid grid-cols-3 gap-6">
          <Card className="col-span-2">
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-32" />
              <Stack gap={2}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <Skeleton key={i} variant="text" className="h-4 w-full" />
                ))}
              </Stack>
            </Stack>
          </Card>
          <Card>
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-24" />
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="flex justify-between">
                  <Skeleton variant="text" className="h-4 w-20" />
                  <Skeleton variant="text" className="h-4 w-24" />
                </div>
              ))}
            </Stack>
          </Card>
        </div>`;
      break;
    case "form":
      p = `
        {/* Form Skeleton */}
        <Card>
          <Stack gap={6}>
            <Skeleton variant="text" className="h-7 w-48" />

            <div className="grid grid-cols-2 gap-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <Stack key={i} gap={2}>
                  <Skeleton variant="text" className="h-4 w-24" />
                  <Skeleton variant="rectangular" className="h-10 w-full" />
                </Stack>
              ))}
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Skeleton variant="rectangular" className="h-10 w-24" />
              <Skeleton variant="rectangular" className="h-10 w-32" />
            </div>
          </Stack>
        </Card>`;
      break;
    case "dashboard":
      c.push("Grid"), p = `
        {/* Dashboard Header Skeleton */}
        <Stack gap={2}>
          <Skeleton variant="text" className="h-8 w-40" />
          <Skeleton variant="text" className="h-4 w-64" />
        </Stack>

        {/* KPI Cards Skeleton */}
        <Grid columns={4} gap={4}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Card key={i}>
              <Stack gap={3}>
                <Skeleton variant="text" className="h-4 w-24" />
                <Skeleton variant="text" className="h-8 w-20" />
                <Skeleton variant="text" className="h-3 w-16" />
              </Stack>
            </Card>
          ))}
        </Grid>

        {/* Charts Skeleton */}
        <Grid columns={2} gap={6}>
          <Card>
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-32" />
              <Skeleton variant="rectangular" className="h-64 w-full" />
            </Stack>
          </Card>
          <Card>
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-32" />
              <Skeleton variant="rectangular" className="h-64 w-full" />
            </Stack>
          </Card>
        </Grid>`;
      break;
    case "settings":
      c.push("Tabs"), p = `
        {/* Settings Header Skeleton */}
        <Stack gap={2}>
          <Skeleton variant="text" className="h-8 w-32" />
          <Skeleton variant="text" className="h-4 w-64" />
        </Stack>

        {/* Tabs Skeleton */}
        <div className="flex gap-4 border-b">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="text" className="h-10 w-20" />
          ))}
        </div>

        {/* Settings Content Skeleton */}
        <Card>
          <Stack gap={6}>
            {Array.from({ length: 3 }).map((_, sectionIdx) => (
              <Stack key={sectionIdx} gap={4}>
                <Skeleton variant="text" className="h-6 w-40" />
                <div className="grid grid-cols-2 gap-4">
                  {Array.from({ length: 2 }).map((_, fieldIdx) => (
                    <Stack key={fieldIdx} gap={2}>
                      <Skeleton variant="text" className="h-4 w-24" />
                      <Skeleton variant="rectangular" className="h-10 w-full" />
                    </Stack>
                  ))}
                </div>
              </Stack>
            ))}
          </Stack>
        </Card>`;
      break;
    case "profile":
      p = `
        {/* Profile Header Skeleton */}
        <Card>
          <div className="flex items-center gap-6">
            <Skeleton variant="circular" className="h-24 w-24" />
            <Stack gap={2}>
              <Skeleton variant="text" className="h-7 w-48" />
              <Skeleton variant="text" className="h-4 w-32" />
              <Skeleton variant="text" className="h-4 w-40" />
            </Stack>
          </div>
        </Card>

        {/* Profile Content Skeleton */}
        <div className="grid grid-cols-3 gap-6">
          <Card className="col-span-2">
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-32" />
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="flex justify-between py-2 border-b">
                  <Skeleton variant="text" className="h-4 w-24" />
                  <Skeleton variant="text" className="h-4 w-40" />
                </div>
              ))}
            </Stack>
          </Card>
          <Card>
            <Stack gap={4}>
              <Skeleton variant="text" className="h-6 w-24" />
              {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton key={i} variant="rectangular" className="h-12 w-full" />
              ))}
            </Stack>
          </Card>
        </div>`;
      break;
    case "kanban":
      p = `
        {/* Kanban Header Skeleton */}
        <div className="flex justify-between items-center">
          <Skeleton variant="text" className="h-8 w-40" />
          <div className="flex gap-2">
            <Skeleton variant="rectangular" className="h-10 w-32" />
            <Skeleton variant="rectangular" className="h-10 w-10" />
          </div>
        </div>

        {/* Kanban Columns Skeleton */}
        <div className="flex gap-4 overflow-x-auto pb-4">
          {Array.from({ length: 4 }).map((_, colIdx) => (
            <div key={colIdx} className="flex-shrink-0 w-72">
              <Card padding="sm" className="bg-muted/50">
                <Stack gap={3}>
                  <div className="flex justify-between items-center">
                    <Skeleton variant="text" className="h-5 w-24" />
                    <Skeleton variant="text" className="h-5 w-6" />
                  </div>
                  {Array.from({ length: 3 }).map((_, cardIdx) => (
                    <Card key={cardIdx} padding="sm">
                      <Stack gap={2}>
                        <Skeleton variant="text" className="h-4 w-full" />
                        <Skeleton variant="text" className="h-3 w-3/4" />
                        <div className="flex gap-1">
                          <Skeleton variant="text" className="h-5 w-12" />
                          <Skeleton variant="text" className="h-5 w-16" />
                        </div>
                      </Stack>
                    </Card>
                  ))}
                </Stack>
              </Card>
            </div>
          ))}
        </div>`;
      break;
  }
  const u = Array.from(new Set(c)).sort();
  return {
    code: `"use client";

import {
  ${u.join(`,
  `)},
} from '@org/design-system';

export function ${i}() {
  return (
    <Stack gap={6}>
      ${p}
    </Stack>
  );
}
`,
    componentName: i,
    imports: u,
    usage: `<${i} />`
  };
}
function Pa(e) {
  const {
    componentName: t = "FeatureErrorBoundary",
    feature: a = "feature",
    includeRetry: o = !0,
    includeGoBack: n = !0,
    includeContactSupport: s = !1,
    customErrorTypes: r = []
  } = e, i = ["ErrorState", "Button", "Stack"], c = r.map((m) => `
    if (error instanceof ${m}) {
      return (
        <ErrorState
          title="${m} Error"
          description={error.message}
          ${o ? 'action={{ label: "Try Again", onClick: reset }}' : ""}
        />
      );
    }`).join(`
`), p = Array.from(new Set(i)).sort(), u = `"use client";

import { Component, ReactNode } from 'react';
import {
  ${p.join(`,
  `)},
} from '@org/design-system';

interface ${t}Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ${t}State {
  hasError: boolean;
  error: Error | null;
}

export class ${t} extends Component<${t}Props, ${t}State> {
  constructor(props: ${t}Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ${t}State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('${a} Error:', error, errorInfo);
    // TODO: Send to error tracking service (Sentry, etc.)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { error } = this.state;

      if (this.props.fallback) {
        return this.props.fallback;
      }
      ${c}
      return (
        <ErrorState
          title="Something went wrong"
          description={error?.message || "An unexpected error occurred in the ${a}."}
          ${o ? "onRetry={this.handleReset}" : ""}
        />
      );
    }

    return this.props.children;
  }
}

export default ${t};
`, l = `"use client";

import { useEffect } from 'react';
import {
  ${p.join(`,
  `)},
} from '@org/design-system';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ${a.charAt(0).toUpperCase() + a.slice(1)}Error({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    // Log error to error tracking service
    console.error('${a} page error:', error);
  }, [error]);

  return (
    <ErrorState
      title="Something went wrong"
      description={error.message || "Failed to load ${a}. Please try again."}
      onRetry={reset}
    />
  );
}
`;
  return {
    code: u,
    componentName: t,
    errorPageCode: l,
    imports: i
  };
}
function Ia(e) {
  const {
    entities: t,
    appName: a = "app",
    includeSettings: o = !0,
    includeDashboard: n = !0,
    includeSearch: s = !1
  } = e, r = {
    user: "Users",
    users: "Users",
    customer: "Users",
    product: "Package",
    products: "Package",
    order: "ShoppingCart",
    orders: "ShoppingCart",
    invoice: "FileText",
    invoices: "FileText",
    project: "FolderKanban",
    projects: "FolderKanban",
    task: "CheckSquare",
    tasks: "CheckSquare",
    message: "MessageSquare",
    messages: "MessageSquare",
    notification: "Bell",
    analytics: "BarChart3",
    report: "FileBarChart",
    reports: "FileBarChart",
    settings: "Settings",
    team: "Users2",
    teams: "Users2",
    dashboard: "LayoutDashboard",
    billing: "CreditCard",
    api: "Code",
    webhook: "Webhook",
    integration: "Puzzle"
  }, i = (f, b) => {
    if (b) return b;
    const y = f.toLowerCase();
    return r[y] || "Circle";
  }, c = (f, b = "") => f.map((y) => {
    const $ = y.plural || `${y.name.toLowerCase()}s`, C = y.path || `${b}/${$}`, P = i(y.name, y.icon);
    return y.children && y.children.length > 0 ? `{
    label: '${y.name}',
    icon: ${P},
    children: [
      ${c(y.children, C)}
    ],
  }` : `{
    label: '${y.name}s',
    href: '${C}',
    icon: ${P},
  }`;
  }).join(`,
  `), p = /* @__PURE__ */ new Set(), u = (f) => {
    f.forEach((b) => {
      p.add(i(b.name, b.icon)), b.children && u(b.children);
    });
  };
  u(t), n && p.add("LayoutDashboard"), o && p.add("Settings"), s && p.add("Search");
  const m = `import {
  ${Array.from(p).sort().join(`,
  `)},
} from 'lucide-react';
import type { SidebarConfig } from '@org/design-system';

export const ${a}SidebarConfig: SidebarConfig = {
  ${s ? `search: {
    enabled: true,
    placeholder: 'Search...',
    shortcut: '⌘K',
  },` : ""}
  navigation: [
    ${n ? `{
      label: 'Dashboard',
      href: '/dashboard',
      icon: LayoutDashboard,
    },` : ""}
    ${c(t)}
  ],
  footer: [
    ${o ? `{
      label: 'Settings',
      href: '/settings',
      icon: Settings,
    },` : ""}
  ],
};
`, g = "SidebarConfig", h = `<Sidebar config={${a}SidebarConfig} />`;
  return {
    code: m,
    configType: g,
    usage: h
  };
}
function Ta(e) {
  const {
    entity: t,
    operations: a,
    hasRelationships: o = !1,
    hasApprovalWorkflow: n = !1,
    hasStatusTransitions: s = !1
  } = e, r = t.toLowerCase(), i = [], c = {
    list: {
      intent: "EntityList",
      description: `Display a list of ${t}s with search, filters, and pagination`,
      baseProps: { entity: r, columns: [], onRowClick: "(item) => router.push(`/${entityLower}s/${item.id}`)" }
    },
    create: {
      intent: "EntityCreate",
      description: `Create a new ${t} with form validation`,
      baseProps: { entity: r, onSuccess: "() => router.push(`/${entityLower}s`)" }
    },
    view: {
      intent: "EntityDetail",
      description: `View ${t} details with related information`,
      baseProps: { entity: r, showRelated: o }
    },
    edit: {
      intent: "EntityEdit",
      description: `Edit existing ${t} with validation`,
      baseProps: { entity: r, onSuccess: "() => router.push(`/${entityLower}s/${id}`)" }
    },
    delete: {
      intent: "ConfirmDestructive",
      description: `Confirm deletion of ${t} with safety checks`,
      baseProps: { title: `Delete ${t}`, confirmText: "delete", warningLevel: "high" }
    },
    "bulk-action": {
      intent: "BulkActionBar",
      description: `Perform bulk operations on selected ${t}s`,
      baseProps: { actions: ["delete", "export", "archive"] }
    },
    import: {
      intent: "ImportWizard",
      description: `Import ${t}s from CSV/Excel with validation`,
      baseProps: { entity: r, formats: ["csv", "xlsx"] }
    },
    export: {
      intent: "ExportDialog",
      description: `Export ${t}s to various formats`,
      baseProps: { entity: r, formats: ["csv", "xlsx", "json"] }
    },
    approve: {
      intent: "ApprovalWorkflow",
      description: `Handle approval workflow for ${t}`,
      baseProps: { entity: r, stages: ["pending", "approved", "rejected"] }
    },
    reject: {
      intent: "ApprovalWorkflow",
      description: `Handle rejection with reason for ${t}`,
      baseProps: { entity: r, requireReason: !0 }
    }
  };
  a.forEach((l) => {
    const m = c[l];
    m && i.push({
      intent: m.intent,
      operation: l,
      description: m.description,
      props: m.baseProps,
      importPath: "@org/design-system"
    });
  }), n && !a.includes("approve") && i.push({
    intent: "ApprovalWorkflow",
    operation: "approve",
    description: `Manage approval workflow for ${t}`,
    props: { entity: r, stages: ["pending", "review", "approved", "rejected"] },
    importPath: "@org/design-system"
  }), s && i.push({
    intent: "StatusTimeline",
    operation: "view",
    description: `Show status transition history for ${t}`,
    props: { entity: r },
    importPath: "@org/design-system"
  });
  const u = [`import { ${Array.from(new Set(i.map((l) => l.intent))).join(", ")} } from '@org/design-system';`];
  return {
    suggestions: i,
    imports: u,
    summary: `Found ${i.length} intent components for ${t} workflow with ${a.length} operations`
  };
}
function Aa(e) {
  const {
    routes: t,
    basePath: a = "",
    homeLabel: o = "Home"
  } = e, n = t.map((c) => {
    const p = `${a}${c.path}`;
    return `'${c.dynamic ? p.replace(/\[([^\]]+)\]/g, ":$1") : p}': {
    label: ${c.dynamic ? `(params) => \`${c.label.replace(/\{(\w+)\}/g, "${params.$1}")}\`` : `'${c.label}'`},
    ${c.parent ? `parent: '${c.parent}',` : ""}
  }`;
  }).join(`,
  `);
  return {
    code: `import type { BreadcrumbConfig } from '@org/design-system';

export const breadcrumbConfig: BreadcrumbConfig = {
  homeLabel: '${o}',
  routes: {
    ${n}
  },
};
`,
    hookCode: `import { usePathname, useParams } from 'next/navigation';
import { useMemo } from 'react';
import { breadcrumbConfig } from './breadcrumb-config';

interface BreadcrumbItem {
  label: string;
  href: string;
  current?: boolean;
}

export function useBreadcrumbs(): BreadcrumbItem[] {
  const pathname = usePathname();
  const params = useParams();

  return useMemo(() => {
    const segments = pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { label: breadcrumbConfig.homeLabel, href: '/' },
    ];

    let currentPath = '';
    segments.forEach((segment, index) => {
      currentPath += \`/\${segment}\`;

      // Find matching route config
      const routeConfig = Object.entries(breadcrumbConfig.routes).find(([pattern]) => {
        const regex = new RegExp(\`^\${pattern.replace(/:[^/]+/g, '[^/]+')}$\`);
        return regex.test(currentPath);
      });

      if (routeConfig) {
        const [, config] = routeConfig;
        const label = typeof config.label === 'function'
          ? config.label(params as Record<string, string>)
          : config.label;

        breadcrumbs.push({
          label,
          href: currentPath,
          current: index === segments.length - 1,
        });
      }
    });

    return breadcrumbs;
  }, [pathname, params]);
}
`,
    usage: `import { Breadcrumbs } from '@org/design-system';
import { useBreadcrumbs } from './use-breadcrumbs';

function PageHeader() {
  const breadcrumbs = useBreadcrumbs();
  return <Breadcrumbs items={breadcrumbs} />;
}`
  };
}
function Ea(e) {
  const {
    code: t,
    presetId: a,
    strictMode: o = !1
  } = e, n = [];
  [
    { pattern: /<button\s+className=/gi, element: "button", replacement: "Button" },
    { pattern: /<input\s+className=/gi, element: "input", replacement: "Input or TextField" },
    { pattern: /<select\s+/gi, element: "select", replacement: "SelectField" },
    { pattern: /<textarea\s+/gi, element: "textarea", replacement: "TextareaField" },
    { pattern: /<table\s+className=/gi, element: "table", replacement: "DataTable or Table" },
    { pattern: /<form\s+className=/gi, element: "form", replacement: "Form or SmartForm" }
  ].forEach(({ pattern: m, element: g, replacement: h }) => {
    m.test(t) && n.push({
      type: "error",
      rule: "no-raw-html",
      message: `Raw <${g}> element with className found`,
      suggestion: `Use <${h}> from @org/design-system instead`
    });
  }), /variant="destructive"/gi.test(t) && n.push({
    type: "error",
    rule: "no-shadcn-variants",
    message: 'shadcn/ui variant="destructive" found',
    suggestion: 'Use variant="danger" for design system components'
  }), (/from ['"]@shadcn/gi.test(t) || /from ['"]shadcn/gi.test(t)) && n.push({
    type: "error",
    rule: "no-direct-shadcn-import",
    message: "Direct import from shadcn/ui package found",
    suggestion: "Import from @org/design-system which wraps shadcn internally"
  }), /from ['"]@radix-ui/gi.test(t) && n.push({
    type: o ? "error" : "warning",
    rule: "no-direct-radix-import",
    message: "Direct import from @radix-ui found",
    suggestion: "Prefer design system components which wrap Radix primitives"
  }), /className="[^"]*\[#[0-9a-fA-F]{3,8}\]/gi.test(t) && n.push({
    type: o ? "error" : "warning",
    rule: "no-hardcoded-colors",
    message: "Hardcoded hex color in Tailwind className",
    suggestion: "Use semantic color classes (bg-primary, text-muted) or CSS variables (--ds-*)"
  }), /style=\{[^}]*(color|background|border)[^}]*#[0-9a-fA-F]{3,8}/gi.test(t) && n.push({
    type: o ? "error" : "warning",
    rule: "no-inline-color-styles",
    message: "Hardcoded color in inline style",
    suggestion: "Use Tailwind classes or CSS variables"
  });
  const r = /<Button|<Card|<Input|<Badge|<DataTable/i.test(t), i = /from ['"]@org\/design-system['"]/i.test(t);
  r && !i && n.push({
    type: "error",
    rule: "missing-design-system-import",
    message: "Uses design system components but missing import",
    suggestion: "Add: import { ... } from '@org/design-system'"
  }), /<div\s+className="[^"]*fixed[^"]*inset-0[^"]*z-/gi.test(t) && n.push({
    type: "error",
    rule: "no-diy-modal",
    message: "DIY modal/overlay pattern detected",
    suggestion: "Use <Dialog> or <Drawer> from @org/design-system"
  }), /<span\s+className="[^"]*rounded-full[^"]*bg-/gi.test(t) && n.push({
    type: "error",
    rule: "no-diy-badge",
    message: "DIY badge pattern detected",
    suggestion: 'Use <Badge variant="..."> from @org/design-system'
  }), a && ((a.includes("executive") || a.includes("premium")) && /variant="bordered"/gi.test(t) && o && n.push({
    type: "warning",
    rule: "preset-card-style",
    message: `${a} preset prefers elevated cards`,
    suggestion: 'Use variant="elevated" for cards in premium presets'
  }), (a.includes("minimal") || a.includes("clean")) && /shadow-xl|shadow-2xl/gi.test(t) && n.push({
    type: "warning",
    rule: "preset-shadow-style",
    message: `${a} preset prefers subtle shadows`,
    suggestion: "Use shadow-sm or shadow-md for minimal presets"
  }));
  const c = n.some((m) => m.type === "error"), p = n.filter((m) => m.type === "error").length, u = n.filter((m) => m.type === "warning").length;
  let l = "";
  return p === 0 && u === 0 ? l = "Code is fully compliant with design system standards." : p === 0 ? l = "Code is compliant but has warnings to consider." : l = "Fix errors before proceeding. Use MCP validation tools for automated fixes.", {
    valid: !c,
    issues: n,
    summary: {
      errors: p,
      warnings: u
    },
    recommendation: l
  };
}
function Da(e) {
  const {
    endpoint: t,
    appName: a = "web",
    generateTests: o = !0
  } = e, s = t.path.split("/").filter(Boolean)[0].replace(/s$/, ""), r = s.charAt(0).toUpperCase() + s.slice(1), i = `${s}s`, c = [], p = t.method === "GET" && !t.path.includes("{"), u = t.method === "GET" && t.path.includes("{"), l = t.method === "POST", m = t.method === "PUT" || t.method === "PATCH", g = t.method === "DELETE", h = `// Generated from ${t.method} ${t.path}

export interface ${r} {
  id: string;
  // TODO: Add fields from OpenAPI schema
  createdAt: string;
  updatedAt: string;
}

export interface ${r}ListParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface ${r}CreateInput {
  // TODO: Add create fields from request body schema
}

export interface ${r}UpdateInput {
  // TODO: Add update fields from request body schema
}
`;
  c.push({
    path: `apps/${a}-web/src/features/${i}/types/${s}.ts`,
    content: h,
    type: "types"
  });
  const f = `import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { ${r}, ${r}ListParams, ${r}CreateInput, ${r}UpdateInput } from '../types/${s}';

const API_BASE = process.env.NEXT_PUBLIC_API_URL || '';

// Query keys
export const ${s}Keys = {
  all: ['${i}'] as const,
  lists: () => [...${s}Keys.all, 'list'] as const,
  list: (params: ${r}ListParams) => [...${s}Keys.lists(), params] as const,
  details: () => [...${s}Keys.all, 'detail'] as const,
  detail: (id: string) => [...${s}Keys.details(), id] as const,
};

${p ? `// List ${i}
export function use${r}List(params: ${r}ListParams = {}) {
  return useQuery({
    queryKey: ${s}Keys.list(params),
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) searchParams.set(key, String(value));
      });
      const res = await fetch(\`\${API_BASE}/${i}?\${searchParams}\`);
      if (!res.ok) throw new Error('Failed to fetch ${i}');
      return res.json() as Promise<{ data: ${r}[]; total: number }>;
    },
  });
}` : ""}

${u ? `// Get single ${s}
export function use${r}(id: string) {
  return useQuery({
    queryKey: ${s}Keys.detail(id),
    queryFn: async () => {
      const res = await fetch(\`\${API_BASE}/${i}/\${id}\`);
      if (!res.ok) throw new Error('Failed to fetch ${s}');
      return res.json() as Promise<${r}>;
    },
    enabled: !!id,
  });
}` : ""}

${l ? `// Create ${s}
export function useCreate${r}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ${r}CreateInput) => {
      const res = await fetch(\`\${API_BASE}/${i}\`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error('Failed to create ${s}');
      return res.json() as Promise<${r}>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ${s}Keys.lists() });
    },
  });
}` : ""}

${m ? `// Update ${s}
export function useUpdate${r}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: ${r}UpdateInput }) => {
      const res = await fetch(\`\${API_BASE}/${i}/\${id}\`, {
        method: '${t.method}',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error('Failed to update ${s}');
      return res.json() as Promise<${r}>;
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ${s}Keys.detail(id) });
      queryClient.invalidateQueries({ queryKey: ${s}Keys.lists() });
    },
  });
}` : ""}

${g ? `// Delete ${s}
export function useDelete${r}() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const res = await fetch(\`\${API_BASE}/${i}/\${id}\`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete ${s}');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ${s}Keys.lists() });
    },
  });
}` : ""}
`;
  if (c.push({
    path: `apps/${a}-web/src/features/${i}/hooks/use${r}.ts`,
    content: f,
    type: "hooks"
  }), c.push({
    path: `apps/${a}-web/src/features/${i}/types/index.ts`,
    content: `export * from './${s}';
`,
    type: "index"
  }), c.push({
    path: `apps/${a}-web/src/features/${i}/hooks/index.ts`,
    content: `export * from './use${r}';
`,
    type: "index"
  }), c.push({
    path: `apps/${a}-web/src/features/${i}/index.ts`,
    content: `export * from './types';
export * from './hooks';
`,
    type: "index"
  }), o) {
    const y = `import { renderHook, waitFor } from '@testing-library/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { describe, it, expect, vi, beforeEach } from 'vitest';
import { use${r}List, use${r}, useCreate${r} } from './use${r}';

const createWrapper = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: false } },
  });
  return ({ children }: { children: React.ReactNode }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

describe('${r} Hooks', () => {
  beforeEach(() => {
    vi.clearAllMocks();
  });

  ${p ? `it('use${r}List fetches list data', async () => {
    global.fetch = vi.fn().mockResolvedValue({
      ok: true,
      json: () => Promise.resolve({ data: [], total: 0 }),
    });

    const { result } = renderHook(() => use${r}List(), {
      wrapper: createWrapper(),
    });

    await waitFor(() => expect(result.current.isSuccess).toBe(true));
    expect(result.current.data).toEqual({ data: [], total: 0 });
  });` : ""}

  ${u ? `it('use${r} fetches single item', async () => {
    const mock${r} = { id: '1', createdAt: '', updatedAt: '' };
    global.fetch = vi.fn().mockResolvedValue({
      ok: true,
      json: () => Promise.resolve(mock${r}),
    });

    const { result } = renderHook(() => use${r}('1'), {
      wrapper: createWrapper(),
    });

    await waitFor(() => expect(result.current.isSuccess).toBe(true));
    expect(result.current.data).toEqual(mock${r});
  });` : ""}
});
`;
    c.push({
      path: `apps/${a}-web/src/features/${i}/hooks/use${r}.test.tsx`,
      content: y,
      type: "test"
    });
  }
  const b = c.map((y) => `  ${y.path}`).join(`
`);
  return {
    files: c,
    structure: b,
    summary: `Generated ${c.length} files for ${r} feature from ${t.method} ${t.path}`
  };
}
function _a(e) {
  var I, S;
  const {
    entity: t,
    pluralEntity: a = `${t.toLowerCase()}s`,
    fields: o,
    apiBasePath: n = `/${a}`,
    features: s = {
      bulkActions: !0,
      search: !0,
      filters: !0,
      pagination: !0,
      sorting: !0,
      export: !1,
      import: !1
    },
    nextAppRouter: r = !0
  } = e, i = t.charAt(0).toUpperCase() + t.slice(1), c = t.toLowerCase(), p = [], u = o.filter((d) => d.showInList !== !1), l = o.filter((d) => d.showInDetail !== !1), m = o.filter((d) => d.showInForm !== !1), g = o.filter((d) => d.filterable), h = o.filter((d) => d.sortable);
  o.filter((d) => d.searchable);
  const f = `"use client";

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  DataTable,
  PageHeader,
  Button,
  Stack,
  Badge,
  ${s.search ? "Input," : ""}
  ${s.filters ? "SelectField," : ""}
  ${s.bulkActions ? "BulkActionBar," : ""}
  ${s.pagination ? "Pagination," : ""}
  LoadingState,
  ErrorState,
  EmptyState,
  toast,
} from '@org/design-system';
import { Plus, ${s.export ? "Download," : ""} ${s.import ? "Upload," : ""} Search } from 'lucide-react';
import { use${i}List, useDelete${i}${s.bulkActions ? `, useBulkDelete${i}s` : ""} } from '../hooks/use${i}';
import type { ${i} } from '../types/${c}';

interface ${i}ListProps {
  initialPage?: number;
  initialLimit?: number;
}

export function ${i}List({ initialPage = 1, initialLimit = 10 }: ${i}ListProps) {
  const router = useRouter();
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  ${s.search ? "const [search, setSearch] = useState('');" : ""}
  ${s.filters ? "const [filters, setFilters] = useState<Record<string, string>>({});" : ""}
  ${s.bulkActions ? "const [selectedIds, setSelectedIds] = useState<string[]>([]);" : ""}
  ${h.length > 0 ? `const [sortBy, setSortBy] = useState<string | undefined>();
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');` : ""}

  const { data, isLoading, error, refetch } = use${i}List({
    page,
    limit,
    ${s.search ? "search," : ""}
    ${h.length > 0 ? "sortBy, sortOrder," : ""}
    ${s.filters ? "...filters," : ""}
  });

  const deleteMutation = useDelete${i}();
  ${s.bulkActions ? `const bulkDeleteMutation = useBulkDelete${i}s();` : ""}

  const columns = [
    ${u.map((d) => `{
      key: '${d.name}',
      header: '${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}',
      ${d.sortable ? "sortable: true," : ""}
      ${d.type === "boolean" ? `cell: (row: ${i}) => <Badge variant={row.${d.name} ? 'green' : 'gray'}>{row.${d.name} ? 'Yes' : 'No'}</Badge>,` : ""}
      ${d.type === "date" || d.type === "datetime" ? `cell: (row: ${i}) => new Date(row.${d.name}).toLocaleDateString(),` : ""}
      ${d.type === "enum" ? `cell: (row: ${i}) => <Badge variant="outline">{row.${d.name}}</Badge>,` : ""}
    }`).join(`,
    `)}
  ];

  const handleRowClick = (row: ${i}) => {
    router.push(\`${n}/\${row.id}\`);
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteMutation.mutateAsync(id);
      toast.success('${i} deleted successfully');
    } catch (error) {
      toast.error('Failed to delete ${c}');
    }
  };

  ${s.bulkActions ? `const handleBulkDelete = async () => {
    try {
      await bulkDeleteMutation.mutateAsync(selectedIds);
      setSelectedIds([]);
      toast.success(\`\${selectedIds.length} ${a} deleted\`);
    } catch (error) {
      toast.error('Failed to delete ${a}');
    }
  };` : ""}

  if (isLoading) {
    return <LoadingState message="Loading ${a}..." />;
  }

  if (error) {
    return (
      <ErrorState
        title="Failed to load ${a}"
        description={error.message}
        action={{ label: 'Retry', onClick: () => refetch() }}
      />
    );
  }

  if (!data?.data?.length) {
    return (
      <EmptyState
        title="No ${a} found"
        description="Get started by creating your first ${c}."
        action={{ label: 'Create ${i}', onClick: () => router.push('${n}/new') }}
      />
    );
  }

  return (
    <Stack gap={6}>
      <PageHeader
        title="${i}s"
        description="Manage your ${a}"
        actions={
          <Button variant="primary" onClick={() => router.push('${n}/new')}>
            <Plus className="h-4 w-4 mr-2" />
            Add ${i}
          </Button>
        }
      />

      ${s.search || s.filters ? `<div className="flex gap-4 items-center">
        ${s.search ? `<div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search ${a}..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-9"
          />
        </div>` : ""}
        ${g.map((d) => {
    var k;
    return d.type === "enum" ? `<SelectField
          placeholder="Filter by ${d.label || d.name}"
          value={filters.${d.name} || ''}
          onChange={(value) => setFilters(prev => ({ ...prev, ${d.name}: value }))}
          options={[
            { label: 'All', value: '' },
            ${(k = d.enumValues) == null ? void 0 : k.map((w) => `{ label: '${w}', value: '${w}' }`).join(`,
            `)}
          ]}
        />` : "";
  }).join(`
        `)}
      </div>` : ""}

      ${s.bulkActions ? `{selectedIds.length > 0 && (
        <BulkActionBar
          selectedCount={selectedIds.length}
          onClearSelection={() => setSelectedIds([])}
          actions={[
            { label: 'Delete Selected', onClick: handleBulkDelete, variant: 'danger' },
          ]}
        />
      )}` : ""}

      <DataTable
        data={data.data}
        columns={columns}
        onRowClick={handleRowClick}
        ${s.bulkActions ? `selectable
        selectedIds={selectedIds}
        onSelectionChange={setSelectedIds}` : ""}
        ${h.length > 0 ? `sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={(key, order) => {
          setSortBy(key);
          setSortOrder(order);
        }}` : ""}
        actions={[
          { label: 'Edit', onClick: (row) => router.push(\`${n}/\${row.id}/edit\`) },
          { label: 'Delete', onClick: (row) => handleDelete(row.id), variant: 'danger' },
        ]}
      />

      ${s.pagination ? `<Pagination
        currentPage={page}
        totalPages={Math.ceil((data.total || 0) / limit)}
        onPageChange={setPage}
      />` : ""}
    </Stack>
  );
}

export default ${i}List;
`;
  p.push({
    path: `src/features/${a}/components/${i}List.tsx`,
    content: f,
    type: "list"
  });
  const b = `"use client";

import { useRouter } from 'next/navigation';
import {
  PageHeader,
  Card,
  Stack,
  Button,
  Badge,
  DescriptionList,
  LoadingState,
  ErrorState,
  ConfirmDestructive,
  toast,
} from '@org/design-system';
import { Edit, Trash2, ArrowLeft } from 'lucide-react';
import { use${i}, useDelete${i} } from '../hooks/use${i}';

interface ${i}DetailProps {
  id: string;
}

export function ${i}Detail({ id }: ${i}DetailProps) {
  const router = useRouter();
  const { data: ${c}, isLoading, error, refetch } = use${i}(id);
  const deleteMutation = useDelete${i}();

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(id);
      toast.success('${i} deleted successfully');
      router.push('${n}');
    } catch (error) {
      toast.error('Failed to delete ${c}');
    }
  };

  if (isLoading) {
    return <LoadingState message="Loading ${c}..." />;
  }

  if (error) {
    return (
      <ErrorState
        title="Failed to load ${c}"
        description={error.message}
        action={{ label: 'Retry', onClick: () => refetch() }}
      />
    );
  }

  if (!${c}) {
    return (
      <ErrorState
        title="${i} not found"
        description="The ${c} you're looking for doesn't exist."
        action={{ label: 'Go Back', onClick: () => router.push('${n}') }}
      />
    );
  }

  const items = [
    ${l.map((d) => `{
      label: '${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}',
      value: ${d.type === "boolean" ? `<Badge variant={${c}.${d.name} ? 'green' : 'gray'}>{${c}.${d.name} ? 'Yes' : 'No'}</Badge>` : d.type === "date" || d.type === "datetime" ? `new Date(${c}.${d.name}).toLocaleDateString()` : d.type === "enum" ? `<Badge variant="outline">{${c}.${d.name}}</Badge>` : `${c}.${d.name}`},
    }`).join(`,
    `)}
  ];

  return (
    <Stack gap={6}>
      <PageHeader
        title={${c}.${((I = o.find((d) => d.name === "name" || d.name === "title")) == null ? void 0 : I.name) || "id"} || '${i} Details'}
        breadcrumbs={[
          { label: '${i}s', href: '${n}' },
          { label: 'Details' },
        ]}
        actions={
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => router.push('${n}')}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
            <Button variant="outline" onClick={() => router.push(\`${n}/\${id}/edit\`)}>
              <Edit className="h-4 w-4 mr-2" />
              Edit
            </Button>
            <ConfirmDestructive
              title="Delete ${i}"
              description="Are you sure you want to delete this ${c}? This action cannot be undone."
              confirmText="delete"
              onConfirm={handleDelete}
              trigger={
                <Button variant="danger">
                  <Trash2 className="h-4 w-4 mr-2" />
                  Delete
                </Button>
              }
            />
          </div>
        }
      />

      <Card>
        <DescriptionList items={items} />
      </Card>
    </Stack>
  );
}

export default ${i}Detail;
`;
  p.push({
    path: `src/features/${a}/components/${i}Detail.tsx`,
    content: b,
    type: "detail"
  });
  const y = `"use client";

import { useRouter } from 'next/navigation';
import {
  PageHeader,
  Card,
  Stack,
  Button,
  SmartForm,
  TextField,
  SelectField,
  TextareaField,
  SwitchField,
  toast,
} from '@org/design-system';
import { ArrowLeft, Save } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCreate${i} } from '../hooks/use${i}';
import { create${i}Schema, type Create${i}Input } from '../types/${c}';

export function ${i}Create() {
  const router = useRouter();
  const createMutation = useCreate${i}();

  const form = useForm<Create${i}Input>({
    resolver: zodResolver(create${i}Schema),
    defaultValues: {
      ${m.map((d) => d.type === "boolean" ? `${d.name}: false,` : d.type === "number" ? `${d.name}: 0,` : `${d.name}: '',`).join(`
      `)}
    },
  });

  const onSubmit = async (data: Create${i}Input) => {
    try {
      const result = await createMutation.mutateAsync(data);
      toast.success('${i} created successfully');
      router.push(\`${n}/\${result.id}\`);
    } catch (error) {
      toast.error('Failed to create ${c}');
    }
  };

  return (
    <Stack gap={6}>
      <PageHeader
        title="Create ${i}"
        breadcrumbs={[
          { label: '${i}s', href: '${n}' },
          { label: 'Create' },
        ]}
        actions={
          <Button variant="outline" onClick={() => router.push('${n}')}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Cancel
          </Button>
        }
      />

      <Card>
        <SmartForm form={form} onSubmit={onSubmit}>
          <Stack gap={4}>
            ${m.map((d) => {
    var k;
    return d.type === "boolean" ? `<SwitchField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
            />` : d.type === "enum" ? `<SelectField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
              options={[
                ${(k = d.enumValues) == null ? void 0 : k.map((w) => `{ label: '${w}', value: '${w}' }`).join(`,
                `)}
              ]}
              ${d.required ? "required" : ""}
            />` : d.type === "text" ? `<TextareaField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
              ${d.required ? "required" : ""}
            />` : `<TextField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              type="${d.type === "email" ? "email" : d.type === "number" ? "number" : d.type === "date" ? "date" : "text"}"
              control={form.control}
              ${d.required ? "required" : ""}
            />`;
  }).join(`
            `)}

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Button variant="outline" type="button" onClick={() => router.push('${n}')}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={createMutation.isPending}>
                <Save className="h-4 w-4 mr-2" />
                {createMutation.isPending ? 'Creating...' : 'Create ${i}'}
              </Button>
            </div>
          </Stack>
        </SmartForm>
      </Card>
    </Stack>
  );
}

export default ${i}Create;
`;
  p.push({
    path: `src/features/${a}/components/${i}Create.tsx`,
    content: y,
    type: "create"
  });
  const $ = `"use client";

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import {
  PageHeader,
  Card,
  Stack,
  Button,
  SmartForm,
  TextField,
  SelectField,
  TextareaField,
  SwitchField,
  LoadingState,
  ErrorState,
  toast,
} from '@org/design-system';
import { ArrowLeft, Save } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { use${i}, useUpdate${i} } from '../hooks/use${i}';
import { update${i}Schema, type Update${i}Input } from '../types/${c}';

interface ${i}EditProps {
  id: string;
}

export function ${i}Edit({ id }: ${i}EditProps) {
  const router = useRouter();
  const { data: ${c}, isLoading, error, refetch } = use${i}(id);
  const updateMutation = useUpdate${i}();

  const form = useForm<Update${i}Input>({
    resolver: zodResolver(update${i}Schema),
  });

  useEffect(() => {
    if (${c}) {
      form.reset({
        ${m.map((d) => `${d.name}: ${c}.${d.name},`).join(`
        `)}
      });
    }
  }, [${c}, form]);

  const onSubmit = async (data: Update${i}Input) => {
    try {
      await updateMutation.mutateAsync({ id, data });
      toast.success('${i} updated successfully');
      router.push(\`${n}/\${id}\`);
    } catch (error) {
      toast.error('Failed to update ${c}');
    }
  };

  if (isLoading) {
    return <LoadingState message="Loading ${c}..." />;
  }

  if (error) {
    return (
      <ErrorState
        title="Failed to load ${c}"
        description={error.message}
        action={{ label: 'Retry', onClick: () => refetch() }}
      />
    );
  }

  if (!${c}) {
    return (
      <ErrorState
        title="${i} not found"
        description="The ${c} you're trying to edit doesn't exist."
        action={{ label: 'Go Back', onClick: () => router.push('${n}') }}
      />
    );
  }

  return (
    <Stack gap={6}>
      <PageHeader
        title="Edit ${i}"
        breadcrumbs={[
          { label: '${i}s', href: '${n}' },
          { label: ${c}.${((S = o.find((d) => d.name === "name" || d.name === "title")) == null ? void 0 : S.name) || "id"} || 'Details', href: \`${n}/\${id}\` },
          { label: 'Edit' },
        ]}
        actions={
          <Button variant="outline" onClick={() => router.push(\`${n}/\${id}\`)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Cancel
          </Button>
        }
      />

      <Card>
        <SmartForm form={form} onSubmit={onSubmit}>
          <Stack gap={4}>
            ${m.map((d) => {
    var k;
    return d.type === "boolean" ? `<SwitchField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
            />` : d.type === "enum" ? `<SelectField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
              options={[
                ${(k = d.enumValues) == null ? void 0 : k.map((w) => `{ label: '${w}', value: '${w}' }`).join(`,
                `)}
              ]}
            />` : d.type === "text" ? `<TextareaField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              control={form.control}
            />` : `<TextField
              name="${d.name}"
              label="${d.label || d.name.charAt(0).toUpperCase() + d.name.slice(1)}"
              type="${d.type === "email" ? "email" : d.type === "number" ? "number" : d.type === "date" ? "date" : "text"}"
              control={form.control}
            />`;
  }).join(`
            `)}

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Button variant="outline" type="button" onClick={() => router.push(\`${n}/\${id}\`)}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={updateMutation.isPending}>
                <Save className="h-4 w-4 mr-2" />
                {updateMutation.isPending ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </Stack>
        </SmartForm>
      </Card>
    </Stack>
  );
}

export default ${i}Edit;
`;
  p.push({
    path: `src/features/${a}/components/${i}Edit.tsx`,
    content: $,
    type: "edit"
  });
  const C = `export { ${i}List } from './${i}List';
export { ${i}Detail } from './${i}Detail';
export { ${i}Create } from './${i}Create';
export { ${i}Edit } from './${i}Edit';
`;
  p.push({
    path: `src/features/${a}/components/index.ts`,
    content: C,
    type: "shared"
  });
  const P = p.map((d) => `  ${d.path}`).join(`
`);
  return {
    files: p,
    structure: P,
    summary: `Generated ${p.length} entity component files for ${i}: List, Detail, Create, Edit, and index.`
  };
}
function yt(e) {
  const {
    hookName: t,
    hookPath: a,
    entity: o,
    operations: n,
    apiBasePath: s = `/${o.toLowerCase()}s`
  } = e, r = o.charAt(0).toUpperCase() + o.slice(1), i = o.toLowerCase(), c = `${i}s`, p = [], u = `import { renderHook, waitFor, act } from '@testing-library/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { describe, it, expect, vi, beforeEach, afterEach } from 'vitest';
import {
  ${n.includes("list") ? `use${r}List,` : ""}
  ${n.includes("detail") ? `use${r},` : ""}
  ${n.includes("create") ? `useCreate${r},` : ""}
  ${n.includes("update") ? `useUpdate${r},` : ""}
  ${n.includes("delete") ? `useDelete${r},` : ""}
} from '${a}';

// Test utilities
const createWrapper = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        gcTime: 0,
      },
      mutations: {
        retry: false,
      },
    },
  });

  return function Wrapper({ children }: { children: React.ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    );
  };
};

// Mock data
const mock${r} = {
  id: '1',
  name: 'Test ${r}',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

const mock${r}List = {
  data: [mock${r}, { ...mock${r}, id: '2', name: 'Test ${r} 2' }],
  total: 2,
  page: 1,
  limit: 10,
};

describe('${t}', () => {
  beforeEach(() => {
    vi.clearAllMocks();
  });

  afterEach(() => {
    vi.restoreAllMocks();
  });

  ${n.includes("list") ? `describe('use${r}List', () => {
    it('should fetch ${c} list successfully', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve(mock${r}List),
      });

      const { result } = renderHook(() => use${r}List(), {
        wrapper: createWrapper(),
      });

      expect(result.current.isLoading).toBe(true);

      await waitFor(() => {
        expect(result.current.isSuccess).toBe(true);
      });

      expect(result.current.data).toEqual(mock${r}List);
      expect(global.fetch).toHaveBeenCalledWith(
        expect.stringContaining('${s}'),
        expect.any(Object)
      );
    });

    it('should handle fetch error', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: false,
        status: 500,
        statusText: 'Internal Server Error',
      });

      const { result } = renderHook(() => use${r}List(), {
        wrapper: createWrapper(),
      });

      await waitFor(() => {
        expect(result.current.isError).toBe(true);
      });

      expect(result.current.error).toBeDefined();
    });

    it('should support pagination params', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve(mock${r}List),
      });

      renderHook(() => use${r}List({ page: 2, limit: 20 }), {
        wrapper: createWrapper(),
      });

      await waitFor(() => {
        expect(global.fetch).toHaveBeenCalledWith(
          expect.stringContaining('page=2'),
          expect.any(Object)
        );
      });
    });
  });` : ""}

  ${n.includes("detail") ? `describe('use${r}', () => {
    it('should fetch single ${i} successfully', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve(mock${r}),
      });

      const { result } = renderHook(() => use${r}('1'), {
        wrapper: createWrapper(),
      });

      await waitFor(() => {
        expect(result.current.isSuccess).toBe(true);
      });

      expect(result.current.data).toEqual(mock${r});
      expect(global.fetch).toHaveBeenCalledWith(
        expect.stringContaining('${s}/1'),
        expect.any(Object)
      );
    });

    it('should not fetch when id is undefined', () => {
      const { result } = renderHook(() => use${r}(undefined as unknown as string), {
        wrapper: createWrapper(),
      });

      expect(result.current.isLoading).toBe(false);
      expect(result.current.isFetching).toBe(false);
    });

    it('should handle 404 error', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: false,
        status: 404,
        statusText: 'Not Found',
      });

      const { result } = renderHook(() => use${r}('nonexistent'), {
        wrapper: createWrapper(),
      });

      await waitFor(() => {
        expect(result.current.isError).toBe(true);
      });
    });
  });` : ""}

  ${n.includes("create") ? `describe('useCreate${r}', () => {
    it('should create ${i} successfully', async () => {
      const newData = { name: 'New ${r}' };
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve({ ...mock${r}, ...newData }),
      });

      const { result } = renderHook(() => useCreate${r}(), {
        wrapper: createWrapper(),
      });

      await act(async () => {
        await result.current.mutateAsync(newData);
      });

      expect(result.current.isSuccess).toBe(true);
      expect(global.fetch).toHaveBeenCalledWith(
        expect.stringContaining('${s}'),
        expect.objectContaining({
          method: 'POST',
          body: JSON.stringify(newData),
        })
      );
    });

    it('should handle validation error', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: false,
        status: 400,
        json: () => Promise.resolve({ errors: [{ field: 'name', message: 'Required' }] }),
      });

      const { result } = renderHook(() => useCreate${r}(), {
        wrapper: createWrapper(),
      });

      await act(async () => {
        try {
          await result.current.mutateAsync({});
        } catch (e) {
          // Expected error
        }
      });

      expect(result.current.isError).toBe(true);
    });
  });` : ""}

  ${n.includes("update") ? `describe('useUpdate${r}', () => {
    it('should update ${i} successfully', async () => {
      const updateData = { name: 'Updated ${r}' };
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve({ ...mock${r}, ...updateData }),
      });

      const { result } = renderHook(() => useUpdate${r}(), {
        wrapper: createWrapper(),
      });

      await act(async () => {
        await result.current.mutateAsync({ id: '1', data: updateData });
      });

      expect(result.current.isSuccess).toBe(true);
      expect(global.fetch).toHaveBeenCalledWith(
        expect.stringContaining('${s}/1'),
        expect.objectContaining({
          method: 'PATCH',
          body: JSON.stringify(updateData),
        })
      );
    });
  });` : ""}

  ${n.includes("delete") ? `describe('useDelete${r}', () => {
    it('should delete ${i} successfully', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: true,
        json: () => Promise.resolve({}),
      });

      const { result } = renderHook(() => useDelete${r}(), {
        wrapper: createWrapper(),
      });

      await act(async () => {
        await result.current.mutateAsync('1');
      });

      expect(result.current.isSuccess).toBe(true);
      expect(global.fetch).toHaveBeenCalledWith(
        expect.stringContaining('${s}/1'),
        expect.objectContaining({ method: 'DELETE' })
      );
    });

    it('should handle delete error', async () => {
      global.fetch = vi.fn().mockResolvedValue({
        ok: false,
        status: 403,
        statusText: 'Forbidden',
      });

      const { result } = renderHook(() => useDelete${r}(), {
        wrapper: createWrapper(),
      });

      await act(async () => {
        try {
          await result.current.mutateAsync('1');
        } catch (e) {
          // Expected error
        }
      });

      expect(result.current.isError).toBe(true);
    });
  });` : ""}
});
`;
  return p.push({
    path: `${a.replace(".ts", ".test.tsx").replace("./hooks/", "hooks/")}`,
    content: u,
    type: "unit"
  }), {
    files: p,
    summary: `Generated hook tests for ${t} with ${n.length} operations.`
  };
}
function ft(e) {
  var u;
  const {
    componentName: t,
    componentPath: a,
    props: o,
    interactions: n = [],
    mockData: s = {}
  } = e, r = [], i = o.filter((l) => l.required), c = o.filter((l) => !l.required), p = `import { render, screen, fireEvent, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { describe, it, expect, vi, beforeEach } from 'vitest';
import { ${t} } from '${a}';

// Mock dependencies
vi.mock('next/navigation', () => ({
  useRouter: () => ({
    push: vi.fn(),
    replace: vi.fn(),
    back: vi.fn(),
  }),
  usePathname: () => '/test',
  useParams: () => ({}),
}));

// Mock data
const mockProps = {
  ${o.map((l) => l.type === "string" ? `${l.name}: ${l.defaultValue ? `'${l.defaultValue}'` : `'Test ${l.name}'`},` : l.type === "number" ? `${l.name}: ${l.defaultValue ?? 0},` : l.type === "boolean" ? `${l.name}: ${l.defaultValue ?? !1},` : l.type === "function" ? `${l.name}: vi.fn(),` : l.type === "array" ? `${l.name}: [],` : l.type === "object" ? `${l.name}: {},` : `${l.name}: undefined,`).join(`
  `)}
};

describe('${t}', () => {
  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe('rendering', () => {
    it('should render without crashing', () => {
      render(<${t} {...mockProps} />);
      expect(document.body).toBeTruthy();
    });

    ${i.length > 0 ? `it('should render with required props', () => {
      const requiredProps = {
        ${i.map((l) => `${l.name}: mockProps.${l.name},`).join(`
        `)}
      };
      render(<${t} {...requiredProps} />);
      expect(document.body).toBeTruthy();
    });` : ""}

    ${c.map((l) => `it('should render with ${l.name} prop', () => {
      render(<${t} {...mockProps} ${l.name}={${l.type === "string" ? `'custom ${l.name}'` : l.type === "number" ? "42" : l.type === "boolean" ? "true" : "mockProps." + l.name}} />);
      expect(document.body).toBeTruthy();
    });`).join(`

    `)}
  });

  ${n.includes("click") ? `describe('click interactions', () => {
    it('should handle click events', async () => {
      const handleClick = vi.fn();
      render(<${t} {...mockProps} onClick={handleClick} />);

      const clickableElement = screen.getByRole('button') || screen.getByTestId('clickable');
      await userEvent.click(clickableElement);

      expect(handleClick).toHaveBeenCalledTimes(1);
    });
  });` : ""}

  ${n.includes("type") ? `describe('type interactions', () => {
    it('should handle text input', async () => {
      const handleChange = vi.fn();
      render(<${t} {...mockProps} onChange={handleChange} />);

      const input = screen.getByRole('textbox') || screen.getByTestId('input');
      await userEvent.type(input, 'test input');

      expect(handleChange).toHaveBeenCalled();
    });
  });` : ""}

  ${n.includes("hover") ? `describe('hover interactions', () => {
    it('should handle hover state', async () => {
      render(<${t} {...mockProps} />);

      const hoverableElement = screen.getByTestId('hoverable') || screen.getByRole('button');
      await userEvent.hover(hoverableElement);

      // Check for hover-specific changes (e.g., tooltip, style change)
      expect(document.body).toBeTruthy();
    });
  });` : ""}

  ${n.includes("submit") ? `describe('form submission', () => {
    it('should handle form submit', async () => {
      const handleSubmit = vi.fn((e) => e.preventDefault());
      render(<${t} {...mockProps} onSubmit={handleSubmit} />);

      const submitButton = screen.getByRole('button', { name: /submit/i }) || screen.getByType('submit');
      await userEvent.click(submitButton);

      expect(handleSubmit).toHaveBeenCalled();
    });
  });` : ""}

  describe('accessibility', () => {
    it('should have no accessibility violations', async () => {
      const { container } = render(<${t} {...mockProps} />);
      // Note: Add axe-core integration for full a11y testing
      expect(container).toBeTruthy();
    });

    it('should be keyboard navigable', async () => {
      render(<${t} {...mockProps} />);

      const focusableElements = document.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length > 0) {
        await userEvent.tab();
        expect(document.activeElement).toBe(focusableElements[0]);
      }
    });
  });

  describe('edge cases', () => {
    it('should handle empty/null props gracefully', () => {
      const minimalProps = {
        ${i.map((l) => `${l.name}: mockProps.${l.name},`).join(`
        `)}
      };
      expect(() => render(<${t} {...minimalProps} />)).not.toThrow();
    });

    it('should handle rapid prop changes', async () => {
      const { rerender } = render(<${t} {...mockProps} />);

      for (let i = 0; i < 10; i++) {
        rerender(<${t} {...mockProps} ${(u = o[0]) != null && u.name ? `${o[0].name}={'value-${o[0].type === "string" ? "${i}" : ""}'}` : ""} />);
      }

      expect(document.body).toBeTruthy();
    });
  });
});
`;
  return r.push({
    path: `${a.replace(".tsx", ".test.tsx")}`,
    content: p,
    type: "unit"
  }), {
    files: r,
    summary: `Generated component tests for ${t} with ${n.length} interaction types.`
  };
}
function ht(e) {
  const {
    feature: t,
    entity: a,
    routes: o,
    baseUrl: n = "http://localhost:3000"
  } = e, s = a.charAt(0).toUpperCase() + a.slice(1), r = a.toLowerCase(), i = `${r}s`, c = [], p = `import { test, expect, Page } from '@playwright/test';

/**
 * E2E Tests for ${t}
 *
 * Prerequisites:
 * - App running at ${n}
 * - Test database seeded
 */

// Test data
const test${s} = {
  name: 'E2E Test ${s}',
  description: 'Created by E2E test',
};

// Page objects
class ${s}Page {
  constructor(private page: Page) {}

  async goto(path: string = '/${i}') {
    await this.page.goto(\`${n}\${path}\`);
  }

  async waitForLoad() {
    await this.page.waitForLoadState('networkidle');
  }

  // List page
  async getListItems() {
    return this.page.locator('[data-testid="${r}-row"]').all();
  }

  async searchFor(query: string) {
    await this.page.fill('[data-testid="search-input"]', query);
    await this.page.waitForTimeout(300); // debounce
  }

  async clickCreate() {
    await this.page.click('[data-testid="create-${r}-btn"]');
  }

  // Form page
  async fillForm(data: Record<string, string>) {
    for (const [field, value] of Object.entries(data)) {
      const input = this.page.locator(\`[name="\${field}"]\`);
      await input.fill(value);
    }
  }

  async submitForm() {
    await this.page.click('[type="submit"]');
  }

  // Detail page
  async clickEdit() {
    await this.page.click('[data-testid="edit-btn"]');
  }

  async clickDelete() {
    await this.page.click('[data-testid="delete-btn"]');
  }

  async confirmDelete() {
    await this.page.fill('[data-testid="confirm-input"]', 'delete');
    await this.page.click('[data-testid="confirm-delete-btn"]');
  }
}

test.describe('${t}', () => {
  let ${r}Page: ${s}Page;

  test.beforeEach(async ({ page }) => {
    ${r}Page = new ${s}Page(page);
  });

  ${o.map((l) => `test.describe('${l.name}', () => {
    test.beforeEach(async () => {
      await ${r}Page.goto('${l.path}');
      await ${r}Page.waitForLoad();
    });

    ${l.actions.includes("view") ? `test('should display page correctly', async ({ page }) => {
      await expect(page).toHaveTitle(/${s}/i);
      await expect(page.locator('h1')).toBeVisible();
    });` : ""}

    ${l.actions.includes("list") ? `test('should display ${i} list', async ({ page }) => {
      const items = await ${r}Page.getListItems();
      expect(items.length).toBeGreaterThanOrEqual(0);
    });

    test('should search ${i}', async ({ page }) => {
      await ${r}Page.searchFor('test');
      await page.waitForTimeout(500);
      // Verify search results or empty state
      const content = await page.textContent('body');
      expect(content).toBeTruthy();
    });` : ""}

    ${l.actions.includes("create") ? `test('should create new ${r}', async ({ page }) => {
      await ${r}Page.fillForm(test${s});
      await ${r}Page.submitForm();

      // Should redirect to detail or list page
      await page.waitForURL(/${i}/);
      await expect(page.locator('.toast-success, [role="alert"]')).toBeVisible();
    });

    test('should show validation errors', async ({ page }) => {
      await ${r}Page.submitForm();
      await expect(page.locator('.error-message, [role="alert"]')).toBeVisible();
    });` : ""}

    ${l.actions.includes("edit") ? `test('should edit ${r}', async ({ page }) => {
      await ${r}Page.fillForm({ name: 'Updated Name' });
      await ${r}Page.submitForm();

      await expect(page.locator('.toast-success, [role="alert"]')).toBeVisible();
    });` : ""}

    ${l.actions.includes("delete") ? `test('should delete ${r}', async ({ page }) => {
      await ${r}Page.clickDelete();
      await ${r}Page.confirmDelete();

      // Should redirect to list
      await page.waitForURL(/${i}$/);
      await expect(page.locator('.toast-success, [role="alert"]')).toBeVisible();
    });` : ""}
  });`).join(`

  `)}

  test.describe('navigation', () => {
    test('should navigate between pages', async ({ page }) => {
      await ${r}Page.goto();
      await ${r}Page.waitForLoad();

      // Click on first item if exists
      const firstItem = page.locator('[data-testid="${r}-row"]').first();
      if (await firstItem.isVisible()) {
        await firstItem.click();
        await page.waitForURL(/${i}\\/[^/]+/);
      }
    });

    test('should use breadcrumbs', async ({ page }) => {
      await ${r}Page.goto('/${i}/new');
      await page.waitForLoadState('networkidle');

      const breadcrumb = page.locator('[data-testid="breadcrumbs"] a').first();
      if (await breadcrumb.isVisible()) {
        await breadcrumb.click();
        await page.waitForURL(/${i}/);
      }
    });
  });

  test.describe('accessibility', () => {
    test('should have proper heading structure', async ({ page }) => {
      await ${r}Page.goto();
      await ${r}Page.waitForLoad();

      const h1 = await page.locator('h1').count();
      expect(h1).toBe(1);
    });

    test('should be keyboard navigable', async ({ page }) => {
      await ${r}Page.goto();
      await ${r}Page.waitForLoad();

      await page.keyboard.press('Tab');
      const focused = await page.evaluate(() => document.activeElement?.tagName);
      expect(focused).toBeTruthy();
    });

    test('should have proper ARIA labels', async ({ page }) => {
      await ${r}Page.goto();
      await ${r}Page.waitForLoad();

      const buttonsWithoutLabel = await page.locator('button:not([aria-label]):not(:has-text(*))').count();
      expect(buttonsWithoutLabel).toBe(0);
    });
  });

  test.describe('error handling', () => {
    test('should handle 404 pages', async ({ page }) => {
      await page.goto(\`${n}/${i}/nonexistent-id\`);
      await page.waitForLoadState('networkidle');

      await expect(page.locator('text=/not found/i')).toBeVisible();
    });

    test('should handle network errors gracefully', async ({ page }) => {
      // Simulate offline
      await page.route('**/api/**', route => route.abort());

      await ${r}Page.goto();
      await page.waitForTimeout(1000);

      // Should show error state
      await expect(page.locator('[data-testid="error-state"], text=/error/i')).toBeVisible();
    });
  });
});
`;
  c.push({
    path: `e2e/${t}.spec.ts`,
    content: p,
    type: "e2e"
  });
  const u = `// Add to playwright.config.ts projects array:
{
  name: '${t}',
  testMatch: '${t}.spec.ts',
  use: {
    baseURL: '${n}',
  },
},
`;
  return c.push({
    path: `e2e/${t}.config.snippet.ts`,
    content: u,
    type: "setup"
  }), {
    files: c,
    summary: `Generated E2E tests for ${t} with ${o.length} route tests.`
  };
}
function La(e) {
  var m;
  const {
    entity: t,
    hookPath: a,
    componentPaths: o,
    operations: n,
    generateE2E: s = !0,
    apiBasePath: r
  } = e, i = t.charAt(0).toUpperCase() + t.slice(1), c = `${t.toLowerCase()}s`, p = [], u = yt({
    hookName: `use${i}`,
    hookPath: a,
    entity: t,
    operations: n,
    apiBasePath: r
  });
  p.push(...u.files);
  for (const g of o) {
    const h = ((m = g.split("/").pop()) == null ? void 0 : m.replace(".tsx", "")) || "Component", f = h.includes("Create") || h.includes("Edit"), b = h.includes("List"), y = ft({
      componentName: h,
      componentPath: g,
      props: [
        { name: "id", type: "string", required: !b && !h.includes("Create") }
      ],
      interactions: f ? ["click", "type", "submit"] : b ? ["click"] : ["click"]
    });
    p.push(...y.files);
  }
  if (s) {
    const g = ht({
      feature: c,
      entity: t,
      routes: [
        { path: `/${c}`, name: "List Page", actions: ["view", "list"] },
        { path: `/${c}/new`, name: "Create Page", actions: ["view", "create"] },
        { path: `/${c}/[id]`, name: "Detail Page", actions: ["view", "delete"] },
        { path: `/${c}/[id]/edit`, name: "Edit Page", actions: ["view", "edit"] }
      ]
    });
    p.push(...g.files);
  }
  const l = `// Test setup for ${t} feature
import '@testing-library/jest-dom/vitest';
import { vi } from 'vitest';

// Mock next/navigation
vi.mock('next/navigation', () => ({
  useRouter: () => ({
    push: vi.fn(),
    replace: vi.fn(),
    back: vi.fn(),
    prefetch: vi.fn(),
  }),
  usePathname: () => '/',
  useParams: () => ({}),
  useSearchParams: () => new URLSearchParams(),
}));

// Mock environment variables
process.env.NEXT_PUBLIC_API_URL = 'http://localhost:3000/api';

// Global fetch mock helper
export const mockFetch = (response: unknown, ok = true) => {
  global.fetch = vi.fn().mockResolvedValue({
    ok,
    json: () => Promise.resolve(response),
    text: () => Promise.resolve(JSON.stringify(response)),
    status: ok ? 200 : 500,
  });
};

// Reset all mocks after each test
afterEach(() => {
  vi.clearAllMocks();
});
`;
  return p.push({
    path: `src/features/${c}/__tests__/setup.ts`,
    content: l,
    type: "setup"
  }), {
    files: p,
    summary: `Generated complete test suite for ${i}: ${p.filter((g) => g.type === "unit").length} unit tests, ${p.filter((g) => g.type === "e2e").length} E2E tests, ${p.filter((g) => g.type === "setup").length} setup files.`
  };
}
function bt(e) {
  const { code: t } = e, a = [], o = [], n = [], s = {}, { components: r } = Le(), i = /* @__PURE__ */ new Set();
  Object.values(r).forEach((m) => m.forEach((g) => i.add(g)));
  const c = /import\s*\{([^}]+)\}\s*from\s*['"]@org\/design-system['"]/g;
  let p;
  for (; (p = c.exec(t)) !== null; ) {
    const m = p[1].split(",").map((g) => g.trim().split(" as ")[0].trim());
    for (const g of m)
      if (g)
        if (i.has(g))
          o.push(g);
        else {
          const h = g.toLowerCase();
          let f = !1;
          for (const b of i)
            if (b.toLowerCase() === h) {
              n.push(g), s[g] = b, a.push({
                type: "error",
                rule: "invalid-import",
                message: `'${g}' is not exported from @org/design-system`,
                suggestion: `Did you mean '${b}'?`,
                autoFixable: !0
              }), f = !0;
              break;
            }
          f || ([
            "useForm",
            "useToast",
            "toast",
            "cn",
            "cva",
            "ThemeProvider",
            "PresetProvider",
            "useTheme",
            "usePreset"
          ].includes(g) ? o.push(g) : (n.push(g), a.push({
            type: "error",
            rule: "invalid-import",
            message: `'${g}' is not exported from @org/design-system`,
            suggestion: "Check component-manifest.json for available exports"
          })));
        }
  }
  const u = {
    Box: "Stack or div with className",
    Flex: 'Stack with direction="horizontal" or Inline',
    Text: "Typography components (Heading, Paragraph, etc.)"
  };
  for (const [m, g] of Object.entries(u))
    o.includes(m) && a.push({
      type: "warning",
      rule: "deprecated-import",
      message: `'${m}' is deprecated`,
      suggestion: `Use ${g} instead`
    });
  const l = [
    { pattern: /<Button\s/g, component: "Button" },
    { pattern: /<Card\s/g, component: "Card" },
    { pattern: /<Input\s/g, component: "Input" },
    { pattern: /<Badge\s/g, component: "Badge" },
    { pattern: /<Stack\s/g, component: "Stack" },
    { pattern: /<DataTable\s/g, component: "DataTable" },
    { pattern: /<PageHeader\s/g, component: "PageHeader" },
    { pattern: /toast\.(success|error|info)/g, component: "toast" }
  ];
  for (const { pattern: m, component: g } of l)
    m.test(t) && !o.includes(g) && a.push({
      type: "error",
      rule: "missing-import",
      message: `'${g}' is used but not imported`,
      suggestion: `Add '${g}' to your @org/design-system import`,
      autoFixable: !0
    });
  return {
    valid: a.filter((m) => m.type === "error").length === 0,
    issues: a,
    summary: {
      errors: a.filter((m) => m.type === "error").length,
      warnings: a.filter((m) => m.type === "warning").length,
      info: a.filter((m) => m.type === "info").length
    },
    imports: {
      valid: o,
      invalid: n,
      suggestions: s
    }
  };
}
function Fa(e) {
  const { files: t, strictMode: a = !1 } = e, o = [], n = [];
  for (const s of t) {
    const r = [];
    if (!s.path.match(/\.(tsx|jsx)$/)) {
      n.push({ path: s.path, valid: !0, issues: [] });
      continue;
    }
    if (s.path.includes(".test.") || s.path.includes(".spec.") || s.path.includes("__tests__")) {
      n.push({ path: s.path, valid: !0, issues: [] });
      continue;
    }
    const i = bt({ code: s.content });
    r.push(...i.issues.map((l) => ({ ...l, rule: `${s.path}: ${l.rule}` })));
    const c = $t({ code: s.content });
    a ? r.push(...c.issues.map((l) => ({ ...l, type: "error" }))) : r.push(...c.issues);
    const p = [
      { pattern: /<button\s+className=/gi, message: "Raw <button> with className", suggestion: "Use <Button> from @org/design-system" },
      { pattern: /<input\s+className=/gi, message: "Raw <input> with className", suggestion: "Use <Input> or <TextField> from @org/design-system" },
      { pattern: /<select\s+/gi, message: "Raw <select> element", suggestion: "Use <SelectField> from @org/design-system" },
      { pattern: /<textarea\s+/gi, message: "Raw <textarea> element", suggestion: "Use <TextareaField> from @org/design-system" },
      { pattern: /<table\s+className=/gi, message: "Raw <table> with className", suggestion: "Use <DataTable> from @org/design-system" },
      { pattern: /<form\s+className=/gi, message: "Raw <form> with className", suggestion: "Use <Form> or <SmartForm> from @org/design-system" }
    ];
    for (const { pattern: l, message: m, suggestion: g } of p)
      l.test(s.content) && r.push({
        type: "error",
        rule: "no-raw-html",
        message: m,
        suggestion: g
      });
    const u = [
      { pattern: /<span\s+className="[^"]*rounded-full[^"]*bg-/gi, message: "DIY badge pattern", suggestion: "Use <Badge> from @org/design-system" },
      { pattern: /<div\s+className="[^"]*fixed[^"]*inset-0[^"]*z-/gi, message: "DIY modal pattern", suggestion: "Use <Dialog> from @org/design-system" },
      { pattern: /<Loader2.*animate-spin/gi, message: "DIY loading spinner", suggestion: "Use <LoadingState> or <Spinner> from @org/design-system" },
      { pattern: /variant="destructive"/gi, message: "shadcn/ui variant syntax", suggestion: 'Use variant="danger" for design system' }
    ];
    for (const { pattern: l, message: m, suggestion: g } of u)
      l.test(s.content) && r.push({
        type: "error",
        rule: "no-diy-patterns",
        message: m,
        suggestion: g
      });
    /className="[^"]*\[#[0-9a-fA-F]{3,8}\]/gi.test(s.content) && r.push({
      type: a ? "error" : "warning",
      rule: "no-hardcoded-colors",
      message: "Hardcoded hex color in className",
      suggestion: "Use semantic color classes or CSS variables"
    }), (/from ['"]@shadcn/gi.test(s.content) || /from ['"]shadcn/gi.test(s.content)) && r.push({
      type: "error",
      rule: "no-direct-shadcn-import",
      message: "Direct import from shadcn/ui",
      suggestion: "Import from @org/design-system instead"
    }), /from ['"]@radix-ui/gi.test(s.content) && r.push({
      type: a ? "error" : "warning",
      rule: "no-direct-radix-import",
      message: "Direct import from @radix-ui",
      suggestion: "Use design system components which wrap Radix"
    }), o.push(...r), n.push({
      path: s.path,
      valid: r.filter((l) => l.type === "error").length === 0,
      issues: r
    });
  }
  return {
    valid: o.filter((s) => s.type === "error").length === 0,
    issues: o,
    summary: {
      errors: o.filter((s) => s.type === "error").length,
      warnings: o.filter((s) => s.type === "warning").length,
      info: o.filter((s) => s.type === "info").length
    },
    fileResults: n
  };
}
function $t(e) {
  const { code: t, strict: a = !1 } = e, o = [], n = [];
  /<img(?![^>]*alt=)[^>]*>/gi.test(t) && (o.push({
    type: "error",
    rule: "img-alt",
    message: "Image missing alt attribute",
    suggestion: 'Add alt="description" or alt="" for decorative images'
  }), n.push({
    issue: "Image without alt text",
    fix: 'Add alt attribute describing the image, or alt="" for decorative images',
    wcagLevel: "A",
    priority: "critical"
  }));
  const r = /<Button[^>]*>[\s]*<[^/][^>]*\/?>[\s]*<\/Button>/gi, i = /<Button[^>]*>\s*<\w+Icon[^>]*\/?>\s*<\/Button>/gi;
  (r.test(t) || i.test(t)) && (o.push({
    type: "warning",
    rule: "button-text",
    message: "Button may lack accessible text",
    suggestion: "Add aria-label or visible text to buttons with only icons"
  }), n.push({
    issue: "Icon-only button without accessible label",
    fix: 'Add aria-label="Action description" or <VisuallyHidden>Text</VisuallyHidden>',
    wcagLevel: "A",
    priority: "serious"
  })), /<Input[^>]*(?!.*label)[^>]*\/>/gi.test(t) && (o.push({
    type: "warning",
    rule: "form-label",
    message: "Input may be missing associated label",
    suggestion: "Use TextField component which includes label, or add aria-label"
  }), n.push({
    issue: "Form input without visible label",
    fix: "Use TextField component or add aria-label/aria-labelledby",
    wcagLevel: "A",
    priority: "serious"
  }));
  const p = [
    /text-red-\d+(?![^"]*(?:sr-only|aria-label))/gi,
    /text-green-\d+(?![^"]*(?:sr-only|aria-label))/gi,
    /bg-red-\d+(?![^"]*(?:sr-only|aria-label|icon))/gi,
    /bg-green-\d+(?![^"]*(?:sr-only|aria-label|icon))/gi
  ];
  for (const f of p)
    if (f.test(t)) {
      o.push({
        type: "warning",
        rule: "color-contrast",
        message: "Status may rely on color alone",
        suggestion: "Add icon or text in addition to color for status indicators"
      }), n.push({
        issue: "Color used as only visual indicator",
        fix: "Add icon, text, or pattern to convey meaning beyond color",
        wcagLevel: "A",
        priority: "serious"
      });
      break;
    }
  const l = (t.match(/<h[1-6][^>]*>/gi) || []).map((f) => parseInt(f.charAt(2)));
  for (let f = 1; f < l.length; f++)
    if (l[f] > l[f - 1] + 1) {
      o.push({
        type: "warning",
        rule: "heading-order",
        message: "Heading levels should not skip",
        suggestion: `Found h${l[f]} after h${l[f - 1]}`
      }), n.push({
        issue: "Skipped heading level",
        fix: "Ensure heading levels are sequential (h1 → h2 → h3)",
        wcagLevel: "A",
        priority: "moderate"
      });
      break;
    }
  const m = /<a[^>]*>\s*<\/a>/gi, g = /<Link[^>]*>\s*<\w+Icon[^>]*\/?>\s*<\/Link>/gi;
  if ((m.test(t) || g.test(t)) && (o.push({
    type: "error",
    rule: "link-text",
    message: "Link is missing accessible text",
    suggestion: "Add visible text or aria-label to links"
  }), n.push({
    issue: "Link without accessible text",
    fix: "Add descriptive text or aria-label to links",
    wcagLevel: "A",
    priority: "critical"
  })), a) {
    const b = [
      /focus:ring/gi,
      /focus:outline/gi,
      /focus-visible/gi,
      /focus:border/gi
    ].some(($) => $.test(t));
    /<(Button|Input|Select|Link|a\s)/gi.test(t) && !b && (o.push({
      type: "warning",
      rule: "focus-visible",
      message: "Interactive elements should have visible focus styles",
      suggestion: "Design system components include focus styles by default"
    }), n.push({
      issue: "Missing visible focus indicators",
      fix: "Use design system components which include proper focus styles",
      wcagLevel: "AA",
      priority: "serious"
    }));
  }
  return (/<video[^>]*autoplay/gi.test(t) || /<audio[^>]*autoplay/gi.test(t)) && (o.push({
    type: "warning",
    rule: "no-autoplay",
    message: "Autoplaying media can be disruptive",
    suggestion: "Allow users to control media playback"
  }), n.push({
    issue: "Autoplaying media",
    fix: "Remove autoplay or ensure media is muted and has controls",
    wcagLevel: "A",
    priority: "moderate"
  })), /<table/gi.test(t) && !/<th/gi.test(t) && (o.push({
    type: "warning",
    rule: "table-headers",
    message: "Data tables should have header cells",
    suggestion: "Use <th> elements for header cells, or use DataTable component"
  }), n.push({
    issue: "Table without header cells",
    fix: "Add <th> elements or use DataTable component",
    wcagLevel: "A",
    priority: "serious"
  })), /<div[^>]*onClick/gi.test(t) && (o.push({
    type: "warning",
    rule: "interactive-elements",
    message: "onClick on div may not be keyboard accessible",
    suggestion: 'Use <button> or add role="button" with keyboard handlers'
  }), n.push({
    issue: "Click handler on non-interactive element",
    fix: 'Use <Button> component or add role="button" tabIndex={0} onKeyDown handler',
    wcagLevel: "A",
    priority: "serious"
  })), {
    valid: o.filter((f) => f.type === "error").length === 0,
    issues: o,
    summary: {
      errors: o.filter((f) => f.type === "error").length,
      warnings: o.filter((f) => f.type === "warning").length,
      info: o.filter((f) => f.type === "info").length
    },
    suggestions: n
  };
}
function Na(e, t) {
  const a = [], o = [], n = [], s = /import\s*(?:\{([^}]*)\}|(\w+))\s*from\s*['"]([^'"]+)['"]/g;
  let r;
  for (; (r = s.exec(e)) !== null; ) {
    const i = r[1], c = r[2], p = r[3];
    if (i) {
      const u = i.split(",").map((l) => l.trim().split(" as ")[0].trim()).filter(Boolean);
      for (const l of u) {
        const m = l.startsWith("use") ? "hook" : /^[A-Z]/.test(l) ? "component" : "utility";
        a.push({ name: l, type: m, from: p }), p === "@org/design-system" || p.startsWith("@org/design-system/") ? o.push(l) : !p.startsWith(".") && !p.startsWith("@/") && n.push(`${l} from ${p}`);
      }
    }
    c && (a.push({
      name: c,
      type: "component",
      from: p
    }), !p.startsWith(".") && !p.startsWith("@/") && n.push(`${c} from ${p}`));
  }
  return {
    component: t || "Unknown",
    dependencies: a,
    designSystemDeps: [...new Set(o)].sort(),
    externalDeps: [...new Set(n)].sort(),
    circularDeps: [],
    // Would require full project analysis
    depth: 1
    // Would require recursive analysis
  };
}
function qa(e) {
  const { componentName: t, props: a, children: o } = e, n = Fe(t);
  if (!n)
    return `// Component '${t}' not found in design system`;
  const s = Object.entries(a).filter(([i, c]) => c != null).map(([i, c]) => typeof c == "string" ? `${i}="${c}"` : typeof c == "boolean" ? c ? i : "" : typeof c == "number" ? `${i}={${c}}` : typeof c == "function" ? `${i}={() => { /* handler */ }}` : `${i}={${JSON.stringify(c)}}`).filter(Boolean).join(`
    `), r = o ? `<${t}
    ${s}
  >
    ${o}
  </${t}>` : `<${t}
    ${s}
  />`;
  return `// Preview for ${t}
// Category: ${n.category}
// Description: ${n.description}

import { ${t} } from '@org/design-system';

${r}
`;
}
function Ba(e) {
  const {
    spec: t,
    baseUrl: a = "",
    includeDelay: o = !0,
    delayRange: n = [100, 500],
    generateTypes: s = !0,
    includeErrorScenarios: r = !0
  } = e, i = [], c = [], p = [], u = /* @__PURE__ */ new Set(), l = t.paths || {};
  for (const [$, C] of Object.entries(l))
    if (!(!C || typeof C != "object"))
      for (const P of ["get", "post", "put", "patch", "delete"]) {
        const I = C[P];
        if (!I || typeof I != "object") continue;
        const S = I, d = vt($, S.tags);
        u.add(d);
        const k = wt(P, $), w = kt(d, k);
        i.push({
          method: P.toUpperCase(),
          path: $,
          handlerName: w,
          entity: d,
          operation: k
        });
        const x = St({
          method: P,
          path: `${a}${$}`,
          handlerName: w,
          entity: d,
          operation: k,
          includeDelay: o,
          delayRange: n,
          responses: S.responses
        });
        c.push(x);
      }
  Array.from(u).forEach(($) => {
    p.push(xt($));
  });
  const m = Ct(o), g = Pt(i.map(($) => $.handlerName));
  let h = "";
  r && (h = It(i, a));
  const f = `${m}

// ============================================
// MSW Handlers - Generated from OpenAPI Spec
// ============================================

${c.join(`

`)}

${h}

${g}
`, b = `/**
 * Mock Data Factories
 *
 * Use these to generate test data for your MSW handlers.
 * Generated from OpenAPI spec.
 */

import { faker } from '@faker-js/faker';

${p.join(`

`)}
`, y = Tt();
  return {
    code: f,
    handlers: i,
    factoryCode: b,
    setupCode: y,
    summary: `Generated ${i.length} MSW handlers for ${u.size} entities`
  };
}
function vt(e, t) {
  if (t && t.length > 0)
    return t[0].replace(/s$/, "");
  const a = e.split("/").filter((s) => s && !s.startsWith("{") && !s.startsWith(":")), n = (a[a.length - 1] || "Resource").replace(/s$/, "");
  return n.charAt(0).toUpperCase() + n.slice(1);
}
function wt(e, t) {
  const a = t.includes("{") || t.includes(":id");
  switch (e) {
    case "get":
      return a ? "get" : "list";
    case "post":
      return "create";
    case "put":
    case "patch":
      return "update";
    case "delete":
      return "delete";
    default:
      return "get";
  }
}
function kt(e, t, a) {
  return `${t === "list" ? "getAll" : t}${e}${t === "list" ? "s" : ""}Handler`;
}
function St(e) {
  const { method: t, path: a, handlerName: o, entity: n, operation: s, includeDelay: r, delayRange: i } = e, c = a.replace(/{(\w+)}/g, ":$1"), p = r ? `
    await delay(${i[0]}, ${i[1]});` : "";
  switch (s) {
    case "list":
      return `export const ${o} = http.${t}('${c}', async ({ request }) => {${p}
  const url = new URL(request.url);
  const page = parseInt(url.searchParams.get('page') || '1');
  const limit = parseInt(url.searchParams.get('limit') || '10');
  const search = url.searchParams.get('search') || '';

  let items = generate${n}List(50);

  // Apply search filter
  if (search) {
    items = items.filter(item =>
      JSON.stringify(item).toLowerCase().includes(search.toLowerCase())
    );
  }

  // Apply pagination
  const start = (page - 1) * limit;
  const paginatedItems = items.slice(start, start + limit);

  return HttpResponse.json({
    data: paginatedItems,
    meta: {
      total: items.length,
      page,
      limit,
      totalPages: Math.ceil(items.length / limit),
    },
  });
});`;
    case "get":
      return `export const ${o} = http.${t}('${c}', async ({ params }) => {${p}
  const { id } = params;
  const item = create${n}({ id: id as string });

  if (!item) {
    return HttpResponse.json(
      { error: '${n} not found' },
      { status: 404 }
    );
  }

  return HttpResponse.json({ data: item });
});`;
    case "create":
      return `export const ${o} = http.${t}('${c}', async ({ request }) => {${p}
  const body = await request.json();
  const new${n} = create${n}({ ...body as object, id: crypto.randomUUID() });

  return HttpResponse.json(
    { data: new${n}, message: '${n} created successfully' },
    { status: 201 }
  );
});`;
    case "update":
      return `export const ${o} = http.${t}('${c}', async ({ params, request }) => {${p}
  const { id } = params;
  const body = await request.json();
  const updated${n} = create${n}({ ...body as object, id: id as string });

  return HttpResponse.json({
    data: updated${n},
    message: '${n} updated successfully',
  });
});`;
    case "delete":
      return `export const ${o} = http.${t}('${c}', async ({ params }) => {${p}
  const { id } = params;

  return HttpResponse.json({
    message: '${n} deleted successfully',
    id,
  });
});`;
    default:
      return "";
  }
}
function xt(e) {
  return e.toLowerCase(), `/**
 * Create a single ${e}
 */
export function create${e}(overrides: Partial<${e}> = {}): ${e} {
  return {
    id: faker.string.uuid(),
    name: faker.person.fullName(),
    email: faker.internet.email(),
    status: faker.helpers.arrayElement(['active', 'inactive', 'pending']),
    createdAt: faker.date.past().toISOString(),
    updatedAt: faker.date.recent().toISOString(),
    ...overrides,
  };
}

/**
 * Generate a list of ${e}s
 */
export function generate${e}List(count: number = 10): ${e}[] {
  return Array.from({ length: count }, () => create${e}());
}

export interface ${e} {
  id: string;
  name: string;
  email: string;
  status: 'active' | 'inactive' | 'pending';
  createdAt: string;
  updatedAt: string;
  [key: string]: unknown;
}`;
}
function Ct(e) {
  return `import { http, HttpResponse${e ? ", delay" : ""} } from 'msw';`;
}
function Pt(e) {
  return `// Export all handlers for use in test setup
export const handlers = [
  ${e.join(`,
  `)},
];`;
}
function It(e, t) {
  const a = [];
  for (const o of e) {
    const n = `${t}${o.path}`.replace(/{(\w+)}/g, ":$1"), s = `${o.handlerName}Error`;
    a.push(`
/**
 * Error scenario for ${o.handlerName}
 * Use this to test error handling in your components
 */
export const ${s} = http.${o.method.toLowerCase()}('${n}', () => {
  return HttpResponse.json(
    { error: 'Internal server error', message: 'Something went wrong' },
    { status: 500 }
  );
});`);
  }
  return `// ============================================
// Error Scenario Handlers
// ============================================
${a.join(`
`)}`;
}
function Tt(e) {
  return `/**
 * MSW Setup for Tests
 *
 * Add this to your test setup file (e.g., src/test/setup.ts)
 */

import { setupServer } from 'msw/node';
import { handlers } from './handlers';

export const server = setupServer(...handlers);

// Setup before all tests
beforeAll(() => server.listen({ onUnhandledRequest: 'error' }));

// Reset handlers after each test
afterEach(() => server.resetHandlers());

// Clean up after all tests
afterAll(() => server.close());

/**
 * Usage in tests:
 *
 * import { server } from './setup';
 * import { getUserHandlerError } from './handlers';
 *
 * test('handles error state', async () => {
 *   server.use(getUserHandlerError);
 *   // ... your test
 * });
 */
`;
}
const At = {
  button: [
    />\s*(Submit|Cancel|Save|Delete|Edit|Create|Update|Add|Remove|Close|Back|Next|Previous|Continue|Confirm|Apply|Reset|Clear|Search|Filter|Export|Import|Download|Upload|Refresh|Retry|Send|Copy|Share|Print)\s*</gi,
    />\s*(Sign\s*(?:in|out|up)|Log\s*(?:in|out)|Get\s*Started|Learn\s*More|View\s*(?:All|More|Details)|Show\s*(?:More|Less))\s*</gi
  ],
  label: [
    /label=["']([^"']+)["']/gi,
    /aria-label=["']([^"']+)["']/gi,
    /<Label[^>]*>([^<]+)<\/Label>/gi
  ],
  placeholder: [
    /placeholder=["']([^"']+)["']/gi
  ],
  title: [
    /title=["']([^"']+)["']/gi,
    /<PageHeader[^>]*title=["']([^"']+)["']/gi,
    /<(h[1-6])[^>]*>([^<]+)<\/\1>/gi,
    /<Typography[^>]*variant=["']h[1-6]["'][^>]*>([^<]+)<\/Typography>/gi
  ],
  description: [
    /description=["']([^"']+)["']/gi,
    /<PageHeader[^>]*description=["']([^"']+)["']/gi,
    /<(p)[^>]*className="[^"]*text-muted[^"]*"[^>]*>([^<]+)<\/\1>/gi
  ],
  message: [
    />\s*(Loading\.\.\.|Please\s+wait|No\s+(?:data|results|items)\s+found|Something\s+went\s+wrong|Error\s+occurred)\s*</gi,
    /toast\.\w+\(["']([^"']+)["']/gi,
    /<Alert[^>]*>([^<]+)<\/Alert>/gi
  ],
  error: [
    /error(?:Message)?=["']([^"']+)["']/gi,
    /<ErrorState[^>]*message=["']([^"']+)["']/gi,
    /message:\s*["']([^"']+["'].*(?:required|invalid|must|cannot|should))/gi
  ],
  validation: [
    /\.min\(\d+,\s*["']([^"']+)["']\)/gi,
    /\.max\(\d+,\s*["']([^"']+)["']\)/gi,
    /\.email\(["']([^"']+)["']\)/gi,
    /\.required\(["']([^"']+)["']\)/gi,
    /message:\s*["']([^"']+)["']/gi
  ]
};
function Ra(e) {
  const {
    code: t,
    componentName: a = "Component",
    namespace: o = "common",
    defaultLanguage: n = "en",
    useComponentNamespace: s = !0,
    keyPrefix: r = ""
  } = e, i = [], c = /* @__PURE__ */ new Set();
  for (const [m, g] of Object.entries(At))
    for (const h of g) {
      const f = Array.from(t.matchAll(h));
      for (const b of f) {
        const y = b[1] || b[2] || b[0].replace(/<[^>]+>/g, "").trim();
        if (!y || c.has(y.toLowerCase())) continue;
        c.add(y.toLowerCase());
        const $ = Et(y, m, o, s ? a : void 0, r);
        i.push({
          key: $,
          defaultValue: y,
          source: b[0].substring(0, 50) + (b[0].length > 50 ? "..." : ""),
          category: m
        });
      }
    }
  const p = Dt(i), u = Lt(i, o, a), l = Ft(i, o, a);
  return {
    keys: i,
    translationJson: p,
    typeDefinitions: u,
    hookCode: l,
    summary: `Extracted ${i.length} i18n keys from ${a}`
  };
}
function Et(e, t, a, o, n) {
  const s = e.toLowerCase().replace(/[^a-z0-9\s]/gi, "").replace(/\s+/g, "_").substring(0, 30), r = [a];
  return o && r.push(o.toLowerCase().replace(/([A-Z])/g, "_$1").replace(/^_/, "")), r.push(t), n && r.push(n), r.push(s), r.join(".");
}
function Dt(e, t, a) {
  const o = {};
  for (const n of e)
    _t(o, n.key, n.defaultValue);
  return JSON.stringify(o, null, 2);
}
function _t(e, t, a) {
  const o = t.split(".");
  let n = e;
  for (let s = 0; s < o.length - 1; s++) {
    const r = o[s];
    (!n[r] || typeof n[r] != "object") && (n[r] = {}), n = n[r];
  }
  n[o[o.length - 1]] = a;
}
function Lt(e, t, a) {
  const o = e.map((n) => `  '${n.key}': string;`).join(`
`);
  return `/**
 * i18n Key Types for ${a}
 *
 * Auto-generated type definitions for type-safe translations.
 */

export interface ${a}TranslationKeys {
${o}
}

export type ${a}TranslationKey = keyof ${a}TranslationKeys;
`;
}
function Ft(e, t, a) {
  var s;
  const o = {};
  for (const r of e)
    o[r.category] || (o[r.category] = []), o[r.category].push(r);
  const n = Object.entries(o).map(([r, i]) => {
    const c = i.slice(0, 2).map((p) => `t('${p.key}')`).join(", ");
    return `  // ${r}: ${c}`;
  }).join(`
`);
  return `/**
 * i18n Hook for ${a}
 *
 * Use this hook to get translated strings for ${a}.
 */

import { useTranslation } from 'react-i18next';

export function use${a}Translations() {
  const { t, i18n } = useTranslation('${t}');

  return {
    t,
    // Usage examples:
${n}
  };
}

/**
 * Example usage in component:
 *
 * function ${a}() {
 *   const { t } = use${a}Translations();
 *
 *   return (
 *     <Button>{t('${((s = e[0]) == null ? void 0 : s.key) || "common.buttons.submit"}')}</Button>
 *   );
 * }
 */
`;
}
function ja(e) {
  const {
    languages: t,
    defaultLanguage: a,
    namespaces: o,
    defaultNamespace: n,
    useSuspense: s = !0,
    backend: r = "http"
  } = e;
  return {
    configCode: `/**
 * i18n Configuration
 *
 * Internationalization setup using react-i18next.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
${r === "http" ? "import HttpBackend from 'i18next-http-backend';" : ""}
import LanguageDetector from 'i18next-browser-languagedetector';

export const supportedLanguages = ${JSON.stringify(t)} as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const namespaces = ${JSON.stringify(o)} as const;
export type Namespace = typeof namespaces[number];

i18n
${r === "http" ? "  .use(HttpBackend)" : ""}
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: '${a}',
    supportedLngs: supportedLanguages,
    defaultNS: '${n}',
    ns: namespaces,
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: ${s},
    },

${r === "http" ? `    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
` : ""}
  });

export default i18n;
`,
    providerCode: `/**
 * i18n Provider
 *
 * Wrap your app with this provider to enable translations.
 */

'use client';

import { ReactNode, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { LoadingState } from '@org/design-system';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<LoadingState message="Loading translations..." />}>
        {children}
      </Suspense>
    </I18nextProvider>
  );
}
`,
    exampleNamespaceCode: `{
  "buttons": {
    "submit": "Submit",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create New"
  },
  "labels": {
    "name": "Name",
    "email": "Email",
    "status": "Status",
    "createdAt": "Created At"
  },
  "messages": {
    "loading": "Loading...",
    "noData": "No data found",
    "error": "Something went wrong",
    "success": "Operation successful"
  },
  "validation": {
    "required": "This field is required",
    "email": "Please enter a valid email",
    "minLength": "Must be at least {{min}} characters",
    "maxLength": "Must be at most {{max}} characters"
  }
}`,
    summary: `Generated i18n config for ${t.length} languages and ${o.length} namespaces`
  };
}
const _ = {
  page: /^page\.(tsx|jsx|ts|js)$/,
  layout: /^layout\.(tsx|jsx|ts|js)$/,
  loading: /^loading\.(tsx|jsx|ts|js)$/,
  error: /^error\.(tsx|jsx|ts|js)$/,
  route: /^route\.(tsx|ts)$/,
  default: /^default\.(tsx|jsx|ts|js)$/
};
function Ma(e) {
  var u;
  const {
    files: t,
    appDir: a = "src/app",
    strictMode: o = !1
  } = e, n = [], s = [], r = t.filter((l) => l.path.includes(a) || l.path.includes("/app/")), i = /* @__PURE__ */ new Map();
  for (const l of r) {
    const m = l.path.substring(0, l.path.lastIndexOf("/")), g = l.path.substring(l.path.lastIndexOf("/") + 1);
    i.has(m) || i.set(m, []), i.get(m).push({ ...l, filename: g });
  }
  for (const [l, m] of Array.from(i.entries())) {
    const g = Nt(l, a), h = g.includes("["), f = qt(g), b = /\([^)]+\)/.test(g), y = b ? (u = g.match(/\(([^)]+)\)/)) == null ? void 0 : u[1] : void 0, $ = g.includes("@"), C = g.includes("(.)") || g.includes("(..)"), P = m.some((v) => _.page.test(v.filename)), I = m.some((v) => _.layout.test(v.filename)), S = m.some((v) => _.loading.test(v.filename)), d = m.some((v) => _.error.test(v.filename)), k = m.some((v) => _.route.test(v.filename)), w = m.some((v) => _.default.test(v.filename));
    let x = "page";
    k ? x = "route" : I && !P && (x = "layout"), s.push({
      path: g,
      type: x,
      isDynamic: h,
      params: f,
      isRouteGroup: b,
      routeGroup: y,
      isParallelRoute: $,
      isInterceptedRoute: C
    });
    for (const v of m)
      _.layout.test(v.filename) && Bt(v, l, n, a), _.page.test(v.filename) && Rt(v, l, n, d, S, h, f), _.error.test(v.filename) && jt(v, n), _.loading.test(v.filename) && Mt(v, n), _.route.test(v.filename) && Ut(v, n);
    P && !d && n.push({
      path: l,
      type: "warning",
      rule: "error-boundary-present",
      message: `Page at ${g} has no error.tsx - errors will bubble up`,
      fix: "Create error.tsx using mcp__design-system__generate_error_boundaries"
    }), P && !S && n.push({
      path: l,
      type: "suggestion",
      rule: "loading-state-present",
      message: `Page at ${g} has no loading.tsx - consider adding for better UX`,
      fix: "Create loading.tsx using mcp__design-system__generate_loading_states"
    }), $ && !w && n.push({
      path: l,
      type: "warning",
      rule: "parallel-route-has-default",
      message: `Parallel route at ${g} has no default.tsx`,
      fix: "Create default.tsx to handle unmatched parallel routes"
    });
  }
  const c = n.filter((l) => l.type === "error" || o && l.type === "warning").length;
  return {
    valid: c === 0,
    issues: n,
    routes: s,
    summary: `Validated ${t.length} files, ${s.length} routes. ${c} error(s), ${n.filter((l) => l.type === "warning").length} warning(s), ${n.filter((l) => l.type === "suggestion").length} suggestion(s).`
  };
}
function Nt(e, t) {
  const a = e.indexOf(t.replace("src/", ""));
  if (a === -1) {
    const o = "app/", n = e.indexOf(o);
    return n !== -1 ? "/" + e.substring(n + o.length) : "/";
  }
  return "/" + e.substring(a + t.length + 1);
}
function qt(e) {
  const t = [], a = Array.from(e.matchAll(/\[([^\]]+)\]/g));
  for (const o of a)
    t.push(o[1].replace("...", ""));
  return t;
}
function Bt(e, t, a, o) {
  !e.content.includes("{children}") && !e.content.includes("{ children }") && a.push({
    path: e.path,
    type: "error",
    rule: "layout-wraps-children",
    message: "Layout must render {children}",
    fix: "Add {children} to the layout return statement"
  }), (t.endsWith(o) || t.endsWith("/app")) && (!e.content.includes("<html") || !e.content.includes("<body")) && a.push({
    path: e.path,
    type: "error",
    rule: "root-layout-has-html",
    message: "Root layout must have <html> and <body> tags",
    fix: "Wrap children with <html><body>{children}</body></html>"
  });
}
function Rt(e, t, a, o, n, s, r) {
  const i = /use(State|Effect|Ref|Callback|Memo|Context|Reducer)\s*\(/.test(e.content), c = e.content.includes("'use client'") || e.content.includes('"use client"');
  i && !c && a.push({
    path: e.path,
    type: "error",
    rule: "use-client-in-client-components",
    message: 'Page uses client hooks but missing "use client" directive',
    fix: 'Add "use client" at the top of the file'
  }), s && r.length > 0 && (e.content.includes("params") || r.some((u) => e.content.includes(u)) || a.push({
    path: e.path,
    type: "warning",
    rule: "dynamic-route-has-params",
    message: `Dynamic route has params [${r.join(", ")}] but they don't appear to be used`,
    fix: "Access params via the params prop in your component"
  })), (e.content.includes("export const metadata") || e.content.includes("export async function generateMetadata")) && c && a.push({
    path: e.path,
    type: "error",
    rule: "metadata-in-server-component",
    message: "Metadata exports cannot be in client components",
    fix: 'Remove "use client" or move metadata to a server component'
  });
}
function jt(e, t) {
  e.content.includes("'use client'") || e.content.includes('"use client"') || t.push({
    path: e.path,
    type: "error",
    rule: "use-client-in-client-components",
    message: "error.tsx must be a client component",
    fix: 'Add "use client" at the top of the file'
  }), !e.content.includes("ErrorState") && !e.content.includes("@org/design-system") && t.push({
    path: e.path,
    type: "suggestion",
    rule: "use-design-system",
    message: "Consider using <ErrorState /> from @org/design-system",
    fix: "Import and use ErrorState component"
  });
}
function Mt(e, t) {
  !e.content.includes("LoadingState") && !e.content.includes("Skeleton") && !e.content.includes("@org/design-system") && t.push({
    path: e.path,
    type: "suggestion",
    rule: "use-design-system",
    message: "Consider using <LoadingState /> or <Skeleton /> from @org/design-system",
    fix: "Import and use LoadingState or Skeleton component"
  });
}
function Ut(e, t) {
  /export\s+(async\s+)?function\s+(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS)/.test(e.content) || t.push({
    path: e.path,
    type: "warning",
    rule: "route-handler-exports",
    message: "Route handler should export at least one HTTP method (GET, POST, etc.)",
    fix: "Export async function GET/POST/etc."
  });
}
function Ua(e) {
  const t = [`# Route Structure
`], a = e.filter((n) => n.type === "page");
  e.filter((n) => n.type === "layout");
  const o = e.filter((n) => n.type === "route");
  if (a.length > 0) {
    t.push(`## Pages
`);
    for (const n of a) {
      const s = [
        n.isDynamic ? "🔄 dynamic" : "",
        n.isRouteGroup ? `📁 (${n.routeGroup})` : "",
        n.isParallelRoute ? "⚡ parallel" : "",
        n.isInterceptedRoute ? "🔀 intercepted" : ""
      ].filter(Boolean).join(" ");
      t.push(`- \`${n.path}\` ${s}`), n.params.length > 0 && t.push(`  - Params: ${n.params.join(", ")}`);
    }
    t.push("");
  }
  if (o.length > 0) {
    t.push(`## API Routes
`);
    for (const n of o)
      t.push(`- \`${n.path}\``);
    t.push("");
  }
  return t.join(`
`);
}
function Ha(e) {
  const {
    title: t,
    description: a,
    pageType: o,
    siteName: n,
    baseUrl: s,
    pagePath: r,
    image: i,
    author: c,
    publishedAt: p,
    modifiedAt: u,
    keywords: l = [],
    twitterHandle: m,
    locale: g = "en_US",
    openGraph: h = {},
    includeStructuredData: f = !0,
    includeCanonical: b = !0,
    noIndex: y = !1
  } = e, $ = `${s}${r}`, C = i || `${s}/og${r === "/" ? "/home" : r}.png`, P = Ht({
    title: t,
    description: a,
    pageType: o,
    siteName: n,
    canonicalUrl: $,
    ogImage: C,
    author: c,
    publishedAt: p,
    keywords: l,
    twitterHandle: m,
    locale: g,
    openGraph: h,
    includeCanonical: b,
    noIndex: y
  }), I = f ? Ot({
    pageType: o,
    title: t,
    description: a,
    canonicalUrl: $,
    siteName: n,
    ogImage: C,
    author: c,
    publishedAt: p,
    modifiedAt: u
  }) : "", S = y ? `Disallow: ${r}` : void 0, d = zt({
    url: $,
    lastModified: u || (/* @__PURE__ */ new Date()).toISOString(),
    priority: Gt(o),
    changeFrequency: Kt(o)
  });
  return {
    metadataCode: P,
    structuredData: I,
    robotsEntry: S,
    sitemapEntry: d,
    summary: `Generated SEO metadata for ${o} page: ${t}`
  };
}
function Ht(e) {
  const {
    title: t,
    description: a,
    pageType: o,
    siteName: n,
    canonicalUrl: s,
    ogImage: r,
    author: i,
    publishedAt: c,
    keywords: p,
    twitterHandle: u,
    locale: l,
    openGraph: m,
    includeCanonical: g,
    noIndex: h
  } = e, f = Wt(o), b = "summary_large_image", y = [
    "import type { Metadata } from 'next';",
    "",
    "export const metadata: Metadata = {",
    `  title: '${T(t)}',`,
    `  description: '${T(a)}',`
  ];
  p.length > 0 && y.push(`  keywords: [${p.map(($) => `'${T($)}'`).join(", ")}],`), i && y.push(`  authors: [{ name: '${T(i)}' }],`), h && y.push("  robots: { index: false, follow: false },"), g && (y.push("  alternates: {"), y.push(`    canonical: '${s}',`), y.push("  },")), y.push("  openGraph: {"), y.push(`    title: '${T(t)}',`), y.push(`    description: '${T(a)}',`), y.push(`    url: '${s}',`), y.push(`    siteName: '${T(n)}',`), y.push(`    locale: '${l}',`), y.push(`    type: '${f}',`), y.push("    images: ["), y.push("      {"), y.push(`        url: '${r}',`), y.push("        width: 1200,"), y.push("        height: 630,"), y.push(`        alt: '${T(t)}',`), y.push("      },"), y.push("    ],"), f === "article" && c && (y.push(`    publishedTime: '${c}',`), i && y.push(`    authors: ['${T(i)}'],`));
  for (const [$, C] of Object.entries(m))
    y.push(`    ${$}: '${T(C)}',`);
  return y.push("  },"), y.push("  twitter: {"), y.push(`    card: '${b}',`), y.push(`    title: '${T(t)}',`), y.push(`    description: '${T(a)}',`), y.push(`    images: ['${r}'],`), u && (y.push(`    creator: '@${u}',`), y.push(`    site: '@${u}',`)), y.push("  },"), y.push("};"), y.join(`
`);
}
function Ot(e) {
  const {
    pageType: t,
    title: a,
    description: o,
    canonicalUrl: n,
    siteName: s,
    ogImage: r,
    author: i,
    publishedAt: c,
    modifiedAt: p
  } = e;
  let u;
  switch (t) {
    case "article":
    case "blog":
      u = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: a,
        description: o,
        image: r,
        url: n,
        datePublished: c,
        dateModified: p || c,
        author: i ? {
          "@type": "Person",
          name: i
        } : void 0,
        publisher: {
          "@type": "Organization",
          name: s,
          logo: {
            "@type": "ImageObject",
            url: `${new URL(n).origin}/logo.png`
          }
        }
      };
      break;
    case "product":
      u = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: a,
        description: o,
        image: r,
        url: n
      };
      break;
    case "landing":
    case "about":
    default:
      u = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: a,
        description: o,
        url: n,
        isPartOf: {
          "@type": "WebSite",
          name: s,
          url: new URL(n).origin
        }
      };
  }
  const l = JSON.parse(JSON.stringify(u));
  return `<script type="application/ld+json">
${JSON.stringify(l, null, 2)}
<\/script>`;
}
function zt(e) {
  const { url: t, lastModified: a, priority: o, changeFrequency: n } = e;
  return `  {
    url: '${t}',
    lastModified: new Date('${a}'),
    changeFrequency: '${n}',
    priority: ${o},
  },`;
}
function Wt(e) {
  switch (e) {
    case "article":
    case "blog":
      return "article";
    case "product":
      return "product";
    default:
      return "website";
  }
}
function Gt(e) {
  switch (e) {
    case "landing":
      return 1;
    case "pricing":
      return 0.9;
    case "product":
      return 0.8;
    case "article":
    case "blog":
      return 0.7;
    case "about":
    case "contact":
      return 0.6;
    case "dashboard":
    case "auth":
      return 0.3;
    default:
      return 0.5;
  }
}
function Kt(e) {
  switch (e) {
    case "landing":
    case "pricing":
      return "weekly";
    case "blog":
    case "article":
      return "daily";
    case "product":
      return "weekly";
    default:
      return "monthly";
  }
}
function T(e) {
  return e.replace(/'/g, "\\'").replace(/"/g, '\\"');
}
function Oa(e) {
  const { baseUrl: t, staticPages: a, dynamicRoutes: o = [] } = e, n = a.map((r) => ({
    url: `${t}${r.path}`,
    lastModified: "new Date()",
    changeFrequency: r.changeFrequency || "monthly",
    priority: r.priority || 0.5
  }));
  let s = `import type { MetadataRoute } from 'next';

export default async function sitemap(): Promise<MetadataRoute.Sitemap> {
  const baseUrl = '${t}';

  // Static pages
  const staticPages: MetadataRoute.Sitemap = [
${n.map((r) => `    {
      url: '${r.url}',
      lastModified: ${r.lastModified},
      changeFrequency: '${r.changeFrequency}',
      priority: ${r.priority},
    },`).join(`
`)}
  ];
`;
  for (const r of o)
    s += `
  // Dynamic pages: ${r.pattern}
  const ${r.fetchFunctionName.replace("fetch", "").toLowerCase()}Items = await ${r.fetchFunctionName}();
  const ${r.fetchFunctionName.replace("fetch", "").toLowerCase()}Pages = ${r.fetchFunctionName.replace("fetch", "").toLowerCase()}Items.map((item) => ({
    url: \`\${baseUrl}${r.pattern.replace("[slug]", "${item.slug}").replace("[id]", "${item.id}")}\`,
    lastModified: item.updatedAt || new Date(),
    changeFrequency: '${r.changeFrequency || "weekly"}' as const,
    priority: ${r.priority || 0.7},
  }));
`;
  return s += `
  return [
    ...staticPages,
${o.map((r) => `    ...${r.fetchFunctionName.replace("fetch", "").toLowerCase()}Pages,`).join(`
`)}
  ];
}
`, s;
}
function za(e) {
  const { baseUrl: t, disallowPaths: a = ["/dashboard/", "/api/", "/admin/"], rules: o = [] } = e;
  return `import type { MetadataRoute } from 'next';

export default function robots(): MetadataRoute.Robots {
  return {
    rules: [
      {
        userAgent: '*',
        allow: '/',
        disallow: [${a.map((s) => `'${s}'`).join(", ")}],
      },
${o.map((s) => `      {
        userAgent: '${s.userAgent}',
        ${s.allow ? `allow: [${s.allow.map((r) => `'${r}'`).join(", ")}],` : ""}
        ${s.disallow ? `disallow: [${s.disallow.map((r) => `'${r}'`).join(", ")}],` : ""}
      },`).join(`
`)}
    ],
    sitemap: '${t}/sitemap.xml',
  };
}
`;
}
const Ce = { components: {} };
try {
  const e = require("../../../component-manifest.json");
  Object.assign(Ce, e);
} catch {
}
const fe = {
  atoms: { base: 500, perProp: 50 },
  molecules: { base: 1500, perProp: 80 },
  organisms: { base: 3e3, perProp: 100 },
  patterns: { base: 5e3, perProp: 150 },
  primitives: { base: 300, perProp: 30 },
  intents: { base: 4e3, perProp: 120 },
  content: { base: 2e3, perProp: 100 },
  motion: { base: 1e3, perProp: 50 }
}, he = {
  DataTable: 15e3,
  RichTextEditor: 5e4,
  MarkdownRenderer: 25e3,
  CommandPalette: 8e3,
  Dialog: 3e3,
  Drawer: 3500,
  DatePicker: 12e3,
  Calendar: 1e4,
  ChartLine: 2e4,
  ChartBar: 18e3,
  ChartPie: 15e3,
  ChartArea: 18e3,
  Combobox: 5e3,
  NotificationCenter: 6e3
}, Vt = {
  "@radix-ui/react-dialog": 4e3,
  "@radix-ui/react-dropdown-menu": 5e3,
  "@radix-ui/react-tabs": 3e3,
  "@radix-ui/react-tooltip": 3e3,
  "@radix-ui/react-select": 5e3,
  "@radix-ui/react-popover": 4e3,
  "@radix-ui/react-accordion": 3e3,
  "@tanstack/react-table": 15e3,
  "react-hook-form": 1e4,
  recharts: 45e3,
  "@tiptap/react": 4e4,
  "date-fns": 8e3,
  cmdk: 4e3,
  "lucide-react": 1e3
  // Per icon, tree-shaken
}, Qt = {
  Dialog: ["@radix-ui/react-dialog"],
  Drawer: ["@radix-ui/react-dialog"],
  DropdownMenu: ["@radix-ui/react-dropdown-menu"],
  Tabs: ["@radix-ui/react-tabs"],
  Tooltip: ["@radix-ui/react-tooltip"],
  Select: ["@radix-ui/react-select"],
  SelectField: ["@radix-ui/react-select"],
  Popover: ["@radix-ui/react-popover"],
  Accordion: ["@radix-ui/react-accordion"],
  DataTable: ["@tanstack/react-table"],
  SmartForm: ["react-hook-form"],
  Form: ["react-hook-form"],
  ChartLine: ["recharts"],
  ChartBar: ["recharts"],
  ChartPie: ["recharts"],
  ChartArea: ["recharts"],
  Sparkline: ["recharts"],
  RichTextEditor: ["@tiptap/react"],
  DatePicker: ["date-fns"],
  DateField: ["date-fns"],
  Calendar: ["date-fns"],
  CommandPalette: ["cmdk"]
};
function Jt(e) {
  const {
    components: t,
    includeDependencies: a = !0,
    environment: o = "production",
    includeTreeShaking: n = !0
  } = e, s = [], r = /* @__PURE__ */ new Set();
  let i = 0, c = 0;
  const p = [];
  for (const m of t) {
    const g = Yt(m, a);
    s.push(g), i += g.estimatedSize, c += g.estimatedGzipSize;
    for (const h of g.dependencies)
      r.add(h);
    g.optimizationTips && p.push(...g.optimizationTips);
  }
  a && Array.from(r).forEach((m) => {
    const g = Vt[m] || 0;
    c += g, i += g * 2.5;
  });
  let u;
  if (n) {
    const m = i * 0.3;
    u = Math.round(m);
  }
  if (s.some((m) => m.isHeavy)) {
    const m = s.filter((g) => g.isHeavy).map((g) => g.name);
    p.push(
      `Heavy components detected (${m.join(", ")}). Consider lazy loading these with React.lazy() or next/dynamic.`
    );
  }
  r.has("recharts") && p.push(
    "Charts add ~45KB gzipped. Consider using Sparkline for simple metrics instead of full charts."
  ), r.has("@tiptap/react") && p.push(
    "RichTextEditor adds ~40KB gzipped. Only import if rich text editing is essential."
  ), t.length > 10 && p.push(
    `Importing ${t.length} components. Consider code splitting by feature to reduce initial bundle.`
  ), o === "production" && p.push(
    "Enable Next.js production build optimizations: next build with NODE_ENV=production"
  );
  const l = (m) => m < 1024 ? `${m} B` : m < 1024 * 1024 ? `${(m / 1024).toFixed(1)} KB` : `${(m / (1024 * 1024)).toFixed(2)} MB`;
  return {
    components: s,
    totalSize: i,
    totalGzipSize: c,
    uniqueDependencies: Array.from(r),
    treeShakingSavings: u,
    recommendations: [...new Set(p)],
    // Dedupe
    summary: `Importing ${t.length} components: ~${l(i)} minified, ~${l(c)} gzipped${u ? ` (tree-shaking may save ~${l(u)})` : ""}`
  };
}
function Yt(e, t) {
  const a = Ce.components[e], o = (a == null ? void 0 : a.category) || "patterns", n = Object.keys((a == null ? void 0 : a.props) || {}).length;
  let s;
  if (he[e])
    s = he[e];
  else {
    const u = fe[o] || fe.patterns;
    s = u.base + n * u.perProp;
  }
  const r = Math.round(s * 0.4), i = t ? Qt[e] || [] : [], c = s > 1e4 || i.some(
    (u) => ["recharts", "@tiptap/react", "@tanstack/react-table"].includes(u)
  ), p = [];
  return e === "DataTable" && n > 5 && p.push(
    "DataTable: Use column virtualization for large datasets (>1000 rows)"
  ), e.includes("Chart") && p.push(
    `${e}: Consider using server-side rendering for static charts`
  ), e === "RichTextEditor" && p.push(
    "RichTextEditor: Load only required extensions to reduce bundle size"
  ), {
    name: e,
    estimatedSize: s,
    estimatedGzipSize: r,
    dependencies: i,
    category: o,
    isHeavy: c,
    optimizationTips: p.length > 0 ? p : void 0
  };
}
function Wa(e) {
  const t = Jt({ components: e, includeDependencies: !0 }), a = (o) => o < 1024 ? `${o} B` : o < 1024 * 1024 ? `${(o / 1024).toFixed(1)} KB` : `${(o / (1024 * 1024)).toFixed(2)} MB`;
  return {
    minified: a(t.totalSize),
    gzipped: a(t.totalGzipSize),
    heavy: t.components.filter((o) => o.isHeavy).map((o) => o.name)
  };
}
function Ga(e) {
  const t = {
    DataTable: [
      { name: "Table (basic)", savings: "~12KB", tradeoffs: "No sorting, filtering, or pagination built-in" },
      { name: "Virtual list", savings: "~10KB", tradeoffs: "List-only, no table features" }
    ],
    RichTextEditor: [
      { name: "Textarea", savings: "~49KB", tradeoffs: "Plain text only, no formatting" },
      { name: "MarkdownEditor (lighter)", savings: "~25KB", tradeoffs: "Markdown syntax instead of WYSIWYG" }
    ],
    ChartLine: [
      { name: "Sparkline", savings: "~35KB", tradeoffs: "No axis labels, tooltips, or legends" },
      { name: "CSS-only bars", savings: "~44KB", tradeoffs: "Very basic, limited interactivity" }
    ],
    ChartBar: [
      { name: "Progress bars", savings: "~17KB", tradeoffs: "Single value comparison only" },
      { name: "Sparkline", savings: "~35KB", tradeoffs: "No axis labels or rich tooltips" }
    ],
    DatePicker: [
      { name: 'Input type="date"', savings: "~11KB", tradeoffs: "Browser-native UI, less customizable" }
    ],
    CommandPalette: [
      { name: "SearchInput + results", savings: "~5KB", tradeoffs: "Less keyboard navigation, no fuzzy search" }
    ]
  };
  return t[e] ? {
    current: e,
    alternatives: t[e]
  } : null;
}
export {
  Jt as analyzeBundleImpact,
  la as analyzeOpenAPISpec,
  ba as analyzedFieldsToCrudFields,
  wa as componentHasCapability,
  ua as detectPresetFromEndpoints,
  Ra as extractI18nKeys,
  oa as findComponentsByCapability,
  ia as findIntentsByGoal,
  fa as generateApiHooks,
  ra as generateAppScaffold,
  Aa as generateBreadcrumbConfig,
  Zt as generateComponentCode,
  ft as generateComponentTests,
  ha as generateCrudFeature,
  ht as generateE2ETests,
  _a as generateEntityComponents,
  Pa as generateErrorBoundary,
  Da as generateFeatureFromOpenAPIEndpoint,
  aa as generateFeatureScaffold,
  Xt as generateFormSchema,
  yt as generateHookTests,
  ja as generateI18nConfig,
  Ca as generateLoadingStates,
  Ba as generateMSWHandlers,
  ta as generatePageScaffold,
  za as generateRobotsFile,
  Ua as generateRouteOverview,
  Ha as generateSEOMetadata,
  Ia as generateSidebarConfig,
  Oa as generateSitemapFile,
  ea as generateStorybookStory,
  La as generateTestSuite,
  ga as generateTypesFromOpenAPI,
  ya as generateZodSchemas,
  Na as getComponentDependencies,
  Fe as getComponentInfo,
  va as getComponentPropSuggestions,
  na as getComponentsByCategory,
  Ne as getIntentComponentInfo,
  sa as getManifestMeta,
  Wa as getQuickBundleEstimate,
  ka as getRecommendedProps,
  ca as getRelatedIntents,
  Le as listComponents,
  ee as listIntentComponents,
  qa as previewComponentCode,
  $t as suggestAccessibilityFixes,
  da as suggestComponentsForEndpoint,
  pa as suggestIntentsForEntity,
  Ta as suggestIntentsForWorkflow,
  Ga as suggestLighterAlternatives,
  ma as suggestPageLayout,
  xa as validateBadge,
  Sa as validateButton,
  ie as validateComponentProps,
  Fa as validateDirectory,
  bt as validateImports,
  $a as validateMultipleComponents,
  Ea as validatePresetCompliance,
  Ma as validateRouteStructure
};
